/**
 * Catalogue FR (Q96) — AUCUN libellé métier codé en dur dans les composants.
 * L'ajout d'une langue = nouveau fichier conforme au type `MessageCatalog`.
 */

export const fr = {
  appExperience: {
    pdfText1:
      'Ce document dépasse 200 pages. Utilisez le téléchargement ou l’ouverture dans un onglet.',
    pdfText2: 'Lecture du PDF impossible.',
    pdfText3: 'Affichage de la page impossible.',
    pdfText4: 'Page précédente',
    pdfText5: 'Page',
    pdfText6: '/',
    pdfText7: 'Page suivante',
    pdfText8: 'Zoom',
    pdfText9: 'Zoom du PDF',
    pdfText10: '%',
    pdfText11: 'Réessayer l’affichage',
    pdfText12: 'Lire le texte de la page',
    text1: 'Froid et climatisation',
    text2: 'Relevés de température, machines et suivi des fluides.',
    text3: 'Température ambiante (°C)',
    text4: 'Température de soufflage (°C)',
    text5: 'Pression relevée (bar)',
    text6: 'État des échangeurs observé',
    text7: 'Évacuation des condensats vérifiée',
    text8: 'Références et charge de la machine relevées',
    text31: 'Relevé ajouté à l’historique de la machine.',
    text32: 'Mon métier',
    text33: 'Espaces métier',
    text34: 'Relevé sur une machine',
    text35:
      'Saisissez les mesures réellement effectuées. Ce carnet ne constitue pas une attestation de conformité.',
    text36: 'Machine',
    text37: 'Machine du relevé',
    text38: 'Choisir une machine',
    text39: 'Observations réalisées',
    text40: 'Voir la fiche',
    text41: 'Enregistrer le relevé',
    text42:
      'Votre rôle permet de consulter les fiches ; l’ajout de relevés nécessite une autorisation.',
    text52: 'Écart de température',
    text54: 'Température départ / ambiante (°C)',
    text56: 'Température retour / soufflage (°C)',
    text57: 'Renseignez les deux valeurs',
    text59:
      'Première température − seconde température. Aucune conclusion automatique sur l’état de l’installation.',
    // Espace métier en page de saisie v4 (vague 5).
    metier: {
      sousTitre: 'Activité de l’entreprise',
      chercher: 'Rechercher un client, un site ou une machine',
      aucuneMachine: 'Aucune machine ne correspond. Essayez le nom du client ou la marque.',
      huitPremieres: 'Les 8 premières sont affichées : précisez la recherche pour en trouver une autre.',
      client: 'Client',
      machine: 'Machine',
      autreMachine: 'Choisir une autre machine',
      contexte: 'Contexte du contrôle',
      contexteAide: 'Facultatif : ce qui permet de retrouver le point de mesure.',
      mesures: 'Mesures observées',
      mesuresAide: 'Saisissez les valeurs lues, avec une virgule si besoin.',
      nombre: 'Saisissez un nombre, par exemple 4,5.',
      notes: 'Notes',
      manqueMachine: 'Choisissez la machine du relevé.',
      manqueSaisie: 'Saisissez au moins une mesure, une observation ou une note.',
      mesureInvalide: 'Corrigez les mesures : un nombre par champ.',
      copieAReprendre: 'Reprenez ou écartez la copie conservée avant d’enregistrer.',
      pret: 'Le relevé rejoindra l’historique de la machine.',
      historique: 'Derniers relevés de cette machine',
      historiqueAide: 'Relevés de cette activité parmi les 100 dernières entrées, en observations datées.',
      historiqueVide: 'Aucun relevé de cette activité dans les dernières entrées.',
      historiqueComplet: 'Historique complet de la machine',
      equipe: 'Équipe',
      calcul: 'Calcul rapide',
      resultat: 'Résultat',
      raccourciPlanning: 'Planning',
      raccourciClients: 'Clients',
      raccourciFluides: 'Fluides frigorigènes',
      raccourciMateriel: 'Matériel',
    },
  },
  commun: {
    appNomParDefaut: 'MyEquip',
    enregistrer: 'Enregistrer',
    annuler: 'Annuler',
    valider: 'Valider',
    refuser: 'Refuser',
    fermer: 'Fermer',
    rechercher: 'Rechercher',
    chargement: 'Chargement…',
    aucunResultat: 'Aucun résultat',
    erreurInattendue: 'Une erreur inattendue est survenue',
    horsLigne: 'Hors ligne',
    horsLigneAction: 'Hors ligne : rien n’a été envoyé. Réessayez au retour du réseau.',
    horsLigneDonnees: 'Hors ligne — données de l’appareil',
    horsLigneDonneesDu: 'Hors ligne — données du {date}',
    pasAJour: 'Pas à jour',
    reessayer: 'Réessayer',
    echecReessayer: 'Échec · Réessayer',
    enLigne: 'En ligne',
    synchronisation: 'Synchronisation…',
    syncEnAttente: '{count} opérations en attente',
    syncOk: 'Synchronisé',
    syncErreur: 'Erreur de synchronisation',
    syncRefusees: '{count} envoi(s) refusé(s)',
    syncOuvrir: 'Voir les envois en attente',
    brouillon: 'Brouillon',
    obligatoire: 'Obligatoire',
    facultatif: 'Facultatif',
    date: 'Date',
    statut: 'Statut',
    actions: 'Actions',
    total: 'Total',
    retour: 'Retour',
    suivant: 'Suivant',
    precedent: 'Précédent',
    confirmerSuppression: 'Confirmer la suppression ?',
    fourniParLeClient: 'Fourni par le client',
    rechercherPlaceholder: 'Client, site, machine, référence…',
    copier: 'Copier',
    copie: 'Copié !',
    telecharger: 'Télécharger',
    afficher: 'Afficher',
    masquer: 'Masquer',
    toutVoir: 'Tout voir',
    ouvrir: 'Ouvrir',
    pasEncoreDisponible: 'Pas encore disponible',
    lireLaSuite: 'Lire la suite',
    reduire: 'Réduire',
  },
  nav: {
    accueil: 'Accueil',
    maJournee: 'Ma journée',
    demandes: 'Demandes',
    // Espace qui réunit les demandes et les interventions (17/10/2026).
    interventions: 'Interventions',
    clients: 'Clients',
    contrats: 'Contrats',
    // Le stock, les véhicules et les achats sous un seul nom (plan du 17/10/2026).
    materiel: 'Matériel',
    alertes: 'Alertes',
    conflits: 'Conflits',
    analyses: 'Analyses',
    profil: 'Menu',
    // Barre basse du téléphone : même libellé que la page qu'elle ouvre (17/10/2026).
    profilMobile: 'Menu',
    taches: 'Tâches',
    // Une rubrique, trois onglets à leur adresse (plan du 17/10/2026).
    ventes: 'Ventes',
    ventesOnglets: {
      aria: 'Rubriques des ventes',
      devis: 'Devis',
      factures: 'Factures',
      contrats: 'Contrats',
    },
    avisClients: 'Avis clients',
    equipe: 'Équipe',
    monVehicule: 'Mon véhicule',
    depenses: 'Dépenses',
    // Annonces de l'entreprise et conversations entre membres (25/10/2026).
    messages: 'Messages',
    // Point sur « Menu » : une rubrique qu'il contient attend (messages non lus).
    menuAttend: 'une rubrique du Menu attend',
    // Groupes de la colonne et du Menu (17/10/2026).
    groupeQuotidien: 'Au quotidien',
    groupeClients: 'Clients et ventes',
    groupeOperations: 'Opérations',
    groupeTerrain: 'Sur le terrain',
    groupePilotage: 'Pilotage',
    // Bouton « ＋ » : créer quelque chose, ou scanner une machine.
    creer: 'Créer',
    creerTitre: 'Créer',
    creerDetail: 'Ce que vous pouvez créer, selon vos droits',
    raccourci: 'Raccourci de la barre du bas',
    raccourciDetail: 'Accueil, Planning, Créer et Menu restent en place ; ce quatrième bouton vous suit sur tous vos appareils.',
    creation: {
      intervention: 'Intervention',
      demande: 'Demande',
      tache: 'Tâche',
      client: 'Client',
      devis: 'Devis',
      facture: 'Facture',
      contrat: 'Contrat',
      depense: 'Dépense',
      achat: 'Demande d’achat',
      mouvement: 'Mouvement de stock',
      inventaire: 'Inventaire',
      tempsBloque: 'Temps bloqué',
      absence: 'Absence',
      import: 'Import Excel ou CSV',
      annonce: 'Annonce',
    },
    menuCompte: 'Menu du compte',
    // Entrées du menu du compte (ordinateur), dans l'ordre du menu.
    parametres: 'Paramètres',
    monCompte: 'Mon compte',
    monEntreprise: 'Mon entreprise',
    abonnementFacturation: 'Abonnement',
    obtenirAide: 'Aide et contact',
    toutesLesSections: 'Toutes les rubriques',
    gestion: 'Gestion',
    technique: 'Technique',
    navigationPrincipale: 'Navigation principale',
    reduireMenu: 'Réduire le menu',
    deployerMenu: 'Déployer le menu',
    nonLues: '{count} non lues',
    // Vue du responsable qui intervient aussi (24/10/2026) : toute l'entreprise,
    // ou seulement sa propre journée, au même nom que l'accueil qu'elle ouvre.
    mode: 'Vue',
    modeTitre: 'Votre vue',
    pilotage: 'Entreprise',
    pilotageDetail: 'Toute l’équipe : planning, clients, ventes',
    modeTerrain: 'Ma journée',
    modeTerrainDetail: 'Seulement vos interventions, comme un technicien',
    modeBascule: 'Passer à la vue {vue}',
  },
  // Messages (25/10/2026) : annonces de l'entreprise et conversations entre membres.
  // Pas d'accusé « Vu » dans les conversations ; « vu par X sur Y » pour les annonces.
  messages: {
    titre: 'Messages',
    usage: 'Les annonces de l’entreprise et vos conversations avec l’équipe.',
    // Avis au premier usage (décision du propriétaire du 25/10/2026 : l'export les garde, on le dit).
    avis: {
      texte: 'Vos messages restent dans l’entreprise : gardés le temps qu’elle a choisi (24 mois par défaut), ils font partie de la copie de ses données que le patron peut télécharger. Évitez d’y écrire des informations personnelles sensibles.',
      enSavoirPlus: 'En savoir plus',
      aSavoir: 'À savoir sur les messages',
    },
    horsLigne: {
      liste: 'Hors ligne : vos conversations les plus récentes, enregistrées sur cet appareil le {date}. Lecture seule.',
      fil: 'Hors ligne : les derniers messages enregistrés sur cet appareil le {date}. Lecture seule ; un message écrit partira au retour du réseau.',
    },
    onglets: {
      aria: 'Rubriques des messages',
      conversations: 'Conversations',
      conversationsUsage: 'Écrire à un collègue ou à un groupe.',
      annonces: 'Annonces',
      annoncesUsage: 'Les informations de l’entreprise pour toute l’équipe ou une partie.',
    },
    nouveauMessage: 'Nouveau message',
    publierAnnonce: 'Publier une annonce',
    aucuneConversation: 'Aucune conversation pour l’instant.',
    aucuneAnnonce: 'Aucune annonce pour l’instant.',
    nonLus: '{count} non lus',
    vous: 'Vous',
    groupeSansNom: 'Groupe de {count} personnes',
    rubriqueCoupee: 'La messagerie est coupée pour votre entreprise.',
    ancienMembre: 'Ancien membre',
    aucunMessage: 'Pas encore de message',
    pieceJointe: 'Pièce jointe',
    piecesJointes: '{n} pièces jointes',
    ficheJointe: 'Fiche jointe',
    pieces: '{n} pièce(s) jointe(s)',
    fichesN: '{n} fiche(s) jointe(s)',
    nonLu: 'Non lu',
    nonLusPastille: 'non lus',
    enSourdine: 'En sourdine',
    aucuneConversationAide: 'Touchez « Nouveau message » pour écrire à un collègue ou à un groupe.',
    aucuneAnnonceAide: 'Les informations de l’entreprise arriveront ici.',
    aucuneAnnonceAidePublier: 'Touchez « Publier une annonce » pour informer toute l’équipe ou une partie.',
    chargementPersonnes: 'Chargement de l’équipe',
    chercherPersonne: 'Chercher une personne',
    aucunePersonneTrouvee: 'Personne ne correspond à cette recherche.',
    personneAAjouter: 'Personne d’autre dans l’équipe ne reçoit de messages.',
    fiches: {
      titre: 'Joindre une fiche',
      aide: 'Le message ne garde que le lien : chacun voit la fiche selon ses propres droits.',
      chercher: 'Client, machine, devis, facture, contrat, fournisseur…',
      deuxLettres: 'Tapez au moins deux lettres ou chiffres.',
      recherche: 'Recherche',
      aucune: 'Aucune fiche trouvée.',
      resultats: 'Fiches trouvées',
      intervention: 'Intervention',
      quote: 'Devis',
      invoice: 'Facture',
      contract: 'Contrat',
      customer: 'Client',
      equipment: 'Machine',
      supplier_invoice: 'Facture fournisseur',
    },
    conversation: {
      ecrire: 'Écrire un message',
      envoyer: 'Envoyer',
      joindrePiece: 'Joindre une photo ou un fichier',
      joindreFiche: 'Joindre une fiche',
      ficheInaccessible: 'Fiche non accessible',
      retirer: 'Retirer le message',
      retireConfirmation: 'Retirer ce message ? Il devient « Message retiré » pour tout le monde, et ses pièces jointes sont retirées.',
      retire: 'Message retiré',
      retraitExpire: 'Un message se retire dans les {minutes} minutes qui suivent son envoi.',
      enFile: 'En file : envoi au retour du réseau',
      echec: 'Non envoyé',
      reessayer: 'Réessayer',
      supprimer: 'Supprimer',
      plusAncien: 'Messages plus anciens',
      reseauRequis: 'Connexion nécessaire pour cette action.',
      titre: 'Conversation',
      groupe: 'Groupe',
      fil: 'Messages de la conversation',
      chargement: 'Chargement des messages',
      vide: 'Aucun message pour l’instant : écrivez le premier ci-dessous.',
      joindre: 'Joindre',
      actionsMessage: 'Actions sur votre message',
      retirerTitre: 'Retirer ce message ?',
      misEnFile: 'Pas de réseau : le message est gardé sur l’appareil et partira au retour du réseau.',
      echecMotif: 'Non envoyé : {motif}',
      supprimerTitre: 'Supprimer ce message de l’appareil ?',
      supprimerConsequence: 'Le serveur l’a refusé : personne ne l’a reçu. Il quitte cet appareil.',
      photo: 'Photo',
      photos: 'Photos jointes',
      ouvrirPhoto: 'Ouvrir',
      pieceEnAnalyse: '{nom} : analyse antivirus en cours',
      pieceIllisible: '{nom} : fichier illisible',
      piecesChoisies: 'Pièces à envoyer',
      piecesNonGardees: 'Les photos et fichiers choisis ne sont pas gardés si vous quittez l’écran avant l’envoi.',
      retirerPiece: 'Retirer',
      retirerNom: 'Retirer {nom}',
    },
    nouveau: {
      titre: 'Nouveau message',
      retour: 'Messages',
      personnes: 'Avec qui ?',
      personnesAide: 'Une personne, ou plusieurs pour un groupe ({max} au plus).',
      nomGroupe: 'Nom du groupe (facultatif)',
      creer: 'Commencer la conversation',
      usage: 'Une personne pour une conversation à deux, plusieurs pour un groupe.',
      choisirPersonne: 'Choisissez au moins une personne.',
      nomTropLong: 'Le nom du groupe compte {max} caractères au plus.',
      nomGroupeAide: 'Sinon, le groupe porte le prénom de ses membres.',
      pretDirect: 'La conversation s’ouvre ; si elle existe déjà, vous la retrouvez.',
      pretGroupe: 'Un groupe de {n} personnes, vous compris.',
      creation: 'Ouverture…',
    },
    membres: {
      titre: 'Membres',
      ajouter: 'Ajouter des membres',
      retirer: 'Retirer du groupe',
      quitter: 'Quitter le groupe',
      quitterConfirmation: 'Quitter ce groupe ? Vous ne recevrez plus ses messages.',
      sourdine: 'Mettre en sourdine',
      sourdineAide: 'Plus de notification pour cette conversation ; les messages restent marqués non lus.',
      administrateur: 'Gère le groupe',
      titreN: 'Membres ({n})',
      ajouterAide: '{n} place(s) encore dans le groupe.',
      ajouterN: 'Ajouter ({n})',
      ajout: 'Ajout…',
      actions: 'Actions sur {nom}',
      retirerTitre: 'Retirer {nom} du groupe ?',
      retirerConsequence: 'Cette personne ne lira plus ce groupe, ni ses anciens messages. Vous pourrez l’ajouter de nouveau.',
      quitterTitre: 'Quitter ce groupe ?',
      quitte: 'Vous avez quitté le groupe.',
      reactiver: 'Réactiver les notifications',
      renommer: 'Renommer le groupe',
      renommerAide: 'Vide : le groupe porte le prénom de ses membres.',
      renommerValider: 'Enregistrer le nom',
    },
    annonce: {
      nouvelle: 'Nouvelle annonce',
      retour: 'Annonces',
      audience: 'Pour qui ?',
      audienceTous: 'Toute l’équipe',
      audienceRoles: 'Un ou plusieurs rôles',
      audienceMembres: 'Des membres choisis',
      titreChamp: 'Titre',
      texte: 'Texte',
      pieces: 'Pièces jointes',
      lectureAConfirmer: 'Lecture à confirmer',
      lectureAConfirmerAide: 'Chacun confirme avoir pris connaissance de l’annonce.',
      urgente: 'Urgente',
      urgenteAide: 'Prévient tout de suite, même en dehors des heures habituelles.',
      publier: 'Publier',
      publierConfirmation: 'Publier cette annonce ? Elle ne pourra plus être modifiée, seulement archivée.',
      prisConnaissance: 'J’ai pris connaissance',
      confirme: 'Lecture confirmée le {date}',
      vuPar: 'Vu par {vus} sur {total}',
      confirmePar: 'Confirmé par {confirmes} sur {total}',
      relancer: 'Relancer ceux qui n’ont pas lu',
      relanceAttente: 'Une relance par jour au plus.',
      archiver: 'Archiver l’annonce',
      archiverConfirmation: 'Archiver cette annonce ? Elle quitte l’accueil de chacun ; les lectures restent enregistrées.',
      archivee: 'Archivée',
      remplace: 'Remplace une annonce archivée',
      urgenteBadge: 'Urgente',
      titre: 'Annonce',
      usage: 'Une information de l’entreprise pour toute l’équipe, des rôles ou des personnes choisies.',
      aLire: 'À lire',
      aConfirmer: 'À confirmer',
      confirmeeBadge: 'Confirmée',
      aLireTitre: 'À lire',
      dejaLues: 'Déjà lues',
      archivees: 'Annonces archivées',
      archiveesAide: 'Retirées de l’accueil ; leurs lectures restent enregistrées.',
      aucuneArchivee: 'Aucune annonce archivée.',
      parLe: 'Par {nom}, le {date}',
      archiveeLe: 'Archivée le {date} : elle a quitté l’accueil de chacun.',
      voirCorrection: 'Voir l’annonce corrigée',
      archiveeRetour: 'Annonce archivée.',
      archiverTitre: 'Archiver cette annonce ?',
      assistance: 'Session d’assistance : la lecture se confirme par le membre lui-même.',
      confirmerAide: 'Confirmez avoir lu et compris cette annonce.',
      enregistrement: 'Enregistrement…',
      confirmationEnFile: 'Pas de réseau : votre confirmation est gardée sur l’appareil et partira au retour du réseau, avec l’heure de votre geste.',
      corriger: 'Corriger (publier une nouvelle version)',
      corrigerTitre: 'Corriger l’annonce',
      corrigerUsage: 'Une annonce publiée ne change plus : celle-ci la remplace, l’ancienne est archivée avec ses lectures.',
      corrigerConfirmationTitre: 'Publier la correction ?',
      lectures: 'Lectures',
      lecturesAide: 'Qui l’a vue, et qui a confirmé quand c’est demandé.',
      chargementLectures: 'Chargement des lectures',
      relancerN: 'Relancer {n} personne(s)',
      relanceEnvoi: 'Envoi…',
      relanceFaite: 'Rappel envoyé à {n} personne(s).',
      relanceProchaine: 'Prochaine relance possible le {date}.',
      toutLeMonde: 'Tout le monde l’a lue.',
      confirmeLe: 'Confirmé le {date}',
      vuLe: 'Vu le {date}',
      pasEncoreVu: 'Pas encore vue',
      audienceAide: 'Chacun reçoit seulement ce qui le concerne.',
      audienceTousAide: 'Tous les membres qui reçoivent des messages.',
      audienceRolesAide: 'Par exemple les techniciens.',
      audienceMembresAide: 'Une ou plusieurs personnes.',
      audienceRolesN: '{n} rôle(s)',
      audienceMembresN: '{n} personne(s)',
      quelsRoles: 'Quels rôles ?',
      quiMembres: 'Quelles personnes ?',
      personnesN: '{n} personne(s)',
      choisirAudience: 'Choisissez pour qui.',
      contenu: 'Titre et texte',
      contenuAide: 'Court et clair : l’équipe le lit souvent au téléphone.',
      titreManquant: 'Donnez un titre.',
      texteManquant: 'Écrivez le texte.',
      texteAide: '{n} / {max} caractères.',
      ajouterPiece: 'Joindre une photo ou un PDF',
      piecesAide: 'Photos ou PDF, {n} au plus.',
      piecesARejoindre: 'Les pièces de l’annonce corrigée sont à joindre de nouveau.',
      options: 'Options',
      pret: 'Pour : {audience}.',
      publication: 'Publication…',
      publiee: 'Annonce publiée à {n} personne(s).',
      publierTitre: 'Publier cette annonce ?',
      urgenteConfirmation: 'Urgente : elle prévient tout de suite, même en dehors des heures habituelles (tracé au journal d’audit).',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
    },
    reglages: {
      titre: 'Messagerie',
      aide: 'Annonces et conversations de l’équipe',
      activer: 'Messagerie de l’équipe',
      activerAide: 'Coupée, la rubrique Messages disparaît pour tout le monde, patron compris.',
      horairesCalmes: 'Horaires calmes',
      horairesCalmesAide: 'En dehors des heures habituelles, les notifications attendent le début de la journée. Une annonce urgente passe toujours.',
      conservation: 'Durée de conservation',
      conservationAide: 'Les messages plus anciens sont effacés avec leurs pièces jointes, chaque nuit. Les annonces non archivées restent. Raccourcir la durée demande de confirmer votre identité.',
      mois: '{n} mois',
      rubrique: 'Rubrique Messages',
      rubriqueAide: 'Annonces de l’entreprise et conversations de l’équipe.',
      conservationTitre: 'Conservation',
      conservationDefaut: '{n} mois par défaut, de 1 mois à 10 ans.',
      unite: 'mois',
    },
    erreurs: {
      tropDeMessages: 'Trop de messages envoyés en une heure. Réessayez un peu plus tard.',
      groupePlein: 'Un groupe compte {max} personnes au plus.',
      tropDeConversations: 'Vous avez atteint {max} conversations. Quittez-en une pour en commencer une autre.',
      plusMembre: 'Vous ne faites plus partie de cette conversation.',
      pieceRefusee: 'Seules les photos et les PDF de {mo} Mo au plus peuvent être joints.',
      tropDAnnonces: 'L’entreprise a publié {max} annonces aujourd’hui. Réessayez demain.',
      tropDePieces: '{n} pièces jointes au plus.',
      tropLong: 'Message trop long : {n} caractères au plus.',
    },
  },
  // Avis sur MyEquip (24/10/2026) : un bug ou une idée, transmis à l'équipe MyEquip.
  avisProduit: {
    ouvrir: 'Signaler un problème ou proposer une idée',
    menu: 'Donner un avis sur MyEquip',
    menuLigne: 'Un bug, une idée : l’équipe MyEquip lit tout',
    kicker: 'Avis sur MyEquip',
    titre: 'Un problème, une idée ?',
    description: 'Votre message part directement à l’équipe MyEquip, avec l’écran où vous êtes. Ne mettez ni mot de passe ni données de vos clients.',
    type: 'Type',
    types: { bug: 'Problème', idee: 'Idée', autre: 'Autre' },
    message: 'Votre message',
    aide: '{compte} / {max} caractères, 10 au minimum.',
    exemples: {
      bug: 'Ce que vous faisiez, ce qui s’est passé, ce que vous attendiez…',
      idee: 'Ce qui vous ferait gagner du temps…',
      autre: 'Ce que vous voulez nous dire…',
    },
    envoyer: 'Envoyer',
    envoi: 'Envoi…',
    merci: 'Merci !',
    transmis: 'Avis n° {numero} transmis à l’équipe MyEquip.',
    assistance: 'Pendant une session d’assistance, les avis ne s’envoient pas au nom du membre.',
    signalerErreur: 'Signaler ce problème',
  },
  // Fenêtre des paramètres sur ordinateur (24/10/2026).
  fenetreParametres: {
    apercu: 'Vue d’ensemble',
    rubriques: 'Rubriques des paramètres',
    fermer: 'Fermer les paramètres',
    retour: 'Page précédente',
    recherche: 'Rechercher un réglage',
    aucunResultat: 'Aucun réglage pour « {terme} ».',
    // Mots trouvés par la recherche en plus du nom et de la description de chaque rubrique.
    motsCles: {
      compte: 'nom, photo, e-mail, mot de passe, double authentification, clé d’accès, appareils de confiance, thème, sombre, clair, raccourci, déconnexion',
      notifications: 'alertes, e-mails, téléphone, push',
      apercu: 'entreprise, mise en route',
      identite: 'raison sociale, nom commercial, SIRET, SIREN, TVA intracommunautaire, adresse du siège, téléphone public',
      apparence: 'logo, couleur, présentation, PDF, mentions, pied de page, IBAN, BIC, coordonnées bancaires, conditions de paiement, pénalités, signature des e-mails, adresse de réponse, étiquette QR',
      documents: 'règlement intérieur, consignes, lecture',
      donneesPersonnelles: 'RGPD, accès, correction, suppression',
      membres: 'inviter, utilisateur, technicien, collègue, accès',
      roles: 'droits, permissions, hiérarchie, responsable',
      comptable: 'expert-comptable, cabinet, SIREN, factures, accès gratuit',
      audit: 'historique, journal, traces',
      equipe: 'absences, congés, astreinte, agenda, disponibilités',
      sousTraitants: 'partenaires, missions',
      metiers: 'activités, machines suivies',
      horaires: 'heures, jours travaillés, début, fin',
      terrain: 'signature, double authentification, planning des collègues',
      suivi: 'position, GPS, arrivée, technicien le plus proche',
      temps: 'heures supplémentaires, week-end, oubli de fin',
      pieces: 'stock, inventaire, achats, réservations',
      checklists: 'contrôles, rapport, points à vérifier',
      clients: 'carte, adresse, placement',
      fluides: 'frigorigène, CERFA, attestation de capacité',
      devis: 'facture, numérotation, acompte, TVA, délai de paiement, échéance, taux horaire, envoi',
      baremes: 'prix, tarifs, lignes',
      catalogue: 'modèles, types de machines, entretien',
      relances: 'impayés, rappels, retard de paiement',
      avis: 'satisfaction, questionnaire',
      integrations: 'Pennylane, comptabilité, agenda, journal des ventes',
      import: 'CSV, tableur, reprise, autre logiciel',
      abonnement: 'offre, essai, paiement',
    },
  },
  roles: {
    patron: 'Patron',
    dispatcher: 'Bureau',
    technicien: 'Technicien',
    client: 'Client',
    sous_traitant: 'Sous-traitant',
    super_admin: 'Super-administrateur',
  },
  recherche: {
    customer: 'Client',
    equipment: 'Machine',
    site: 'Site',
    article: 'Article',
    quote: 'Devis',
    invoice: 'Facture',
    intervention: 'Intervention',
  },
  erreurs: {
    validation_error: 'Données invalides',
    not_found: 'Ressource introuvable',
    forbidden: 'Accès refusé',
    accesRefuseTexte: 'Votre rôle ne permet pas d’ouvrir cette page. Demandez l’accès au responsable de l’entreprise.',
    retourAccueil: 'Retour à l’accueil',
    unauthorized: 'Authentification requise',
    step_up_required: 'Réauthentification requise pour cette action sensible',
    conflict: 'Conflit de modification',
    rate_limited: 'Trop de tentatives, réessayez plus tard',
    internal_error: 'Erreur interne',
    tenant_context_missing: 'Contexte entreprise manquant',
    read_only_mode: 'Compte en lecture seule — contactez votre administrateur',
    compte_suspendu: 'Compte suspendu : l’accès aux données est fermé jusqu’à la reprise de l’abonnement.',
    service_indisponible: 'Ce service est momentanément indisponible. Contactez directement l’entreprise qui vous a transmis ce lien.',
    recuperation_fermee: 'La récupération des données a fermé 30 jours après la fin de l’abonnement.',
    registration_unavailable: 'La création de compte en ligne n’est pas encore ouverte.',
    requete_mal_formee: 'Requête mal formée',
    fichier_trop_volumineux: 'Fichier ou requête trop volumineux',
    format_non_accepte: 'Format non accepté',
    transition_interdite: 'Ce changement de statut n’est pas autorisé',
    document_immuable: 'Ce document est immuable ; créez une correction liée',
    signature_requise: 'Signature client obligatoire pour ce type d’intervention',
    signature_impossible_motif_requis: 'Sélectionnez un motif d’absence de signature',
    stock_insuffisant: 'Stock insuffisant',
    reservation_expiree: 'Réservation expirée',
    idempotency_conflict: 'Opération déjà traitée avec un contenu différent',
    article_brouillon_non_validable: 'Article en brouillon : validez-le avant l’entrée en stock',
    quota_stockage_depasse: 'L’espace de stockage de l’entreprise est plein. Consultez Entreprise → Abonnement pour demander davantage d’espace. Les documents existants sont conservés.',
    quota_photos_qr_atteint: 'Trop de photos reçues pour cette entreprise : envoyez votre demande sans photo, ou réessayez dans quelques jours.',
    stockage_indisponible: 'Stockage de fichiers indisponible',
    base_occupee: 'Service très sollicité : réessayez dans quelques instants.',
    fichier_en_quarantaine: 'Fichier en cours d’analyse antivirus',
    fichier_infecte: 'Fichier rejeté par l’analyse antivirus',
    fichier_analyse_impossible: 'Analyse antivirus impossible : renvoyez le fichier',
    limite_devis_depassee: 'Montant, remise ou marge hors de vos limites de devis',
    periode_verrouillee: 'Période verrouillée',
    contrat_signe_immuable: 'Contrat signé : créez un avenant',
    transmission_en_attente: 'En attente de transmission — aucun accusé reçu',
    integration_desactivee: 'Intégration non activée',
    appareil_revoque: 'Appareil révoqué',
    appareils_trop_nombreux: 'Trop d’appareils actifs : retirez-en un dans Mon compte → Appareils et sessions',
    autorisation_hors_ligne_expiree: 'Autorisation hors ligne expirée : reconnexion nécessaire',
    mfa_requis: 'Double authentification requise',
    lien_expire_ou_consomme: 'Lien expiré ou déjà utilisé',
    import_simulation_requise: 'Exécutez d’abord la simulation d’import',
    import_hors_limites: 'Fichier trop volumineux pour un import : découpez-le en plusieurs fichiers',
    approbation_requise: 'Approbation requise',
    sous_traitant_acces_expire: 'Accès sous-traitant expiré',
    client_existant: 'Une fiche existe déjà pour ce client',
    depense_existante: 'Une facture identique est déjà enregistrée',
    chevauchement: 'Chevauche une ligne déjà saisie',
    temps_facture: 'Temps verrouillé : l’intervention est facturée',
    droit_non_accorde: 'Cette mission ne vous autorise pas à envoyer cette partie',
    signature_deja_recueillie: 'La signature du client a déjà été recueillie pour cette mission',
    reglage_manquant: 'Un réglage de l’entreprise manque pour ce geste',
  },
  abonnement: {
    // Aucune mention de prix ni de canal commercial : rien n'est validé.
    essaiActif: 'Votre essai est en cours : il vous reste {jours} jours avec toutes les fonctions.',
    voirDetail: 'Voir le détail',
    essaiRestant: 'Votre essai se termine dans {jours} jours.',
    essaiDernierJour: 'Votre essai se termine aujourd’hui.',
    grace:
      'Paiement de l’abonnement non reçu. Votre accès reste complet quelques jours ; sans régularisation, plus rien ne pourra être enregistré.',
    lectureSeule:
      'Espace en lecture seule : ni vous ni votre équipe ne pouvez plus rien enregistrer. Reprenez votre abonnement pour continuer.',
    suspendu: 'Compte suspendu : votre équipe n’a plus accès et vos données sont inaccessibles.',
    reprendre: 'Reprendre mon abonnement',
    reprendreReessayer: 'Réessayer la demande de reprise',
    repriseEnAttente: 'Demande envoyée, en attente de l’équipe MyEquip.',
    // Aucune ligne d'abonnement rattachée (DB-28) : l'accès est fermé.
    ferme: {
      titre: 'Accès fermé',
      badge: 'Fermé',
      description: 'Aucun abonnement MyEquip n’est rattaché à {entreprise} : l’accès est fermé pour toute l’équipe.',
    },
    // Récupération des données par le patron (décision 12) : lien discret, jamais mis en avant.
    recuperation: {
      lien: 'Récupérer mes données',
      titre: 'Récupérer mes données',
      description:
        'Une archive ZIP de vos données : un fichier par sujet (clients, machines, interventions, factures…), les PDF de vos factures émises et de vos fiches CERFA.',
      preparer: 'Préparer l’archive',
      reessayer: 'Préparer une nouvelle archive',
      telecharger: 'Télécharger l’archive',
      // Archive hors limites (taille, fichiers, durée) : la copie est demandée d'elle-même à MyEquip.
      copie: {
        titre: 'Archive trop volumineuse pour la préparation automatique',
        demandee: 'L’équipe MyEquip a été prévenue : elle prépare la copie de vos données et vous la remet dans le mois.',
        traitee: 'L’équipe MyEquip a traité la copie de vos données le {date}.',
      },
      enCours: 'Archive en préparation : vous pouvez rester sur cette page ou revenir plus tard.',
      echec: 'La préparation a échoué',
      prete: 'Archive prête ({taille}), téléchargeable jusqu’au {date}.',
      prochaine: 'Une archive par jour : la prochaine pourra être préparée le {date}.',
      verification: 'Votre identité vous sera redemandée avant la préparation et avant le téléchargement.',
      retour: 'Retour',
      reserve: 'Seul le responsable de l’entreprise peut récupérer ses données.',
      // Fin d'abonnement (décision 12) : 30 jours pour récupérer, puis suppression possible.
      jusquAu: 'Récupérez vos données avant le {date}',
      avantSuppression: 'Passé ce délai, la récupération ferme et vos données peuvent être supprimées définitivement.',
      disponibleJusquAu: 'Récupération ouverte jusqu’au {date} ; vos données peuvent ensuite être supprimées définitivement.',
      fermee: 'La récupération des données est fermée',
      fermeeDetail: 'Elle restait ouverte 30 jours après la fin de l’abonnement.',
    },
  },
  // Boîte de réception, cloche et préférences (refonte v4, 18/10/2026).
  notifications: {
    titre: 'Notifications',
    description: 'Les alertes qui vous concernent ; touchez-en une pour ouvrir ce qu’elle vise.',
    toutLire: 'Tout marquer comme lu',
    toutLireEnCours: 'Marquage…',
    toutLu: '{n} notification(s) marquée(s) comme lue(s).',
    choisir: 'Choisir mes notifications',
    ongletsLabel: 'Filtrer les notifications',
    onglets: { toutes: 'Toutes', nonLues: 'Non lues', urgentes: 'Urgentes' },
    aides: {
      toutes: 'Les plus récentes d’abord ; les messages d’un même dossier sont regroupés.',
      nonLues: 'Ce que vous n’avez pas encore lu. Glissez une alerte pour la marquer lue.',
      urgentes: 'Les urgences restent toujours visibles, lues ou non.',
    },
    vides: {
      toutes: 'Aucune notification pour le moment.',
      nonLues: 'Vous êtes à jour : rien de non lu.',
      urgentes: 'Aucune urgence.',
    },
    nonLue: 'Non lue',
    urgente: 'Urgente',
    marquerLue: 'Marquer comme lue',
    marquerNonLue: 'Marquer comme non lue',
    marquerLueDe: 'Marquer lue : {titre}',
    marqueeLue: 'Notification marquée comme lue.',
    annuler: 'Annuler',
    dossierNonLus: '{n} non lu(s)',
    ouvrirImpossible: 'Impossible d’ouvrir cette notification.',
    chargementImpossible: 'Impossible de charger vos notifications.',
    reessayer: 'Réessayer',
    aJour: 'Vous êtes à jour : aucune notification non lue.',
    nonLuesListe: 'Notifications non lues',
    nonLuesNombre: '{n} non lue(s)',
    clocheNonLues: 'Notifications : {n} non lue(s)',
    voirToutes: 'Voir toutes les notifications',
    voirNonLues: 'Voir les {n} notifications non lues',
    preferences: {
      titre: 'Mes notifications',
      description: 'Où recevoir chaque alerte. Seules celles qui vous concernent sont proposées.',
      groupes: {
        interventions: 'Interventions et urgences',
        taches: 'Tâches et objectifs',
        equipe: 'Équipe et planning',
        ventes: 'Clients, devis et factures',
        stock: 'Stock, achats et fluides',
        technique: 'Technique et abonnement',
        autres: 'Autres alertes',
      },
      canaux: 'Recevoir par',
      jamais: 'Jamais',
      jamaisIndisponible: 'Nulle part tant que le push est indisponible',
      toujours: 'Toujours, sur tous les canaux',
      resumeSoir: 'Résumé du soir',
      resumeSoirAide: 'Pas de notification immédiate sur le téléphone : l’avis reste dans l’application et un seul message de fin de journée les regroupe.',
      feuilleKicker: 'Recevoir cette alerte',
      feuilleAide: 'Chaque case s’enregistre tout de suite.',
      termine: 'Terminé',
    },
    // Notifications push de l'appareil (décision 1 du 19/10/2026).
    push: {
      titre: 'Sur cet appareil',
      aide: 'Les alertes s’affichent sur l’écran, même MyEquip fermé.',
      inactifTitre: 'Recevoir les alertes sur ce téléphone',
      activer: 'Activer sur cet appareil',
      activation: 'Activation…',
      desactiver: 'Désactiver',
      echec: 'Activation impossible sur cet appareil. Réessayez dans un moment.',
      optionIndisponible: 'Pas encore disponible',
      etats: {
        actif: 'Notifications activées sur cet appareil.',
        inactif: 'Le navigateur vous demandera votre accord une seule fois.',
        bloque: 'Notifications bloquées : autorisez-les pour MyEquip dans les réglages du navigateur, puis revenez ici.',
        indisponible: 'Les notifications push ne sont pas encore disponibles : vos alertes arrivent dans l’application.',
        non_pris_en_charge: 'Ce navigateur ne reçoit pas les notifications. Ouvrez MyEquip dans Chrome, Edge, Firefox ou Safari à jour.',
        ios_a_installer: 'Sur iPhone : touchez Partager, puis « Sur l’écran d’accueil », ouvrez MyEquip depuis l’icône et revenez ici.',
      },
    },
  },
  // Conflits de synchronisation (refonte v4, 18/10/2026).
  conflits: {
    titre: 'Conflits de synchronisation',
    description: 'Une même donnée a changé hors ligne et au bureau : gardez une des deux versions. L’autre reste tracée dans l’historique.',
    nombre: '{n} à arbitrer',
    lienIndicateur: '{n} conflit(s) de synchronisation à arbitrer',
    champ: 'Champ « {champ} »',
    versions: 'Deux versions de « {champ} »',
    horsLigne: 'Hors ligne · {nom}',
    bureau: 'Au bureau',
    quelquun: 'un membre',
    saisiLe: 'Synchronisée le {date}',
    garderHorsLigne: 'Garder la version hors ligne',
    garderBureau: 'Garder la version du bureau',
    ouvrir: 'Ouvrir la fiche',
    menu: 'Plus d’actions sur le conflit de {element}',
    confirmer: {
      horsLigneTitre: 'Garder la version hors ligne ?',
      bureauTitre: 'Garder la version du bureau ?',
      horsLigne: '« {champ} » prendra la valeur saisie hors ligne : {valeur}',
      bureau: '« {champ} » garde la valeur du bureau : {valeur}',
    },
    garde: {
      horsLigne: 'Version hors ligne gardée : {element}.',
      bureau: 'Version du bureau gardée : {element}.',
    },
    videTitre: 'Aucun conflit à arbitrer',
    vide: 'Tout ce qui a été saisi hors ligne a pu être fusionné.',
    // Fusion à la main d'un texte (FLD-9) : page dédiée, prérempli des deux versions.
    fusion: {
      action: 'Fusionner à la main',
      titre: 'Fusionner les deux versions',
      description: 'Réunissez les deux textes en un seul : c’est lui qui sera gardé.',
      etapeLire: 'Les deux versions',
      etapeLireAide: 'Ce qui a été saisi hors ligne et ce qui est au bureau.',
      etapeTexte: 'Texte gardé',
      etapeTexteAide: 'Prérempli avec les deux versions réunies : retirez ce qui est en double.',
      champ: 'Texte de « {champ} »',
      avant: 'Avant les deux modifications : {valeur}',
      enregistrer: 'Garder ce texte',
      enCours: 'Enregistrement…',
      pret: 'Ce texte remplacera les deux versions.',
      garde: 'Texte fusionné gardé : {element}.',
      introuvable: 'Ce conflit n’existe pas ou n’est plus visible.',
      dejaTranche: 'Ce conflit a déjà été tranché{par}.',
      par: ' par {nom}',
      impossible: 'Ce champ ne se fusionne pas à la main : choisissez une des deux versions.',
    },
  },
  // Mon compte (refonte v4, 18/10/2026).
  compte: {
    description: 'Ce qui ne concerne que vous : photo, connexion, notifications et affichage.',
    ligneMenu: 'Mon compte : photo, connexion, notifications, affichage',
    photo: {
      changer: 'Changer ma photo de profil',
      choisir: 'Choisir une photo de profil',
      menu: 'Photo de profil',
      googleActualiser: 'Actualiser ma photo Google',
      googleImporter: 'Importer ma photo Google',
      googleLie: 'Compte Google lié : sa photo devient la vôtre si vous n’en aviez pas choisi.',
      googleDejaLie: 'Ce compte Google est déjà lié à un autre compte MyEquip : rien n’a été changé.',
      googleEchec: 'La liaison avec Google n’a pas abouti (autorisation expirée ou refusée) : rien n’a été changé. Réessayez.',
      googleDelier: 'Délier mon compte Google',
      googleDelie: 'Compte Google délié : la photo qui en venait, s’il y en avait une, a été retirée.',
      retirer: 'Retirer ma photo',
      envoi: 'Envoi de la photo…',
      aide: 'Touchez la photo pour la changer · JPG, PNG ou WebP, 5 Mo maximum.',
    },
    securite: {
      titre: 'Connexion et sécurité',
      aideCode: 'Avant une action sensible, votre identité est revérifiée (appli de codes ou code par e-mail), puis plus pendant {duree} sur cet appareil.',
      aideMotDePasse: 'Avant une action sensible, votre mot de passe est demandé, puis plus pendant {duree} sur cet appareil.',
      identifiant: 'Nom d’utilisateur',
      email: 'Adresse e-mail',
      emailConfirme: 'Confirmée',
      emailAConfirmer: 'À confirmer',
      nonRenseigne: 'Non renseigné',
      changerAcces: 'Changer mon e-mail ou mon mot de passe',
      changerAccesAide: 'Votre identité est vérifiée à chaque changement.',
      aideCle: 'Avant une action sensible, votre identité est revérifiée (Face ID, empreinte, code ou mot de passe), puis plus pendant {duree} sur cet appareil.',
      assistance: 'Une session d’assistance ne modifie ni l’e-mail, ni le mot de passe, ni la double authentification du compte.',
    },
    clesAcces: {
      titre: 'Clés d’accès',
      description: 'Se connecter sans mot de passe, avec l’empreinte, le visage ou le code de votre appareil.',
      aucune: 'Se connecter sans mot de passe',
      nombre: '{n} clé(s) enregistrée(s)',
      listeAide: 'Une clé par téléphone ou ordinateur. Elle sert aussi à confirmer une action sensible.',
      secoursCode: 'Conseillé : ajoutez aussi l’appli de codes. Si vous changez de téléphone sans y retrouver vos clés, elle vous permettra de vous reconnecter seul.',
      ajouterCode: 'Ajouter l’appli de codes',
      vide: 'Aucune clé d’accès pour l’instant. Ajoutez-en une sur chaque appareil que vous utilisez.',
      ajouter: 'Ajouter une clé d’accès',
      ajoutEnCours: 'Déverrouillez votre appareil…',
      ajoutee: 'Clé d’accès ajoutée : « {nom} ». Proposez-la à la prochaine connexion.',
      nonGere: 'Ce navigateur ne gère pas les clés d’accès. Utilisez un navigateur récent (Chrome, Safari, Edge ou Firefox).',
      plafond: 'Vous avez {n} clés d’accès, le maximum : retirez-en une pour en ajouter une autre.',
      sansNom: 'Clé d’accès',
      dates: 'Ajoutée le {ajout} · utilisée le {utilisation}',
      datesJamais: 'Ajoutée le {ajout} · pas encore utilisée',
      actions: 'Actions pour {nom}',
      renommer: 'Renommer',
      nom: 'Nom de la clé',
      nomAide: 'Pour la reconnaître : « iPhone de Paul », « Ordinateur du bureau »…',
      enregistrer: 'Enregistrer le nom',
      annuler: 'Annuler',
      retirer: 'Retirer cette clé',
      retirerTitre: 'Retirer cette clé d’accès ?',
      retirerEffet: '« {nom} » ne permettra plus de vous connecter.',
      retirerAutres: 'Vos autres clés d’accès restent valables.',
      retirerMotDePasseCode: 'Votre mot de passe et votre code de vérification restent valables.',
      retirerCode: 'Votre code de vérification reste valable.',
      retirerMotDePasse: 'Votre mot de passe reste valable.',
      retirerDerniereObligatoire: 'C’est votre dernière clé et la double authentification est obligatoire pour votre compte : sans elle, vous ne pourrez plus confirmer une action sensible avant d’avoir configuré une application d’authentification.',
      retirerDerniereSansMotDePasse: 'C’est votre dernière clé et votre compte n’a pas de mot de passe : vous ne pourrez plus confirmer une action sensible avant d’en créer un avec « Mot de passe oublié ».',
      retirerConfirmer: 'Retirer la clé',
      annule: 'Opération annulée : rien n’a été enregistré.',
      dejaEnregistree: 'Cet appareil a déjà une clé d’accès pour votre compte.',
      echec: 'La clé d’accès n’a pas pu être utilisée. Réessayez ou utilisez une autre méthode.',
      assistance: 'Une session d’assistance ne gère pas les clés d’accès du compte.',
      offreTitre: 'Connectez-vous d’un appui',
      offre: 'Activez {methode} sur cet appareil : plus de mot de passe à taper, et aussi sûr qu’un code.',
      offreActiver: 'Activer',
    },
    appareils: {
      titre: 'Appareils de confiance',
      aide: 'Le code de vérification n’y est plus demandé à la connexion ; le mot de passe l’est toujours. Oubliez un appareil perdu.',
      dates: 'Ajouté le {ajout} · code redemandé le {fin}',
      oublier: 'Oublier cet appareil',
      oublierTous: 'Tout oublier',
    },
    sessions: {
      titre: 'Appareils et sessions',
      aide: 'Chaque navigateur ou téléphone connecté à votre compte. Fermez une session que vous ne reconnaissez pas.',
      cetAppareil: 'Cet appareil',
      dates: 'Connecté le {debut} · actif le {activite}',
      android: 'Téléphone Android',
      ios: 'iPhone ou iPad',
      actions: 'Actions pour {appareil}',
      fermer: 'Déconnecter cette session',
      retirerAppareil: 'Retirer cet appareil',
      retirerTitre: 'Retirer cet appareil ?',
      retirerEffet: '{appareil} sera déconnecté et ses données hors ligne effacées à sa prochaine connexion au réseau.',
      retirerConfirmer: 'Retirer l’appareil',
    },
    deconnecterTout: {
      action: 'Déconnecter tous mes appareils',
      titre: 'Déconnecter tous vos appareils ?',
      consequence: 'Toutes vos sessions seront fermées, y compris celle-ci, et vos appareils de confiance oubliés : vous devrez vous reconnecter partout.',
      confirmer: 'Tout déconnecter',
    },
    // Fin d'un compte personnel (25/10/2026) : quitter une entreprise, supprimer son compte.
    quitter: {
      action: 'Quitter une entreprise',
      titre: 'Quitter une entreprise',
      description: 'Mettre fin à votre accès dans une de vos entreprises. Votre compte et vos autres entreprises restent.',
      liste: 'Mes entreprises',
      aide: 'Touchez une entreprise pour la quitter.',
      actuelle: 'Entreprise ouverte en ce moment',
      verrouille: 'Accès verrouillé',
      inactif: 'Accès suspendu',
      aucune: 'Vous n’avez aucune entreprise à quitter.',
      confirmerTitre: 'Quitter {nom} ?',
      consequence: 'Votre accès à {nom} prend fin tout de suite : sessions fermées, interventions à venir retirées de votre planning. Vos rapports et votre historique restent dans l’entreprise ; pour revenir, il faudra une nouvelle invitation.',
      consequenceActuelle: 'C’est l’entreprise ouverte en ce moment : cet appareil sera déconnecté.',
      confirmer: 'Quitter l’entreprise',
      fait: 'Vous avez quitté {nom}.',
      faitInterventions: 'Vous avez quitté {nom}. {n} intervention(s) à venir ont été retirées de votre planning.',
    },
    suppression: {
      action: 'Supprimer mon compte',
      titre: 'Supprimer mon compte',
      description: 'Supprimer définitivement votre compte MyEquip personnel.',
      effets: 'Ce qui sera fait',
      effetEntreprises: 'Vous quittez toutes vos entreprises, comme si vous partiez de chacune.',
      effetIdentifiants: 'Votre adresse, votre identifiant, votre mot de passe, vos clés d’accès et votre double authentification sont effacés.',
      effetHistorique: 'Votre nom reste sur les documents et l’historique des entreprises (factures, rapports, journal), qu’elles doivent conserver.',
      effetPatron: 'Si vous êtes le seul patron d’une entreprise, nommez d’abord un autre patron : la suppression sera refusée sinon.',
      bouton: 'Supprimer mon compte',
      confirmerTitre: 'Supprimer votre compte ?',
      consequence: 'C’est définitif : personne, pas même MyEquip, ne pourra le restaurer. Un e-mail de confirmation partira à votre adresse.',
      phrase: 'Saisissez SUPPRIMER pour confirmer',
    },
    notifications: {
      titre: 'Notifications',
      choisir: 'Choisir mes notifications',
      aide: 'Dans l’application, sur le téléphone ou par e-mail, alerte par alerte.',
    },
    affichage: {
      titre: 'Affichage',
      aide: 'Le thème vaut pour cet appareil ; le raccourci vous suit partout.',
    },
    acces: {
      titre: 'E-mail et mot de passe',
      description: 'Vos identifiants de connexion. Chaque changement vérifie d’abord que c’est bien vous.',
      assistance: 'Une session d’assistance ne peut pas modifier l’e-mail ni le mot de passe du compte.',
      identifiants: 'Identifiants de connexion',
      email: 'Adresse e-mail',
      emailAucun: 'Aucune adresse enregistrée',
      emailEnAttente: 'Nouvelle adresse {email} en attente du code',
      modifier: 'Modifier',
      modifierEmail: 'Modifier l’adresse e-mail',
      modifierMotDePasse: 'Modifier le mot de passe',
      saisirCode: 'Saisir le code',
      saisirCodeEmail: 'Saisir le code de la nouvelle adresse',
      emailNonConfirme: 'Cette adresse n’est pas encore confirmée : ouvrez le lien reçu par e-mail. Sans cela, « Mot de passe oublié » ne fonctionnera pas avec elle.',
      renvoyer: 'Renvoyer le lien',
      lienRenvoye: 'Lien renvoyé',
      motDePasse: 'Mot de passe',
      motDePasseLigne: 'Le changer déconnecte vos autres appareils.',
      // Flux « Changer d'adresse e-mail » (25/10/2026) : code envoyé à la nouvelle adresse.
      emailTitre: 'Changer d’adresse e-mail',
      emailDescription: 'Un code part vers la nouvelle adresse. Votre adresse actuelle reste active tant qu’il n’est pas saisi.',
      etapeIdentite: 'Confirmez que c’est vous',
      etapeIdentiteAide: 'Votre mot de passe actuel, ou votre clé d’accès.',
      etapeIdentiteFaite: 'Identité confirmée.',
      motDePasseActuel: 'Mot de passe actuel',
      utiliserCle: 'Utiliser {methode}',
      cleEnCours: 'Déverrouillez votre appareil…',
      etapeAdresse: 'Nouvelle adresse',
      etapeAdresseAide: 'Un code à 6 chiffres y sera envoyé.',
      nouvelEmail: 'Nouvelle adresse e-mail',
      nouvelEmailAide: 'Les majuscules et les espaces en trop sont retirés automatiquement.',
      envoyeA: 'Code envoyé à {email}.',
      changerAdresse: 'Changer d’adresse',
      etapeCode: 'Code reçu',
      etapeCodeAide: 'Ouvrez la boîte {email} et saisissez le code à 6 chiffres.',
      code: 'Code à 6 chiffres',
      expireDans: 'Valable encore {duree}.',
      renvoyerCode: 'Renvoyer le code',
      renvoyerDans: 'Renvoyer le code ({duree})',
      codeRenvoye: 'Nouveau code envoyé : l’ancien ne fonctionne plus.',
      plusDeRenvoi: 'Plus de renvoi possible pour cette demande : recommencez si le code n’arrive pas.',
      codeExpire: 'Ce code a expiré. Recommencez pour en recevoir un nouveau.',
      recommencer: 'Recommencer',
      demo: 'Démonstration locale : aucun e-mail n’est envoyé. Code : {code}',
      problemeMotDePasse: 'Saisissez votre mot de passe actuel, ou utilisez votre clé d’accès.',
      problemeCle: 'Confirmez avec votre clé d’accès.',
      problemeEmail: 'Saisissez la nouvelle adresse e-mail.',
      problemeCode: 'Saisissez les 6 chiffres du code reçu.',
      pretIdentite: 'Étape suivante : la nouvelle adresse.',
      pretAdresse: 'Le code part vers {email}.',
      pretCode: 'Votre adresse deviendra {email}.',
      continuer: 'Continuer',
      envoyerCode: 'Envoyer le code',
      envoi: 'Envoi…',
      confirmerEmail: 'Confirmer la nouvelle adresse',
      verification: 'Vérification…',
      annulerDemande: 'Annuler le changement d’adresse',
      emailChange: 'Adresse modifiée : {email}. Votre ancienne adresse a été prévenue.',
      demandeAnnulee: 'Changement annulé : votre adresse reste {email}.',
      // Flux « Changer de mot de passe » : même présentation, même comportement qu'avant.
      motDePasseTitre: 'Changer de mot de passe',
      motDePasseDescription: 'Après le changement, vos autres appareils sont déconnectés ; celui-ci reste connecté.',
      etapeActuel: 'Confirmez que c’est vous',
      etapeActuelAide: 'Pour confirmer que c’est bien vous.',
      etapeNouveau: 'Choisissez le nouveau',
      nouveauMotDePasse: 'Nouveau mot de passe',
      minimum: '{n} caractères minimum.',
      tropCourt: 'Encore {reste} caractère(s) : {n} au minimum.',
      confirmer: 'Confirmer le nouveau mot de passe',
      differents: 'Les deux saisies ne sont pas identiques.',
      problemeActuel: 'Saisissez votre mot de passe actuel.',
      problemeNouveau: 'Choisissez un nouveau mot de passe de {n} caractères au moins, saisi deux fois.',
      pretMotDePasse: 'Vos autres appareils seront déconnectés.',
      changerMotDePasse: 'Changer mon mot de passe',
      enregistrement: 'Enregistrement…',
      motDePasseChange: 'Mot de passe modifié. Vos autres appareils ont été déconnectés.',
    },
    mfa: {
      titre: 'Double authentification',
      description: 'Un geste en plus du mot de passe (Face ID, empreinte, appli de codes ou code par e-mail) protège votre compte et les données de vos clients.',
      methodes: 'Vos méthodes',
      methodeCle: 'Clé d’accès',
      methodeCleOui: 'Configurée : Face ID, Touch ID, empreinte ou Windows Hello',
      methodeCleNon: 'Aucune : connectez-vous d’un appui',
      methodeAppli: 'Appli de codes',
      methodeAppliNon: 'Non activée : conseillée en secours',
      methodeEmail: 'Code par e-mail',
      methodeEmailOui: 'Choisi en secours, à chaque nouvel appareil',
      active: 'Activée : un code est demandé à la connexion',
      activeCourt: 'Activée',
      inactive: 'Non activée',
      inactiveCourt: 'Non activée',
      aActiver: 'Obligatoire pour votre compte : à activer',
      parCle: 'Assurée par votre clé d’accès (Face ID, empreinte)',
      parEmail: 'Assurée par un code reçu par e-mail',
      etat: 'État',
      depuis: 'depuis le {date}',
      pourVotreCompte: 'Pour votre compte',
      obligatoire: 'Obligatoire',
      obligatoireAide: 'Exigée pour votre rôle ou par votre entreprise : elle ne peut pas être désactivée.',
      facultative: 'Facultative',
      facultativeAide: 'Conseillée ; vous pouvez la désactiver.',
      obligatoireAActiver: 'La double authentification est obligatoire pour votre compte : activez-la maintenant.',
      assureeParCle: 'Votre clé d’accès (Face ID, empreinte) assure la double authentification. Ajoutez l’appli de codes en secours, pour un changement de téléphone.',
      assureeParEmail: 'Un code vous est envoyé par e-mail à chaque nouvel appareil. Face ID, l’empreinte ou l’appli de codes sont plus sûrs : activez-en un quand vous pouvez.',
      gerer: 'Appli de codes et codes de secours',
      codesRestants: 'Encore {n} sur {total}',
      codesRestantsDate: 'Encore {n} sur {total}, créés le {date}',
      codesAide: 'Chacun permet une connexion si vous perdez votre téléphone.',
      codesPeu: 'Il vous reste peu de codes : créez-en de nouveaux.',
      regenerer: 'Créer de nouveaux codes de secours',
      regenererTitre: 'Créer de nouveaux codes de secours ?',
      regenererEffet: 'Huit nouveaux codes remplacent les anciens, qui ne fonctionneront plus. Vous les verrez une seule fois : gardez-les en lieu sûr.',
      nouveauxCodes: 'Vos nouveaux codes de secours',
      codesGardes: 'Terminer',
      codesRemplaces: 'Nouveaux codes de secours enregistrés ; les anciens ne fonctionnent plus.',
      codesTitre: 'Vos codes de secours',
      codesDescription: 'Montrés une seule fois : gardez-les en lieu sûr avant de continuer.',
      changer: 'Changer d’application',
      changerAide: 'Nouveau téléphone ou nouvelle application d’authentification.',
      activer: 'Activer la double authentification',
      activerTitre: 'Activer la double authentification',
      activerDescription: 'Trois étapes : votre application, le code à scanner, puis le premier code.',
      changerTitre: 'Changer d’application',
      changerDescription: 'L’application actuelle reste valable jusqu’au premier code de la nouvelle ; ensuite, vos autres appareils sont déconnectés.',
      etape1: 'Votre application d’authentification',
      etape1Aide: 'Google Authenticator, Microsoft Authenticator ou Aegis, par exemple, sur votre téléphone.',
      etape1Faite: 'Code prêt : ajoutez MyEquip à votre application.',
      commencer: 'Afficher le code à scanner',
      preparation: 'Préparation…',
      etape2: 'Ajouter MyEquip à l’application',
      etape2Aide: 'Un appui sur ce téléphone, ou le QR code depuis un autre appareil.',
      etape3: 'Saisir le premier code',
      etape3Aide: 'Le code à 6 chiffres affiché par l’application. Ce n’est pas votre mot de passe.',
      codeSixChiffres: 'Saisissez le code à 6 chiffres affiché par l’application.',
      motDePasseTape: 'Ceci ressemble à un mot de passe : saisissez le code à 6 chiffres de l’application.',
      pret: 'Le code sera vérifié avant toute modification.',
      verification: 'Vérification…',
      utiliserApplication: 'Utiliser cette application',
      activee: 'La double authentification est activée.',
      changee: 'La nouvelle application est enregistrée ; vos autres appareils ont été déconnectés.',
      activeeFin: 'Double authentification activée. Un code vous sera demandé à la connexion.',
      changeeFin: 'Nouvelle application enregistrée.',
      desactiver: 'Désactiver la double authentification',
      desactiverTitre: 'Désactiver la double authentification ?',
      desactiverEffet: 'Seul votre mot de passe sera demandé à la connexion, et vos appareils de confiance seront oubliés. Un avis est envoyé à {email}.',
      votreAdresse: 'votre adresse',
      desactivee: 'Double authentification désactivée.',
    },
  },
  // Un compte personnel, plusieurs entreprises (décision du 25 octobre 2026).
  compteEntreprises: {
    titre: 'Vos entreprises',
    aide: 'Un seul compte pour toutes vos entreprises : un appui pour passer de l’une à l’autre.',
    actuelle: 'Actuelle',
    enCours: 'Changement d’entreprise…',
    horsLigne: 'Hors ligne : retrouvez du réseau pour changer d’entreprise. Vos saisies restent dans l’entreprise actuelle.',
    envois: '{n} envoi(s) en attente',
    envoisAide: 'Ils partiront quand vous reviendrez dans cette entreprise.',
    indisponible: {
      verrouille: 'Accès verrouillé',
      suspendu: 'Accès suspendu',
      inactif: 'Accès en pause',
    },
    // Un autre onglet a changé d'entreprise : celui-ci suit avant d'envoyer quoi que ce soit.
    autreOnglet: 'Entreprise changée dans un autre onglet : cette page se met à jour, rien n’a été envoyé.',
    choisirTitre: 'Choisissez une entreprise',
    choisirAide: 'Votre compte donne accès à plusieurs entreprises. Vous pourrez en changer à tout moment depuis le Menu.',
    choisirListe: 'Entreprises de votre compte',
    connexionExpiree: 'Connexion expirée : reconnectez-vous.',
    aucuneTitre: 'Aucune entreprise pour l’instant',
    aucuneAide: 'Votre compte n’a accès à aucune entreprise en ce moment.',
    invitations: 'Invitations en attente',
    invitationLigne: 'Ouvrez le lien reçu par e-mail pour la rejoindre · avant le {date}',
    creer: 'Enregistrer mon entreprise',
    creerAide: 'Vous en devenez le responsable, avec ce même compte.',
    creerNom: 'Nom de votre entreprise',
    creee: 'Entreprise enregistrée. Reconnectez-vous pour sécuriser votre compte : la double authentification est obligatoire pour les responsables.',
    // Acceptation d'une invitation avec un compte existant.
    dejaCompte: 'Avez-vous déjà un compte MyEquip ?',
    dejaCompteNon: 'Non, je crée mon compte',
    dejaCompteNonAide: 'Vous choisissez votre mot de passe.',
    dejaCompteOui: 'Oui, j’ai déjà un compte',
    dejaCompteOuiAide: 'Pour une autre entreprise : le même compte servira pour les deux.',
    connecte: 'Connecté en tant que {nom}',
    rejoindre: 'Rejoindre {entreprise}',
    rejoindreEnCours: 'Ajout à votre compte…',
    rejoindreAide: 'L’invitation doit avoir été envoyée à l’adresse confirmée de ce compte.',
    seConnecterPourRejoindre: 'Se connecter pour accepter',
    seConnecterPourRejoindreAide: 'Connectez-vous avec votre compte, puis confirmez.',
    bandeauRejoindre: 'Connectez-vous pour rejoindre {entreprise}.',
    plusTard: 'Pas maintenant',
    rejointe: 'Vous avez rejoint {entreprise}.',
    rejointeReconnexion: 'Vous avez rejoint {entreprise}. Reconnectez-vous pour y entrer : elle exige la double authentification.',
    // Comptable invité dont le compte n'est pas encore « comptable vérifié » (place tenue fermée).
    comptableAttente: 'Accès comptable à ouvrir',
    comptableAttenteAide: 'Remplissez une fois votre fiche de comptable : l’accès s’ouvre dès qu’elle est vérifiée.',
    comptableAttenteLigne: 'Fiche de comptable à remplir ou en vérification',
    comptableRejointe: 'Invitation de {entreprise} acceptée',
    comptableRejointeAide: 'Votre accès s’ouvrira dès que votre fiche de comptable sera vérifiée. Connectez-vous pour la remplir.',
    comptableFiche: 'Remplir ma fiche de comptable',
    autresActions: 'Autres actions du compte',
    // Vérification d'adresse exigée avant de relier le compte à une autre entreprise.
    prouverAdresse: 'Prouver mon adresse avec « Mot de passe oublié »',
  },
  auth: {
    methode: {
      apple: 'Face ID ou Touch ID',
      mac: 'Touch ID',
      android: 'l’empreinte',
      windows: 'Windows Hello',
      cle: 'une clé d’accès',
    },
    passkeyRequise: 'Terminez la connexion avec {methode}.',
    mfaPasskey: 'Activer {methode}',
    mfaPasskeyAide: 'Un appui suffit, sans appli à installer ni code à recopier.',
    mfaAvecAppli: 'Appli de codes',
    mfaAvecAppliAide: 'Google Authenticator, Microsoft Authenticator…',
    mfaEmail: 'Code par e-mail',
    mfaEmailAide: 'Un code reçu à chaque nouvel appareil.',
    mfaCle: 'Clé d’accès',
    mfaCleAide: 'Votre téléphone ou une clé de sécurité.',
    mfaAutres: 'Autres méthodes',
    miseEnPlaceTitre: 'Sécurisez votre compte',
    miseEnPlaceAide: 'Obligatoire pour votre compte : un geste en plus du mot de passe.',
    verificationTitre: 'Vérification',
    continuer: 'Continuer',
    bonRetour: 'Bon retour, {nom}',
    passkeyContinuer: 'Continuer avec {methode}',
    utiliserMotDePasse: 'Utiliser mon mot de passe',
    modifierIdentifiant: 'Modifier',
    codeEmail: {
      envoyer: 'Recevoir un code par e-mail',
      sansTelephone: 'Pas mon téléphone : recevoir un code par e-mail',
      envoye: 'Code envoyé à {email}, valable {minutes} minutes.',
      libelle: 'Code reçu par e-mail',
      aide: 'Pas reçu ? Regardez dans les courriers indésirables, ou renvoyez-le.',
      renvoyer: 'Renvoyer le code',
      envoi: 'Envoi du code…',
    },
    connexion: 'Connexion',
    email: 'Adresse e-mail',
    motDePasse: 'Mot de passe',
    seConnecter: 'Se connecter',
    motDePasseOublie: 'Mot de passe oublié ?',
    connexionGoogle: 'Continuer avec Google',
    codeMfa: 'Code de vérification',
    // « Ce n'est pas votre mot de passe » : l'erreur la plus fréquente (12/10/2026).
    codeMfaAide: 'Le code à 6 chiffres de votre application d’authentification.',
    codeMfaOu: 'Où trouver ce code ?',
    codeMfaDetail:
      'Ouvrez votre application d’authentification et saisissez le code à 6 chiffres qu’elle affiche : il change toutes les 30 secondes. Ce n’est pas votre mot de passe. Un code de secours fonctionne aussi.',
    autreCompte: 'Autre compte',
    appareilConfiance: 'Ne plus demander de code sur cet appareil pendant {jours} jours',
    appareilConfianceAide:
      'Votre mot de passe reste demandé. À éviter sur un appareil partagé.',
    configurerMfa: 'Configurer la double authentification',
    passkey: 'Utiliser {methode}',
    passkeyEnCours: 'Déverrouillez votre appareil…',
    verification: {
      titre: 'Confirmez votre identité',
      cleTexte: 'Déverrouillez votre appareil (empreinte, visage ou code) pour continuer.',
      cleConfirmer: 'Confirmer avec {methode}',
      utiliserCle: 'Utiliser ma clé d’accès',
      utiliserCode: 'Utiliser le code de l’application',
      utiliserMotDePasse: 'Utiliser mon mot de passe',
    },
    biometrie: 'Déverrouillage biométrique',
    deconnexion: 'Se déconnecter',
    // Déconnexion avec des saisies pas encore envoyées (décision 6 : jamais d'abandon).
    deconnexionEnvois: {
      titre: 'Des envois attendent encore',
      explication: 'Ces saisies sont encore sur cet appareil seulement. Envoyez-les avant de vous déconnecter.',
      liste: 'Envois en attente',
      horsLigne: 'Hors ligne : retrouvez du réseau pour les envoyer.',
      echec: 'Tout n’est pas parti. Réessayez dès que le réseau est stable.',
      envoyer: 'Envoyer maintenant',
      envoi: 'Envoi…',
      garder: 'Me déconnecter et les garder',
      garderAide:
        'Ils partiront à votre prochaine connexion sur cet appareil, où vos brouillons de formulaire restent aussi. Aucun autre compte ne les voit.',
      assistanceAide:
        'Assistance MyEquip : rien ne reste sur ce poste après la session. Envoyez ces saisies, ou effacez-les.',
      effacer: 'Effacer et me déconnecter',
      effacerTitre: 'Effacer ces envois ?',
      effacerConsequence:
        'Les envois listés ne partiront jamais : ils disparaissent de cet appareil, sans copie au bureau.',
      natures: {
        cloture: 'Clôtures d’intervention',
        etape: 'Étapes d’intervention',
        rapport: 'Rapports d’intervention',
        note: 'Notes',
        photo: 'Photos',
        fichier: 'Fichiers',
        temps: 'Saisies de temps',
        aPrevoir: 'Éléments à prévoir',
        fluides: 'Fluides, contrôles et fiches CERFA',
        devis: 'Devis préparés sans réseau',
        intervention: 'Modifications d’intervention',
        message: 'Messages',
        annonce: 'Prises de connaissance d’annonces',
        autre: 'Autres modifications',
        refusee: 'Refusés par le serveur, à corriger',
      },
    },
    invitation: 'Définir mon mot de passe',
    sessionExpiree: 'Session expirée, reconnectez-vous',
    accroche: 'Machines, interventions et documents dans un même système.',
    mfaScannezQr:
      'Scannez ce QR code avec l’application d’authentification de votre téléphone (Google Authenticator, Microsoft Authenticator, Aegis, 1Password…), puis saisissez le code à 6 chiffres affiché.',
    mfaEtape1:
      'Ouvrez votre appli de codes (Google Authenticator, Microsoft Authenticator…), ou installez-en une.',
    mfaEtapeTelephone:
      'Sur ce téléphone, ajoutez MyEquip en un appui.',
    mfaAjouterApp: 'Ajouter à mon application',
    mfaEtapeAutreAppareil:
      'Sur un autre appareil, scannez ce QR code avec l’appli.',
    mfaAfficherQr: 'Afficher le QR code',
    mfaEtapeCode:
      'Saisissez le code à 6 chiffres affiché par l’appli.',
    mfaQrAlt: 'QR code d’enrôlement de la double authentification',
    mfaCleManuelle: 'Pas de scan possible ? Saisissez cette clé dans l’appli.',
    mfaPourquoi:
      'La double authentification protège les données de vos clients : elle est obligatoire pour les responsables.',
    codesSecoursTitre: 'Vos codes de secours',
    codesSecoursExplication:
      'Chaque code permet UNE connexion si vous perdez votre téléphone ou votre application d’authentification. Conservez-les en lieu sûr (coffre de mots de passe, impression au bureau).',
    codesSecoursCopier: 'Copier les codes',
    codesSecoursTelecharger: 'Télécharger (.txt)',
    codesSecoursConfirmation: 'J’ai enregistré mes codes de secours en lieu sûr',
    codesSecoursContinuer: 'Accéder à l’application',
    // Inscription autonome : rien sur la durée d'essai, le prix ou la
    // gratuité — c'est le produit qui l'annonce une fois l'utilisateur entré.
    ongletConnexion: 'Se connecter',
    // « Enregistrer » et non « créer » : la plateforme n'immatricule aucune
    // société, elle accueille une entreprise existante et lui ouvre un espace.
    ongletInscription: 'Enregistrer mon entreprise',
    inscriptionTitre: 'Enregistrer mon entreprise',
    inscriptionSociete: 'Nom de votre entreprise',
    inscriptionNom: 'Votre nom complet',
    inscriptionRole:
      'Vous ouvrez l’espace de votre entreprise et en devenez le responsable. Vous inviterez les membres de votre équipe depuis les paramètres.',
    inscriptionValider: 'Enregistrer mon entreprise',
    inscriptionAccepter: 'J’ai lu et j’accepte {document}',
    inscriptionFermee: 'La création de compte en ligne n’est pas encore ouverte.',
    inscriptionMotDePasseAide: '{n} caractères minimum.',
    emailAConfirmer:
      'Confirmez votre adresse {email} : sans cela, elle ne permettra pas de récupérer votre compte.',
    emailRenvoyer: 'Renvoyer le lien',
    emailRenvoye: 'Lien renvoyé.',
    // Vérification récente exigée pour changer la double authentification (18/10/2026).
    verificationRecente: 'Pour modifier la double authentification, confirmez de nouveau votre identité.',
    // Connexion sur le système v4 (vague 4, 18/10/2026).
    identifiant: 'Nom d’utilisateur ou e-mail',
    erreurs: {
      mfa_recuperation: 'Reconnectez-vous avec votre mot de passe pour configurer votre nouvel authentificateur.',
    },
    retours: {
      compte_supprime: 'Votre compte MyEquip a été supprimé. Un e-mail de confirmation est parti à votre adresse.',
      entreprise_quittee: 'Vous avez quitté l’entreprise. Reconnectez-vous pour ouvrir vos autres entreprises.',
      appareil_retire: 'Cet appareil a été retiré de votre compte : reconnectez-vous pour l’utiliser de nouveau.',
      double_authentification: 'Votre accès à cette entreprise a changé, et votre autre entreprise exige la double authentification : reconnectez-vous.',
    },
    codeRessembleMotDePasse: 'Ceci ressemble à un mot de passe : saisissez le code à 6 chiffres de l’application.',
    documentsAAccepter: 'Documents à accepter',
    lireDocument: 'Lire {document}',
    appareilConfianceEtat: 'Appareil de confiance',
  },
  etats: {
    // Registre juridique plateforme
    draft: 'Brouillon',
    published: 'Publié',
    retired: 'Archivé',
    // Demande client
    soumise: 'Soumise',
    a_qualifier: 'À qualifier',
    information_requise: 'Information requise',
    acceptee: 'Acceptée',
    rejetee: 'Rejetée',
    convertie: 'Convertie',
    // Facture électronique (cycle de vie relevé auprès de la plateforme agréée)
    transmise: 'Déposée',
    suspendue: 'En litige',
    encaissee: 'Encaissée',
    // Intervention
    planifiee: 'Planifiée',
    en_route: 'En route',
    en_cours: 'En cours',
    en_pause: 'En pause',
    cloturee: 'Terminée',
    annulee: 'Annulée',
    // Devis
    brouillon: 'Brouillon',
    envoye: 'Envoyé',
    consulte: 'Consulté',
    accepte: 'Accepté',
    refuse: 'Refusé',
    expire: 'Expiré',
    annule: 'Annulé',
    revise: 'Révisé',
    // Facture
    emise: 'Émise',
    partiellement_payee: 'Partiellement payée',
    payee: 'Payée',
    en_retard: 'En retard',
    litigieuse: 'En litige',
    creditee: 'Annulée par avoir',
    // Contrat
    actif: 'Actif',
    a_renouveler: 'À renouveler',
    termine: 'Terminé',
    resilie: 'Résilié',
    // Facture fournisseur
    en_attente: 'En attente',
    en_analyse: 'En analyse',
    a_verifier: 'À vérifier',
    confirme: 'Confirmé',
    corrige: 'Corrigé',
    echec: 'Échec',
    doublon: 'Doublon',
    rejete: 'Rejeté',
    // Commande fournisseur
    demande: 'Demande',
    a_approuver: 'À approuver',
    approuvee: 'Approuvée',
    envoyee: 'Envoyée',
    partiellement_recue: 'Partiellement reçue',
    recue: 'Reçue',
    retournee: 'Retournée',
    // Pièce retournée au fournisseur (Q195)
    en_quarantaine: 'En contrôle',
    vendable: 'Vendable',
    defectueuse: 'Défectueuse',
    a_reparer: 'À réparer',
    retour_fournisseur: 'Renvoyée au fournisseur',
    // Inventaire
    a_valider: 'À valider',
    valide: 'Validé',
    // Intégration
    en_file: 'En file',
    a_reessayer: 'À réessayer',
    reussie: 'Réussie',
    echec_final: 'Échec définitif',
    // Contrôle fuite
    conforme: 'Conforme',
    fuite: 'Fuite détectée',
    non_applicable: 'Non applicable',
    reparation_requise: 'Réparation requise',
    recontrole_requis: 'Recontrôle requis',
    interdit_remise_service: 'Remise en service interdite',
    // Utilisateur
    invite: 'Invité',
    verrouille: 'Verrouillé',
    revoque: 'Retiré',
    inactif: 'Suspendu',
    // Abonnement
    essai: 'Essai',
    grace: 'Période de grâce',
    lecture_seule: 'Lecture seule',
    suspendu: 'Suspendu',
    sans_abonnement: 'Sans abonnement',
    // RGPD
    identite_a_verifier: 'Identité à vérifier',
    en_traitement: 'En traitement',
    executee: 'Exécutée',
    refusee_motivee: 'Refusée (motivée)',
    // Priorité d'intervention (affichée comme un état sur les cartes)
    urgente: 'Urgente',
    normale: 'Normale',
    // Urgence / escalade (Q186)
    declenchee: 'Urgence déclenchée',
    acquittee: 'Prise en charge',
    escaladee: 'Escaladée',
    prise_en_charge: 'Prise en charge',
    resolue: 'Résolue',
    // Équipement (§4.3)
    en_service: 'En service',
    a_l_arret: 'À l’arrêt',
    demantele: 'Démantelé',
    // Rapport, contrat, anomalies, réservations
    cloture: 'Clôturé',
    active: 'Active',
    consommee: 'Consommée',
    liberee: 'Libérée',
    expiree: 'Expirée',
    ouvert: 'Ouvert',
    ouverte: 'Ouverte',
    regularisee: 'Régularisée',
    archive: 'Archivé',
    // Visites de contrat planifiées
    a_planifier: 'À planifier',
    confirmee: 'Confirmée',
    replanifiee: 'Replanifiée',
    // Achats, fluides
    resume_a_verifier: 'Résumé à vérifier',
    a_recuperer: 'À récupérer',
    recu: 'Reçu',
    verifie: 'Vérifié',
    traite: 'Traité',
    transmis: 'Transmis',
    signe: 'Signé',
    pleine: 'Pleine',
    pour_destruction: 'Pour destruction',
    // Urgence perçue (demande client)
    faible: 'Faible',
    haute: 'Haute',
    critique: 'Critique',
    // Divers techniques
    aucun: 'Aucun',
    ok: 'OK',
    erreur: 'Erreur',
    hors_ligne: 'Hors ligne',
    impossible: 'Impossible',
  },
  interventions: {
    triDemande: {
      titre: 'Tri proposé par l’assistant',
      aide: 'Résumé, priorité et type d’intervention probables, sans les coordonnées du demandeur. Une suggestion : vous décidez.',
      proposer: 'Proposer un tri',
      encours: 'Lecture de la demande…',
      resume: 'Résumé',
      priorite: 'Priorité proposée',
      urgente: 'Urgente',
      normale: 'Normale',
      type: 'Type d’intervention',
      symptome: 'Symptôme probable',
      pourquoi: 'Pourquoi',
      verifier: 'L’assistant peut se tromper : vérifiez avec le signalement et, au besoin, le client.',
      planifier: 'Planifier avec ce type',
    },
    faireDevis: 'Faire un devis',
    terminerVisite: 'Terminer l’intervention',
    // Espace Interventions (17/10/2026) : les demandes, puis un onglet par étape.
    espace: {
      description: 'Les demandes à traiter et les interventions, de la planification à la facture.',
      descriptionSansDemandes: 'Les interventions, à planifier, en cours ou terminées.',
      accesRefuse: 'Votre rôle n’ouvre ni le planning ni les factures : les interventions ne vous sont pas proposées. Demandez un accès au patron si besoin.',
      onglets: {
        demandes: 'Demandes',
        a_planifier: 'À planifier',
        planifiees: 'Planifiées',
        en_cours: 'En cours',
        a_cloturer: 'À terminer',
        a_facturer: 'À facturer',
        terminees: 'Terminées et annulées',
        archivees: 'Archivées',
      },
      // Une phrase par onglet : ce qu'il contient et le geste attendu.
      aides: {
        demandes: 'Demandes reçues par QR code, portail ou téléphone : planifiez-les, ou demandez une précision.',
        a_planifier: 'Interventions sans date : donnez-leur un jour, une heure et un technicien.',
        planifiees: 'Interventions datées qui n’ont pas commencé, de la plus proche à la plus lointaine.',
        en_cours: 'Trajet, travail ou pause en cours, dans les temps.',
        a_cloturer: 'Encore ouvertes bien après leur fin prévue : le technicien a sans doute oublié de terminer.',
        a_facturer: 'Terminées sans facture émise, de la plus ancienne à la plus récente.',
        terminees: 'Terminées et annulées, les plus récentes d’abord.',
        archivees: 'Retirées des listes avec leurs preuves ; restaurer les remet en place sans changer leur état.',
      },
      vides: {
        demandes: 'Aucune demande à traiter : tout est planifié.',
        a_planifier: 'Rien à planifier : chaque intervention a sa date.',
        planifiees: 'Aucune intervention planifiée.',
        en_cours: 'Aucune intervention en cours.',
        a_cloturer: 'Rien à terminer : aucune intervention oubliée.',
        a_facturer: 'Rien à facturer.',
        terminees: 'Aucune intervention terminée ou annulée.',
        archivees: 'Aucune intervention archivée.',
      },
      recherche: 'Client, site ou référence',
      nombre: '{n} intervention(s)',
      nombreDemandes: '{n} demande(s)',
      sansDate: 'Sans date',
      nonAffectee: 'Non affectée',
      planifier: 'Planifier',
      restaurer: 'Restaurer',
      nouvelleDemande: 'Noter une demande',
      nouvelleIntervention: 'Nouvelle intervention',
    },
    titre: 'Interventions',
    types: {
      installation: 'Installation',
      visite_contrat: 'Visite d’entretien',
      depannage: 'Dépannage',
      controle_etancheite: 'Contrôle d’étanchéité',
    },
    priorites: { normale: 'Normale', urgente: 'Urgente' },
    aideDemarrerTrajet: 'Ouvrir un GPS ne démarre pas le trajet : ce bouton enregistre votre départ et prévient le client.',
    demarrerTrajet: 'Démarrer le trajet',
    arrive: 'Arrivé sur site',
    pause: 'Mettre en pause',
    reprendre: 'Reprendre',
    rouvrir: 'Rouvrir (responsable)',
    appelerClient: 'Appeler le client',
    itineraire: 'Itinéraire',
    ficheMachine: 'Fiche machine',
    // Un lien nu « Fiche machine » se lisait comme un PDF à télécharger : la
    // ligne de la machine dit ce qu'on y trouve.
    voirMachineAide: 'QR code, historique des interventions et documents',
    etapes: {
      titre: 'Étapes de l’intervention',
      aide: 'Enregistrées quand vous appuyez sur «\u00a0Démarrer le trajet\u00a0», «\u00a0Arrivé sur site\u00a0» ou «\u00a0Mettre en pause\u00a0».',
      depart: 'Parti vers le client',
      arrivee: 'Arrivé sur site — travail commencé',
      debut: 'Arrivé sur site — travail commencé',
      pause: 'Mis en pause',
      reprise: 'Travail repris',
      cloture: 'Intervention terminée',
      reouverture: 'Intervention rouverte',
      annulation: 'Intervention annulée',
      replanification: 'Remise au planning',
      arret_auto: 'Compteur arrêté automatiquement',
    },
    signatureImpossibleSuite:
      'Le bureau est prévenu tout de suite et règle la signature avec le client. Vous pouvez ensuite terminer l’intervention.',
    motifReouverture: 'Motif de réouverture',
    rapportImmuable: 'Le rapport d’origine reste immuable ; une révision sera créée.',
    // File hors ligne vue depuis la fiche (WEB1-03, WEB1-14, 20/10/2026).
    file: {
      clotureEnAttente: 'Fin d’intervention en attente d’envoi',
      clotureEnAttenteAide:
        'La fin de l’intervention partira au retour du réseau, à l’heure où vous l’avez faite. Le rapport ne se modifie plus sur cet appareil.',
      clotureEnFile:
        'Fin d’intervention enregistrée sur l’appareil : elle partira au retour du réseau, à l’heure où vous l’avez faite.',
      clotureRefusee: 'Fin d’intervention refusée : {motif}',
      clotureRefuseeAide: 'Corrigez ce qui manque, puis terminez à nouveau l’intervention. Le bureau est prévenu.',
      dejaEnFile: 'Une fin d’intervention attend déjà l’envoi sur cet appareil.',
      etapeEnFile: 'Étape enregistrée sur l’appareil : elle partira au retour du réseau, à l’heure de votre appui.',
    },
  },
  planning: {
    demandeATraiter: '1 demande à traiter',
    demandesATraiter: '{n} demandes à traiter',
    titre: 'Planning',
    // Session d'assistance MyEquip : relier un compte externe passe par le membre.
    googleAgendaAssistance: 'Une session d’assistance ne connecte ni ne déconnecte Google Agenda : chaque membre le fait depuis son compte.',
    // Réseau absent : le planning vient de la copie synchronisée (WEB1-08).
    horsLigne: 'Hors ligne : planning gardé sur cet appareil, de 7 jours avant à 14 jours après aujourd’hui.',
    organisationEquipe: 'Organisation de l’équipe',
    sousTitre: 'Planifiez les interventions, équilibrez la charge et traitez les absences.',
    // Les boutons sont nommés par leur EFFET. « Événement » ne disait rien : un
    // événement, ici, c'est un congé, une formation, une astreinte ou un trajet
    // — tout ce qui occupe un technicien sans être un client.
    bloquerDuTemps: 'Bloquer du temps',
    machineConcernee: 'Machine concernée (facultatif)',
    aucuneMachine: 'Pas une machine précise',
    quoiFaire: 'Ce qu’il faut faire (facultatif)',
    // Une phrase par vue, sous le titre : c'est la réponse à « Agenda,
    // Tournées, Suivi terrain, qu'est-ce que ça veut dire ? ».
    modeAgenda:
      'Qui fait quoi, et à quelle heure. C’est ici qu’on pose et déplace les rendez-vous.',
    modeTournee: 'L’ordre des arrêts d’une même personne dans sa journée, et la route entre eux.',
    modeSuivi:
      'Où en est chaque technicien en ce moment : dernier point connu et heure d’arrivée estimée.',
    aujourdHui: 'Aujourd’hui',
    vousEtesIci: 'Vous êtes ici',
    prochainsJours: '30 prochains jours',
    nombreElements: '{n} élément(s)',
    aucunElementPeriode: 'Rien de planifié sur cette période.',
    nonAffectee: 'Non affectée',
    conflitCourt: 'Conflit à arbitrer',
    // Intervention d'un site dont le client n'est pas visible pour ce compte :
    // l'heure et la personne seulement, pour ne pas réserver deux fois.
    creneauOccupe: 'Créneau occupé',
    creneauOccupeDetail: 'Intervention sur un site que vous ne voyez pas',
    aValider: 'À valider',
    approuvee: 'Approuvée',
    refusee: 'Refusée',
    decisionRequise: 'Décision requise',
    decisionEnregistree: 'Décision enregistrée',
    collaborateur: 'Membre',
    periode: 'Période',
    motif: 'Motif',
    aideDecisionAbsence: 'Vérifiez la période, puis approuvez ou refusez cette demande.',
    absenceApprouvee: 'L’absence est approuvée.',
    absenceRefusee: 'L’absence est refusée.',
    validationIntrouvable:
      'Cette demande n’est plus en attente ou se trouve hors de la période affichée.',
    vues: {
      jour: 'Jour',
      semaine: 'Semaine',
      mois: 'Mois',
      liste: 'Liste',
      carte: 'Carte',
      tournee: 'Tournées',
    },
    conflitDetecte:
      'Conflit de planning détecté — l’action est conservée et les personnes concernées alertées',
    attestationManquante:
      'Le technicien n’a pas d’attestation d’aptitude fluides valable ce jour-là : il ne pourra pas enregistrer le contrôle d’étanchéité.',
    evenements: {
      indisponibilite: 'Indisponibilité',
      conge: 'Congé / RTT / maladie',
      rendez_vous_interne: 'Réunion / rendez-vous interne',
      formation: 'Formation',
      ecole: 'École / alternance',
      recuperation_pieces: 'Récupération de pièces',
      trajet: 'Temps de trajet',
      tache_administrative: 'Tâche administrative',
      astreinte: 'Astreinte',
      blocage_provisoire: 'Blocage provisoire',
      rappel_personnel: 'Rappel personnel',
      note: 'Note',
    },
    // Astreinte (décision du 19/10/2026) : le module Équipe › Astreintes est la seule source.
    astreinte: {
      creneauAnciens: 'Ancien créneau d’astreinte : il n’occupe que l’agenda et ne prévient personne. Les astreintes se planifient dans Équipe › Astreintes.',
      voirModule: 'Ouvrir les astreintes',
      bandeJusqua: 'D’astreinte jusqu’à {fin} : {noms}',
    },
    validationRequise: 'Demande envoyée, en attente de validation.',
    nouvelleIntervention: 'Nouvelle intervention',
  },
  temps: {
    titre: 'Temps',
    // Refonte du 30/09/2026 : « je dois saisir mon temps, je comprends pas ».
    usage:
      'Déclarez le temps passé — travail, déplacement, pause ou administratif. Ces durées alimentent les bilans par client.',
    // Décision du propriétaire (09/10/2026) : réserve visible sur la page, pas seulement dans l'aide.
    avertissement:
      'Temps déclaratifs et indicatifs : ils servent à l’analyse et donnent un ordre de grandeur. Ils ne prouvent pas les heures travaillées et ne servent pas de base à la paie.',
    avertissementControle:
      'Ces écarts sont calculés automatiquement et peuvent se tromper (bouton oublié, réseau coupé, saisie regroupée). Ce sont des points à vérifier avec la personne, jamais un constat.',
    aideTitre: 'Comprendre le suivi du temps',
    aideSaisi:
      'Le temps que vous déclarez ici est une déclaration : il sert aux bilans, à l’analyse et à la facture de l’intervention, pas à établir vos heures de travail ni votre paie.',
    // Décision du propriétaire du 15/10/2026 : le relevé proposé reste une déclaration confirmée.
    aideReleve:
      'Sur l’intervention, les boutons « Démarrer le trajet », « Arrivé », « Pause » et la clôture préparent votre temps : déplacement et travail, pauses déduites. Rien n’est enregistré sans votre « Confirmer » ; « Corriger » ouvre la saisie préremplie. Une ligne qui en recouvre une autre est signalée avant l’enregistrement, et le temps d’une intervention facturée ne se modifie plus sans déblocage par la facturation.',
    aideGps: 'MyEquip n’utilise jamais le GPS pour calculer les heures. Le décompte du temps de travail et la paie se font avec les outils et documents prévus pour cela dans votre entreprise.',
    aujourdhui: 'Aujourd’hui',
    hier: 'Hier',
    interventionLiee: 'Pour quelle intervention ?',
    interventionAide:
      'Vos interventions des deux dernières semaines. Laissez « Sans intervention » pour du temps au bureau.',
    sansIntervention: 'Sans intervention',
    quoi: 'Qu’avez-vous fait ?',
    categoriesAide: {
      travail: 'Le temps passé à travailler chez le client.',
      trajet: 'La route pour aller chez le client ou en revenir.',
      pause: 'Vos pauses pendant la journée.',
      administratif: 'Le temps au bureau : devis, commandes, rangement du camion…',
    },
    combien: 'Combien de temps ?',
    heures: 'Heures',
    minutes: 'Minutes',
    jour: 'Jour',
    note: 'Précision (facultatif)',
    enregistrerDuree: 'Enregistrer {duree} de {categorie}',
    dureeInvalide: 'Indiquez une durée entre 1 minute et 24 heures',
    enregistre: 'Enregistré : {duree} de {categorie}{pour}, {jour}.',
    mesSaisies: 'Mes saisies',
    saisiesEquipe: 'Saisies de l’équipe',
    aucuneSaisie: 'Aucune saisie sur cette période.',
    bilanTitre: 'Bilan par client',
    exportEnFile: 'Export en préparation : vous serez notifié lorsqu’il sera disponible.',
    controleTitre: 'Contrôle des temps',
    controleUsage:
      'Compare, pour chaque personne, le déplacement et le travail déclarés à ceux observés par les boutons de l’intervention, et au temps planifié (pauses et administratif à part). Une aide pour vérifier, parfois incomplète ou erronée : jamais une preuve, un calcul de paie ni un score de fraude.',
    controleVide: 'Aucune intervention à comparer sur cette période.',
    fiabilite: {
      high: 'Fiabilité haute',
      medium: 'Fiabilité moyenne',
      low: 'Fiabilité faible',
      unavailable: 'Fiabilité indisponible',
    },
    ecart: 'Écart à vérifier : {duree}',
    // « Déplacement » partout (fiche d'intervention, facture, relevé) : un seul mot (15/10/2026).
    categories: {
      trajet: 'Déplacement',
      travail: 'Travail',
      pause: 'Pause',
      administratif: 'Administratif',
    },
    periode: 'Période',
    du: 'Du',
    au: 'au',
    exportAide: 'Récapitulatif indicatif des heures déclarées sur la période choisie, regroupé par client. Ce n’est ni un décompte du temps de travail ni un document de paie.',
    nonRattache: 'Sans client',
    // Refonte v4 du 18/10/2026 : un onglet par usage, la saisie manuelle à un seul endroit.
    onglets: {
      aria: 'Vues du temps',
      saisir: 'Saisir',
      mes: 'Mes saisies',
      equipe: 'Équipe',
      controle: 'Contrôle',
      usage: {
        saisir: 'Déclarez le temps passé : travail, déplacement, pause ou administratif. Ces durées alimentent les bilans par client.',
        mes: 'Ce que vous avez déclaré sur la période, avec ce qui reste à vérifier.',
        equipe: 'Les saisies de l’équipe sur les sites que vous suivez.',
        controle: 'Le bilan des heures par client, et le temps déclaré comparé à celui relevé pendant les interventions.',
      },
    },
    periodes: { semaine: '7 jours', mois: 'Ce mois', 'mois-precedent': 'Mois précédent', libre: 'Autre période' },
    saisie: {
      enregistrement: 'Enregistrement du temps',
      pret: 'Prêt à enregistrer.',
      autreLigne: 'Vérifiez qu’il s’agit bien d’une autre ligne.',
      quandMeme: 'Enregistrer quand même',
      doublonTitre: 'Une ligne semblable existe déjà',
      modifier: 'Modifier la saisie',
      enregistree: 'Temps enregistré',
      enFile: 'En attente de synchronisation',
      voirMesSaisies: 'Voir mes saisies',
      retourIntervention: 'Revenir à l’intervention',
      manqueQuoi: 'Choisissez ce que vous avez fait.',
      manqueIntervention: 'Choisissez l’intervention, ou « Sans intervention ».',
      manqueDuree: 'Choisissez la durée.',
      manqueJour: 'Choisissez un jour passé ou aujourd’hui.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      interventionsIndisponibles: 'Vos interventions n’ont pas pu être chargées : vous pouvez saisir sans intervention, ou réessayer.',
      interventionIntrouvable: 'L’intervention demandée est introuvable ou ne vous est pas ouverte.',
      reessayer: 'Réessayer',
      chargement: 'Chargement de vos interventions…',
      sansInterventionAide: 'Temps qui ne concerne pas une intervention précise.',
      voirToutes: 'Voir les {n} interventions des deux dernières semaines',
      autreDuree: 'Autre durée',
      horaires: 'De … à …',
      debut: 'Début',
      fin: 'Fin',
      pauseRepasPlage: 'Pause repas pendant cette plage',
      debutPause: 'Début de la pause',
      finPause: 'Fin de la pause',
      pauseRepas: 'Pause repas',
      pauseAjoutee: 'La pause repas est enregistrée à part.',
      resume: '{duree} de travail.',
      resumePause: '{travail} de travail ({presence} de présence, moins {pause} de pause repas).',
      horairesManquants: 'Indiquez l’heure de début et de fin.',
      finAvantDebut: 'L’heure de fin doit suivre l’heure de début.',
      pauseInvalide: 'La pause repas doit avoir une heure de début et une heure de fin.',
      pauseHorsPlage: 'La pause repas doit se situer entre le début et la fin.',
      pauseTouteLaPlage: 'La pause occupe toute la plage horaire.',
      quelJour: 'Quel jour ?',
      autreJour: 'Autre jour',
    },
    liste: {
      compte: '{n} saisie(s) · {periode}',
      totaux: 'Total par catégorie sur la période',
      corriger: 'Corriger',
    },
    controle: {
      periode: 'Du {du} au {au}',
      exporter: 'Exporter en {format}',
      preparation: 'Préparation…',
      exportEchoue: 'Export non lancé',
      valeurs: 'Déclaré {saisi} · Observé {observe} · Planifié {planifie}',
    },
    correction: {
      titre: 'Corriger une saisie',
      usage: 'Changez la durée ou la catégorie ; le motif est gardé dans le journal.',
      verrouilleeUsage: 'Cette saisie se lit, mais ne se corrige plus.',
      verrouillee: 'Correction impossible',
      refusGenerique: 'Vous ne pouvez pas corriger cette saisie.',
      introuvable: 'Cette saisie n’existe plus, ou elle ne vous est pas ouverte.',
      saisie: 'La saisie',
      quoi: 'Saisi',
      client: 'Client',
      personne: 'Personne',
      etapeValeurs: 'Durée et catégorie',
      etapeMotif: 'Motif',
      motif: 'Motif de correction',
      motifAide: 'Obligatoire, aussi pour supprimer ; gardé dans le journal.',
      categorie: 'Catégorie',
      enregistrement: 'Enregistrement de la correction',
      enregistrer: 'Enregistrer la correction',
      pret: 'Nouvelle durée : {duree}.',
      rienAChanger: 'Changez la durée ou la catégorie.',
      manqueMotif: 'Indiquez le motif (3 caractères au moins).',
      enregistree: 'Correction enregistrée.',
      supprimee: 'Ligne supprimée.',
      supprimer: 'Supprimer cette ligne',
      supprimerTitre: 'Supprimer cette saisie ?',
      supprimerConsequence: 'Elle disparaît des bilans ; le motif reste dans le journal.',
    },
  },
  // Tâches et objectifs (refonte v4 du 18/10/2026).
  taches: {
    fait: 'Fait',
    faitAria: 'Fait : « {titre} »',
    faitPhotoAria: 'Fait : prendre la photo de « {titre} »',
    enCours: 'Envoi…',
    reessayer: 'Réessayer',
    rouvrir: 'Rouvrir',
    supprimer: 'Supprimer',
    supprimerTitre: 'Supprimer cette tâche ?',
    supprimerSienne: 'Elle disparaît de vos tâches.',
    supprimerDonnee: 'Elle disparaît des tâches de {nom}.',
    ajoutee: 'Ajoutée à vos tâches.',
    donnee: 'Tâche donnée à {nom} : elle est prévenue.',
    faite: 'Fait : « {titre} ».',
    rouverte: 'Tâche rouverte.',
    supprimee: 'Tâche supprimée.',
    pour: 'Pour {quand}',
    pourLe: 'Pour le {date}',
    enRetard: 'En retard — {date}',
    auPlanning: 'Planning : {creneau}',
    personnelle: 'Tâche personnelle',
    objectifPersonnel: 'Objectif personnel',
    donneePar: 'Donnée par {nom}',
    pourQui: 'Pour {nom}',
    faiteLe: 'Faite le {date}',
    finiQuand: 'C’est fini quand : {texte}',
    objectifEtat: 'Objectif · {etat}',
    priorites: { basse: 'Basse', normale: 'Normale', haute: 'Haute', urgente: 'Urgente' },
    preuve: {
      envoi: 'Envoi de la photo…',
      analyse: 'Analyse antivirus de la photo…',
      enregistrement: 'Enregistrement…',
      manquante: 'Prenez la photo pour marquer l’objectif fait.',
      nonEnvoyee: 'Photo non envoyée : reconnectez-vous, puis réessayez.',
      titre: 'Photo de preuve',
      precedente: 'Photo précédente',
      ouvrir: 'Ouvrir',
    },
    blocage: {
      jeBloque: 'Je bloque',
      jeNeBloquePlus: 'Je ne bloque plus',
      debloque: 'C’est débloqué',
      titre: 'Dire que vous bloquez ?',
      consequence: '{nom} est prévenu tout de suite. Dire qu’on bloque, c’est avancer : rien d’autre ne se passe.',
      prevenir: 'Prévenir {nom}',
      raison: 'Ce qui bloque (facultatif)',
      raisonExemple: 'Ex. il manque une pièce',
      prevenu: '{nom} est prévenu : un appel débloque souvent la situation.',
      leve: 'Blocage levé.',
      vousBloquez: 'Vous bloquez : appelez {nom}',
      bloque: '{nom} bloque{raison}',
      sansRaison: 'Aucune raison donnée.',
      appeler: 'Appeler {nom}',
    },
    rapide: {
      libelle: 'Nouvelle tâche',
      exemple: 'Ajouter une tâche…',
      ajouter: 'Ajouter la tâche',
      plus: 'Plus d’options : date, personne, objectif',
    },
    liste: {
      usage: {
        mes: 'Ce que vous avez à faire, les plus urgentes en premier.',
        equipe: 'Ce que vous avez demandé à votre équipe et qui n’est pas encore fait.',
        faites: 'Les tâches terminées, les vôtres et celles de votre équipe.',
      },
      ongletsAria: 'Tâches affichées',
      onglets: { mes: 'Mes tâches', equipe: 'Données à l’équipe', faites: 'Faites' },
      donner: 'Donner une tâche',
      rechercher: 'Tâche, précision ou personne',
      rechercheLibelle: 'Chercher une tâche',
      compte: '{n} tâche(s)',
      aucunResultat: 'Aucune tâche ne correspond à cette recherche.',
      aucuneFaite: 'Aucune tâche terminée',
      aucuneEquipe: 'Aucune tâche en cours dans l’équipe',
      rienAFaire: 'Rien à faire pour l’instant',
      rienAFaireAide: 'Les tâches qu’on vous donne apparaîtront ici, avec une notification.',
      signalee: 'Tâche de la notification',
      introuvable: 'Cette tâche n’existe plus, ou elle ne vous concerne pas.',
    },
    form: {
      nouvelleTache: 'Nouvelle tâche',
      nouvelObjectif: 'Nouvel objectif',
      usage: 'Une petite chose à faire en dehors des interventions.',
      usageEquipe: 'Une petite chose à faire, pour vous ou pour un membre de votre équipe.',
      etapeQuoi: 'La tâche',
      etapeQui: 'Pour qui',
      etapeQuiAide: 'Vous, ou un membre placé en dessous de vous : il est prévenu.',
      etapeQuand: 'Quand',
      etapeQuandAide: 'Tout est facultatif : une date, une heure limite ou une place dans le planning.',
      quoi: 'Ce qu’il faut faire',
      quoiExemple: 'Ex. commander le filtre du camion 2',
      precisions: 'Précisions (facultatif)',
      priorite: 'Priorité',
      pourQui: 'Pour qui',
      moi: 'Moi',
      objectif: 'Objectif à une heure précise',
      objectifAide: 'Une heure limite et ce qui dit que c’est fini ; une photo sera demandée pour le marquer fait.',
      heureLimite: 'Heure limite',
      finiQuand: 'C’est fini quand… (facultatif)',
      finiQuandExemple: 'Ex. les trois filtres sont posés',
      pourLe: 'À faire pour le (facultatif)',
      planning: 'Dans le planning (facultatif)',
      planningAide: 'Une place à une heure dans votre planning ou celui de la personne.',
      planningVide: 'Choisir le jour et l’heure',
      duree: 'Durée dans le planning',
      durees: { m30: '30 min', m60: '1 h', m120: '2 h', m240: '4 h' },
      enregistrement: 'Enregistrement de la tâche',
      pret: 'Prête à enregistrer.',
      pretPlanning: 'Prête à enregistrer, avec sa place dans le planning.',
      ajouterTache: 'Ajouter à mes tâches',
      ajouterObjectif: 'Ajouter l’objectif',
      donnerTache: 'Donner la tâche à {nom}',
      donnerObjectif: 'Donner l’objectif à {nom}',
      manqueTitre: 'Dites ce qu’il faut faire.',
      heureInvalide: 'Choisissez une heure limite valide.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
    },
    page: {
      titre: 'Tâche',
      kicker: 'Tâche',
      kickerObjectif: 'Objectif',
      introuvable: 'Cette tâche n’existe plus, ou elle ne vous concerne pas.',
      usageAuteur: 'Changez ce qu’il faut faire, la personne ou la date ; elle est prévenue d’un changement de date.',
      usagePlanifier: 'Planifiez-la : la date et la place dans votre planning. Le reste est fixé par la personne qui l’a donnée.',
      usageFaite: 'Cette tâche est faite. Rouvrez-la si elle doit être reprise.',
      resume: 'La tâche',
      qui: 'Qui',
      faiteLe: 'Faite le',
      faiteResume: 'Rouverte, elle revient dans la liste des tâches à faire.',
      rouvrirZone: 'Rouvrir la tâche',
      etapePlanifier: 'Planifier',
      etapePlanifierAide: 'La date et la place dans votre planning.',
      heureFixee: 'Heure limite fixée par {nom} : {quand}.',
      enregistrement: 'Enregistrement de la tâche',
      enregistrer: 'Enregistrer',
      enregistree: 'Tâche enregistrée.',
      rienAChanger: 'Rien n’a changé.',
      prevenu: '{n} ; {nom} sera prévenu d’un changement de date.',
    },
  },
  // Absences de chacun : la demande et « Mes absences » (refonte v4 du 18/10/2026).
  absences: {
    etats: { en_attente: 'En attente', approuve: 'Acceptée', refuse: 'Refusée' },
    mes: {
      titre: 'Mes absences',
      usage: 'Demandez un congé ou une indisponibilité, puis suivez la réponse.',
      demander: 'Demander une absence',
      liste: 'Mes demandes d’absence',
      aucune: 'Aucune demande d’absence pour l’instant.',
      motif: 'Motif : {motif}',
      aideTitre: 'Comprendre les demandes d’absence',
      aide1: 'Un congé, une RTT, un arrêt ou une indisponibilité est d’abord une demande : le bureau l’accepte ou la refuse. Acceptée, elle bloque votre planning ; refusée, elle ne bloque rien et le motif s’affiche ici.',
      aide2: 'Vous êtes prévenu de la décision par une notification et par e-mail.',
    },
    demande: {
      titre: 'Demander une absence',
      usage: 'La demande part à la personne qui organise votre travail ; vous êtes prévenu de sa réponse.',
      usageDecideur: 'Vous décidez les absences : la vôtre est enregistrée tout de suite dans le planning.',
      etapeQuoi: 'Quelle absence ?',
      congeAide: 'Vacances, RTT, arrêt : une absence prévue.',
      indispoAide: 'Un rendez-vous ou une contrainte : vous n’êtes pas disponible.',
      ecole: 'Alternance : cocher ses jours d’école',
      etapeQuand: 'Quand ?',
      duree: 'Durée',
      journees: 'Journées entières',
      heures: 'Une partie de journée',
      du: 'Du',
      au: 'Au',
      debut: 'Début',
      fin: 'Fin',
      etapePrecision: 'Précision',
      etapePrecisionAide: 'Facultatif : ce que la personne qui décide doit savoir.',
      precision: 'Intitulé (facultatif)',
      precisionExemple: 'Ex. congés d’été',
      note: 'Note pour la personne qui décide (facultatif)',
      enregistrement: 'Envoi de la demande d’absence',
      pret: 'Prête à envoyer.',
      pretJours: '{n} jour(s), prête à envoyer.',
      envoyer: 'Envoyer la demande',
      enregistrer: 'Enregistrer l’absence',
      manqueQuand: 'Choisissez quand.',
      ordre: 'La fin doit suivre le début.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      suivre: 'Vous serez prévenu de la réponse ; la demande se suit dans Mes absences.',
      acceptee: 'Absence enregistrée dans le planning.',
      auPlanning: 'Elle bloque déjà la période dans votre planning.',
      retour: 'Revenir',
    },
  },
  // Espace Équipe : Disponibilités · Décisions (refonte v4 du 18/10/2026).
  equipe: {
    rubriques: 'Rubriques de l’équipe',
    disponibilites: {
      titre: 'Disponibilités',
      usage: 'Qui travaille, qui est absent, et l’agenda de chacun au jour choisi.',
      jour: 'Jour consulté',
      demain: 'Demain',
      autreJour: 'Autre jour',
      resume: 'La journée de l’équipe',
      disponibles: 'Disponibles',
      absents: 'Absents',
      interventions: 'Interventions',
      membres: 'Membres de l’équipe',
      aucun: 'Aucun membre actif.',
      terrain: 'Terrain',
      bureau: 'Bureau',
      rienDePrevu: 'Rien de prévu',
      vu: 'Planning vu le {quand}',
      modifieDepuis: ' — modifié depuis',
      jamaisVu: 'Planning jamais ouvert',
      absent: 'Absent',
      aValider: 'Absence à valider',
      tempsBloque: 'Temps bloqué',
      enIntervention: 'En intervention',
      disponible: 'Disponible',
      aideTitre: 'Comprendre les disponibilités',
      aide1: 'En intervention : une intervention de la personne est commencée et pas encore terminée. Disponible signifie qu’aucune absence confirmée ni journée d’école (alternance) ne couvre la journée. Le reste du temps bloqué (formation, trajet…) apparaît dans l’agenda de la personne.',
      aide2: '« Planning vu » indique la dernière fois que la personne a ouvert son planning. « Modifié depuis » signale qu’une de ses interventions à venir a changé après : pensez à la prévenir.',
      aide3: 'Une demande encore à valider est signalée séparément. Les interventions indiquent la charge prévue, pas les heures réellement travaillées.',
    },
    decisions: {
      titre: 'Décisions',
      usage: 'Les demandes d’absence que vous décidez : approuvez ou refusez, le membre est prévenu.',
      ongletsAria: 'État des demandes',
      aTraiter: 'À traiter',
      traitees: 'Traitées',
      planning: 'Voir le planning',
      approuver: 'Approuver',
      approuverAria: 'Approuver l’absence de {nom}',
      refuserAria: 'Refuser l’absence de {nom}',
      approuverTitre: 'Approuver cette absence ?',
      refuserTitre: 'Refuser cette absence ?',
      approuverConsequence: 'L’absence apparaîtra dans le planning et le membre sera prévenu.',
      refuserConsequence: 'Le refus ne bloque pas le planning ; le motif est transmis au membre.',
      confirmerApprobation: 'Approuver l’absence',
      confirmerRefus: 'Confirmer le refus',
      motifRefus: 'Motif du refus',
      motif: 'Motif du refus : {motif}',
      approuvee: 'Absence de {nom} approuvée : le planning est mis à jour, la personne est prévenue.',
      refusee: 'Absence de {nom} refusée : le motif lui est transmis.',
      aucuneATraiter: 'Aucune demande d’absence à traiter.',
      aucuneTraitee: 'Aucune décision prise pour l’instant.',
      aideTitre: 'Comprendre les décisions d’équipe',
      aide: 'Cette file contient les demandes d’absence que vous pouvez décider : celles des membres placés en dessous de vous. Une approbation bloque la période dans le planning ; un refus exige un motif. Dans les deux cas, la personne est prévenue.',
    },
    // Astreintes (décision du 19/10/2026) : facultatives, lues par tout membre.
    astreintes: {
      titre: 'Astreintes',
      usage: 'Qui répond aux urgences en dehors des heures, et qui est prévenu ensuite.',
      maintenant: 'Maintenant',
      maintenantAide: 'Pendant une astreinte, seuls la personne d’astreinte et le bureau prennent en charge une urgence.',
      personne: 'Personne n’est d’astreinte en ce moment : toute l’équipe peut prendre en charge une urgence.',
      jusqua: 'Jusqu’au {quand}',
      aVenir: 'À venir',
      aucune: 'Aucune astreinte planifiée.',
      aucuneAide: 'L’astreinte est facultative : sans elle, toute l’équipe peut prendre en charge une urgence.',
      roulement: 'Générer un roulement',
      ajouter: 'Ajouter une période',
      enCours: 'En cours',
      compteDesactive: 'Compte désactivé',
      tousSecteurs: 'Tous les secteurs',
      secteur: 'Secteur {secteur}',
      appeler: 'Appeler {nom}',
      circuit: 'En cas d’urgence',
      circuitAide: 'Qui est prévenu, dans quel ordre, quand personne ne répond.',
      circuitVide: 'Aucun circuit enregistré : le patron est prévenu dès le déclenchement.',
      circuitRegler: 'Régler le circuit',
      canalTitre: 'Alerte dans l’application seulement',
      canalAide: 'Les notifications sur téléphone (push) et les SMS ne sont pas encore disponibles : la personne d’astreinte est prévenue dans MyEquip, pas réveillée hors de l’application. Appelez-la en cas d’urgence.',
      circuitModifier: 'Modifier',
      sansMobile: 'Sans mobile',
      sansMobileAide: 'Sans numéro de mobile, cette personne ne reçoit pas les SMS d’urgence.',
      sms: {
        titre: 'SMS d’urgence',
        aide: 'Le SMS double la notification pour les urgences seulement, dans la limite d’un plafond par mois.',
        indisponible: 'Le SMS n’est pas encore activé sur MyEquip : les alertes partent par notification.',
        usage: '{envoyes} sur {plafond} SMS d’urgence ce mois-ci.',
        refuses: '{n} refusé(s) faute de place ce mois-ci.',
        plafond: 'Plafond mensuel',
        plafondAide: 'Au-delà, plus aucun SMS ne part : l’alerte continue par notification et par l’étape suivante. 0 coupe le SMS.',
        unite: 'SMS par mois',
      },
      attente: 'Attend {n} min avant l’étape suivante',
      etape: 'Étape {n}',
      introuvable: 'Cette période n’est plus à venir.',
      aideTitre: 'Comprendre les astreintes',
      aide1: 'L’astreinte est facultative. Sans période en cours, toute l’équipe peut prendre en charge une urgence, comme avant.',
      aide2: 'Pendant une astreinte, la prise en charge, l’appel au patron et la résolution d’une urgence sont réservés à la personne d’astreinte, à qui organise le planning et au patron. Une période liée à un secteur ne vaut que pour les urgences de ce secteur.',
      aide3: 'Le principal est prévenu en premier ; les renforts ensuite, selon le circuit d’urgence. Une absence prévue sur la période est signalée sans bloquer.',
    },
  },
  rapports: {
    titre: 'Rapport d’intervention',
    chargement: 'Chargement du rapport…',
    reessayer: 'Réessayer',
    horsLigneEnFile: 'Enregistré sur l’appareil : le rapport partira au retour du réseau.',
    horsLigneSurAppareil: 'Hors ligne : saisie gardée sur cet appareil. Le rapport commencera au retour du réseau.',
    checklistEnFile: 'Checklist enregistrée sur l’appareil : elle partira au retour du réseau.',
    checklistSurAppareil: 'Hors ligne : checklist gardée sur cet appareil. Elle partira avec le rapport au retour du réseau.',
    enAttenteEnvoi: 'En attente d’envoi',
    photosEnAttente: 'Photos en attente d’envoi',
    refuseeMotif: 'Refusée : {motif}',
    photoSurAppareil: 'Hors ligne : photo gardée sur cet appareil. Elle partira au retour du réseau, à l’heure de la prise.',
    signatureEnFile:
      'Signature enregistrée sur l’appareil : elle partira au retour du réseau, à l’heure où le client a signé.',
    signatureImpossibleEnFile:
      'Signature impossible enregistrée sur l’appareil : le bureau sera prévenu au retour du réseau.',
    pieceEnFile: '{piece} enregistrée sur l’appareil : elle partira au retour du réseau.',
    mesures: 'Mesures',
    mesuresAide: 'Pressions, surchauffe, sous-refroidissement et températures relevées.',
    mesureNombre: 'Indiquez un nombre, par exemple 18,5.',
    mesureHorsPlage: 'Une valeur entre {min} et {max} {unite} est attendue.',
    mesureEchec: 'La mesure n’a pas pu être enregistrée.',
    mesureEnFile: 'Mesure enregistrée sur l’appareil : elle partira au retour du réseau, à l’heure de la saisie.',
    mesureRefusee: 'Une mesure saisie hors ligne a été refusée : {motif}',
    clotureGestesRefuses:
      'Une saisie du rapport faite hors ligne a été refusée ou est en conflit : elle n’est pas sur le serveur. Réglez-la dans les envois en attente avant de terminer l’intervention.',
    clotureSaisieSurAppareil:
      'Une saisie du rapport est restée sur cet appareil : elle n’est pas encore sur le serveur et la fin de l’intervention figerait le rapport sans elle. Revenez à l’intervention pour la reprendre ; elle part dès que le réseau est là.',
    clotureSaisieSurAppareilCourt: 'Une saisie du rapport est restée sur l’appareil : reprenez-la avant de terminer l’intervention.',
    clotureRapportIlisible: 'Le rapport n’a pas pu être relu : réessayez avant de terminer l’intervention.',
    reprendreSaisie: 'Reprendre la saisie',
    compteRendu: 'Compte rendu',
    assistant: {
      mettreEnForme: 'Mettre en forme avec l’assistant',
      encours: 'Mise en forme en cours…',
      horsLigne: 'La mise en forme demande du réseau : vos notes restent sur l’appareil.',
      proposition: 'Proposition de l’assistant',
      pieces: 'Pièces citées',
      piecesAide: 'À ajouter dans Pièces et temps si elles ont été posées.',
      durees: 'Durées citées',
      dureesAide: 'À saisir dans Pièces et temps : rien n’est enregistré automatiquement.',
      travail: 'Travail',
      trajet: 'Trajet',
      relire: 'Relisez avant d’utiliser : l’assistant peut se tromper. Le texte remplace celui du rapport, que vous enregistrez ensuite comme d’habitude.',
      utiliser: 'Utiliser cette proposition',
      ignorer: 'Ignorer',
    },
    panneSignalee: 'Panne signalée',
    piecesUtilisees: 'Pièces utilisées',
    photosAvant: 'Photos avant',
    photosApres: 'Photos après',
    annoter: 'Annoter',
    signatureClient: 'Signature du client',
    signatureImpossible: 'Signature impossible',
    motifs: {
      client_absent: 'Client absent',
      client_indisponible: 'Client indisponible',
      client_refuse: 'Le client refuse de signer',
    },
    recommandations: 'Recommandations et travaux à prévoir',
    checklist: 'Checklist',
    // Texte changé par quelqu'un d'autre pendant la saisie (FLD-9) : rien n'est écrasé.
    conflit: {
      titre: '« {champ} » a changé pendant votre saisie',
      aide: 'Quelqu’un d’autre l’a modifié : choisissez la version à garder, ou réunissez les deux.',
      mienne: 'Ma version',
      serveur: 'Version enregistrée',
      garderMienne: 'Garder la mienne',
      garderServeur: 'Reprendre celle-ci',
      lesDeux: 'Réunir les deux',
      choisir: 'Choisissez d’abord quelle version garder pour chaque texte modifié entre-temps.',
      vide: 'Vide',
    },
  },
  // Photos d'un site (décision du 30/09/2026), ouvertes depuis la fiche client.
  chantier: {
    photosTitre: 'Photos — {site}',
    photosUsage:
      'Toutes les photos de ce site : rapports, carnets d’intervention, historique des machines et photos envoyées par le client.',
    aucunePhoto: 'Aucune photo pour ce site.',
    voirIntervention: 'Voir l’intervention',
    plusDePhotos: 'Voir plus de photos ({n} restantes)',
    sources: {
      rapport: 'Rapport',
      carnet: 'Carnet',
      historique: 'Historique',
      demande: 'Envoyée par le client',
    },
  },
  // « Il faut revenir » (décision du 30/09/2026).
  retour: {
    titre: 'Il faut revenir',
    usage:
      'Vous devez repasser ? Fixez la date : le client en est prévenu, et l’intervention de retour reprend le carnet et la liste « À prévoir » de celle-ci.',
    pourquoi: 'Pourquoi revenir ?',
    motifs: {
      piece: 'Il manque une pièce',
      travail: 'Le travail n’est pas fini',
      autre: 'Autre raison',
    },
    precision: 'Précision (facultatif)',
    jour: 'Jour du retour',
    heure: 'Heure',
    dureePrevue: 'Durée prévue',
    qui: 'Qui revient ?',
    moi: 'Moi',
    bureau: 'Le bureau choisira',
    autreTechnicien: 'Un autre technicien',
    quelTechnicien: 'Technicien',
    prevenir: 'Prévenir le client de la date',
    prevenirAide: 'Par e-mail, et par SMS si son numéro est connu.',
    prevenirAideSansSms: 'Par e-mail. L’envoi de SMS n’est pas encore disponible.',
    suite: 'Le technicien qui reviendra verra le carnet et la liste « À prévoir » de cette intervention.',
    valider: 'Planifier le retour',
    cree: 'Retour planifié le {date} à {heure}.',
    clientPrevenu: 'Le client va être prévenu.',
    ouvrir: 'Ouvrir l’intervention de retour',
    horsLigne:
      'Pas de réseau : l’intervention de retour se planifie en ligne. Réessayez au retour de la connexion.',
    visitesLiees: 'Interventions liées',
    retourPrevu: 'Intervention de retour',
  },
  // Trouver une pièce : scan, référence ou nom, et où elle se trouve.
  pieces: {
    chercher: 'Chercher une pièce',
    resultats: 'Pièces trouvées',
    chercherAide: 'Référence, code-barres ou nom — ou scannez l’étiquette.',
    scanner: 'Scanner',
    scannerTitre: 'Scanner le code de la pièce',
    scannerCamera: 'Ouvrir la caméra',
    viserCode: 'Visez le code-barres de l’étiquette ou de l’emballage.',
    photoEtiquette: 'Prendre l’étiquette en photo',
    photoNonDecodable:
      'Ce navigateur ne sait pas lire un code sur une photo : tapez la référence dans le champ de recherche.',
    codeIntrouvable: 'Aucun code lisible. Rapprochez-vous ou tapez la référence.',
    cameraIndisponible:
      'Caméra indisponible ici : prenez l’étiquette en photo ou tapez la référence.',
    saisieManuelle: 'Vous pouvez aussi taper la référence dans le champ de recherche.',
    recherche: 'Recherche…',
    aucunResultat: 'Rien dans le catalogue de l’entreprise pour « {q} ».',
    horsLigne: 'Hors ligne : catalogue de cet appareil ; stock de votre véhicule à la dernière synchronisation.',
    dansVotreVehicule: 'Dans votre véhicule : {qte}',
    auDepot: '{lieu} : {qte}',
    chezCollegue: '{lieu} ({personne}) : {qte}',
    pasEnStock: 'Pas en stock',
    autresEmplacements: '+ {n} autre(s) emplacement(s)',
    choisir: 'Choisir',
    changer: 'Changer de pièce',
    quantiteEntiere: 'Cette pièce se compte à l’unité : indiquez un nombre entier.',
    prendreDans: 'Prise dans',
    horsStock: 'Hors stock (achetée ou fournie sur place)',
  },
  // « À prévoir pour le retour » : ce qu'il faudra apporter ou commander.
  aPrevoir: {
    titre: 'À prévoir pour le retour',
    usage:
      'Ce qu’il faudra apporter ou commander pour la suite : une pièce, un outil ou autre chose. MyEquip dit où se trouve chaque pièce, ou qu’il faut la commander.',
    ajouter: 'Ajouter à prévoir',
    vide: 'Rien à prévoir pour l’instant.',
    types: { piece: 'Pièce', outil: 'Outil', autre: 'Autre' },
    typesAide: {
      piece:
        'Une pièce à apporter ou à commander : cherchez-la, scannez-la, ou décrivez-la si elle n’est pas au catalogue.',
      outil: 'Un outil ou du matériel à emporter la prochaine fois.',
      autre: 'Tout le reste : une nacelle, une clé d’accès, une personne à prévenir…',
    },
    typeLabel: 'Ce qu’il faut prévoir',
    introuvable: 'Pas dans le catalogue ? La décrire',
    designation: 'Désignation',
    reference: 'Référence (facultatif)',
    quantite: 'Quantité',
    note: 'Précision (facultatif)',
    aCommander: 'Il faut la commander',
    aCommanderAide: 'Le bureau la regroupera avec les autres commandes chez le fournisseur.',
    suffisantEnStock: 'En stock : il suffira de l’apporter.',
    insuffisant: 'Pas assez en stock : elle partira à commander.',
    enregistrer: 'Ajouter à la liste',
    ajoute: 'Ajouté à la liste.',
    miseEnFile:
      'Pas de réseau : l’élément est gardé sur l’appareil et partira au retour de la connexion.',
    statuts: {
      a_prevoir: 'À apporter',
      a_commander: 'À commander',
      commande: 'Commandé',
      pret: 'Prêt',
      annule: 'Annulé',
    },
    commandeNumero: 'Commandé — {numero}',
    marquerPret: 'C’est prêt',
    passerCommande: 'À commander',
    plutotApporter: 'Plutôt l’apporter',
    annuler: 'Retirer de la liste',
    annulerTitre: 'Retirer cet élément ?',
    annulerConsequence:
      'Il ne sera plus à apporter ni à commander. S’il figure déjà dans une commande, la commande reste inchangée.',
    enAttente: 'En attente de réseau',
    refusee: 'Refusé : {motif}',
    // Bureau : ce qui attend une commande.
    bureauTitre: 'À commander pour les interventions',
    bureauUsage:
      'Ce que les techniciens ont noté comme manquant. Cochez les éléments d’un même fournisseur pour en faire une demande d’achat.',
    bureauVide: 'Rien n’attend de commande.',
    fournisseurHabituel: 'Fournisseur habituel : {nom}',
    sansFournisseur: 'Pas de fournisseur habituel',
    pourIntervention: '{client} — {site}',
    fournisseur: 'Fournisseur de la commande',
    prixUnitaire: 'Prix unitaire HT (€)',
    creerCommande: 'Créer la demande d’achat ({n})',
    commandeCreee: 'Demande d’achat {numero} créée.',
    commandeAApprouver: 'Demande d’achat {numero} créée : elle attend l’approbation du patron.',
    maxLignes: 'Au plus {n} éléments par demande d’achat.',
  },
  // Dictée vocale : un seul composant (DictationButton) pour tous les champs de texte.
  dictee: {
    dicter: 'Dicter',
    dicterChamp: 'Dicter : {champ}',
    ecoute: 'J’écoute…',
    arreter: 'Arrêter la dictée',
    refusee: 'Le micro est refusé. Autorisez-le dans les réglages du navigateur, ou saisissez au clavier.',
    indisponible: 'Aucun micro n’est disponible sur cet appareil.',
    aucuneParole: 'Rien n’a été entendu. Réessayez en parlant près du micro.',
    reseau: 'La dictée a besoin du réseau. Saisissez au clavier ou réessayez au retour du réseau.',
    echec: 'La dictée a échoué. Réessayez ou saisissez au clavier.',
  },
  // Carnet d'intervention : notes prises AU FIL de l'intervention (décision du
  // 30/09/2026). La phrase d'usage reste visible : c'est elle qui dit à quoi
  // sert le carnet et qui le lira.
  carnet: {
    titre: 'Carnet d’intervention',
    usage:
      'Notez au fur et à mesure ce que vous faites, ce que vous voyez et où se trouvent les choses. Le technicien qui reviendra le lira ; le client ne voit que les notes que vous lui montrez.',
    nouvelleNote: 'Nouvelle note',
    aideSaisie: 'Texte ou photo : une photo seule suffit.',
    aideSaisieDictee: 'Texte, dictée ou photo : une photo seule suffit.',
    photosNonGardees: 'Les photos choisies ne sont gardées qu’une fois la note enregistrée.',
    ajouterPhoto: 'Photo',
    retirerPhoto: 'Retirer cette photo',
    montrerClient: 'Montrer cette note au client',
    montrerClientAide: 'Il la lira dans son espace, sans votre nom.',
    enregistrer: 'Ajouter au carnet',
    enregistrement: 'Enregistrement…',
    vide: 'Rien de noté pour l’instant. Notez dès que vous constatez quelque chose : vous n’aurez pas à vous en souvenir au moment du rapport.',
    videLecture: 'Rien n’a été noté dans ce dossier.',
    cetteVisite: 'Cette intervention',
    visiteDu: 'Intervention du {date}',
    visiteDuPar: 'Intervention du {date} — {technicien}',
    visibleClient: 'Visible par le client',
    enAttente: 'En attente de réseau — elle partira toute seule',
    refusee: 'Refusée : {motif}',
    photosAttente: '{n} photo(s) en attente d’envoi',
    publier: 'Montrer au client',
    depublier: 'Ne plus montrer au client',
    retirer: 'Retirer',
    corriger: 'Corriger',
    corrigerTitre: 'Corriger la note',
    corrigerAide: 'Seul le texte change ; les photos et la visibilité restent comme elles sont.',
    corrigerEnregistrer: 'Enregistrer la correction',
    corrigerEnregistrement: 'Enregistrement…',
    corrigee: 'Note corrigée.',
    corrigeeEnFile: 'Pas de réseau : la correction est gardée sur l’appareil et partira au retour de la connexion.',
    corrigerIntrouvable: 'Cette note n’existe plus ou n’est plus modifiable depuis cet appareil.',
    corrigerInterdit: 'Seul l’auteur corrige sa note, tant que l’intervention n’est pas terminée.',
    corrigerRien: 'Le texte n’a pas changé.',
    retirerTitre: 'Retirer cette note ?',
    retirerConsequence:
      'La note disparaît du carnet pour toute l’équipe et pour le client. L’entreprise en garde la trace.',
    fige: 'Intervention terminée : le carnet ne se modifie plus. Vous pouvez encore choisir ce que le client voit.',
    tropDePhotos: 'Au plus {n} photos par note.',
    tropLong: 'Au plus {n} caractères par note.',
    horsLigneLecture: 'Hors ligne : notes de cet appareil seulement.',
    erreurChargement: 'Le carnet n’a pas pu être chargé.',
    ajoutee: 'Note ajoutée au carnet.',
    miseEnFile:
      'Pas de réseau : la note est gardée sur l’appareil et partira au retour de la connexion.',
    ouvrirPhoto: 'Ouvrir la photo',
    vous: 'Vous',
  },
  stock: {
    depot: 'Dépôt',
    quarantaine: 'Quarantaine',
    reservation: 'Réservation',
    reserver: 'Réserver',
    // Prolonger ou libérer une pièce réservée (lot STK-4), fiche d'intervention et « À surveiller ».
    reservations: {
      prolonger: 'Prolonger de {jours} jours',
      liberer: 'Libérer la réservation',
      libererTitre: 'Libérer cette réservation ?',
      libererConsequence: '« {piece} » redevient disponible pour une autre intervention. Vous pourrez la réserver de nouveau.',
      prolongee: 'Réservation prolongée.',
      prolongeeEnFile: 'Prolongation gardée sur l’appareil ; elle s’appliquera au retour du réseau.',
      liberee: 'Réservation libérée.',
      libereeEnFile: 'Libération gardée sur l’appareil ; elle s’appliquera au retour du réseau.',
      echec: 'L’action a échoué. Réessayez.',
    },
    consommer: 'Consommer',
    transferer: 'Transférer',
    inventaire: 'Inventaire',
    seuilReappro: 'Seuil de réapprovisionnement',
    stockBas: 'Stock bas',
    suggestionsReassort: 'Suggestions de réassort',
    mouvements: {
      entree: 'Entrée',
      sortie: 'Sortie',
      ajustement: 'Ajustement',
      transfert: 'Transfert',
      retour: 'Retour',
      compensation: 'Compensation',
    },
    numeroSerie: 'Numéro de série',
    lot: 'Lot',
    expiration: 'Date d’expiration',
    consigne: 'Consigne',
    // Rubrique Matériel (refonte v4 du 17/10/2026) : accueil, listes et fiches du stock et des achats.
    materiel: {
      titre: 'Matériel',
      usage: 'Le stock et les achats : ce qu’il y a où, ce qu’il faut commander ou recevoir.',
      groupeStock: 'Stock',
      groupeStockAide: 'Ce que vous avez, où il se trouve, ce qui manque.',
      groupeAchats: 'Achats',
      groupeAchatsAide: 'Commander, recevoir, garder les factures.',
      tuiles: {
        stock: 'Ce qu’il y a où',
        articles: 'Articles',
        emplacements: 'Véhicules et dépôts',
        surveiller: 'À surveiller',
        inventaires: 'Inventaires',
        commandes: 'Commandes',
        fournisseurs: 'Fournisseurs',
        factures: 'Factures reçues',
        aCommander: 'À commander',
      },
      // Une ligne sous chaque tuile, sur ordinateur seulement (le téléphone garde la tuile seule).
      descriptions: {
        stock: 'Les quantités, véhicule par véhicule et dépôt par dépôt',
        articles: 'Les pièces et fournitures suivies, avec leurs seuils',
        emplacements: 'Où le matériel est rangé',
        surveiller: 'Réassorts, réservations et écarts à regarder',
        inventaires: 'Les comptages et les écarts à valider',
        commandes: 'Les commandes aux fournisseurs et leurs livraisons',
        fournisseurs: 'Vos fournisseurs et leurs coordonnées',
        factures: 'Les factures de vos fournisseurs',
        aCommander: 'Les besoins notés, prêts à être commandés',
      },
      compteurs: {
        aTraiter: 'à traiter',
        sousSeuil: 'sous le seuil d’alerte',
        aSurveiller: 'à recharger ou à régulariser',
        aReceptionner: 'à réceptionner',
        aReceptionnerOuApprouver: 'à réceptionner ou à approuver',
        aApprouver: 'à approuver',
        aCommander: 'à commander',
        aValider: 'à valider',
        ouverts: 'en cours',
      },
    },
    niveaux: {
      titre: 'Ce qu’il y a où',
      usage: 'Les quantités de chaque dépôt et de chaque véhicule. Le stock bouge avec les réceptions, les mouvements et les rapports.',
      usageVehicule: 'Ce que vous avez à bord. Déclarez ce que vous utilisez ou déplacez : le stock se met à jour.',
      rechercher: 'Référence, nom ou code-barres',
      emplacement: 'Emplacement',
      tous: 'Tous les emplacements',
      compte: '{n} ligne(s) de stock',
      enStock: 'en stock',
      mouvement: 'Enregistrer un mouvement',
      mettreAJour: 'Mettre à jour mon stock',
      vide: 'Rien n’est encore en stock ici. Le stock arrive par une réception de commande ou une entrée.',
      aucunResultat: 'Aucun article ne correspond ici.',
    },
    catalogue: {
      titre: 'Articles',
      usage: 'Ce que vous stockez : ouvrez un article pour voir où il se trouve et le commander.',
      nouveau: 'Nouvel article',
      rechercher: 'Référence, nom ou code-barres',
      afficher: 'Afficher',
      actifs: 'Articles du catalogue',
      sousSeuil: 'Sous le seuil d’alerte',
      sousSeuilCourt: 'Sous le seuil',
      archives: 'Articles archivés',
      categorie: 'Catégorie',
      toutes: 'Toutes',
      compte: '{n} article(s)',
      fournisseur: 'Fournisseur : {nom}',
      enStock: '{qte} en stock · {n} emplacement(s)',
      pasEnStock: 'Pas en stock',
      vide: 'Aucun article dans le catalogue. Ajoutez la première pièce ou le premier consommable que vous stockez.',
      aucunResultat: 'Aucun article ne correspond.',
    },
    lieux: {
      titre: 'Véhicules et dépôts',
      description: 'Chaque emplacement garde son propre stock et son historique. Touchez-en un pour voir ce qu’il contient.',
      nouveau: 'Nouvel emplacement',
      modifier: 'Modifier',
      groupes: { vehicule: 'Véhicules', depot: 'Dépôts', quarantaine: 'Zone de contrôle' },
      usage: {
        vehicule: 'Un petit dépôt roulant, conduit par un membre de l’équipe.',
        depot: 'Là où arrivent les livraisons et d’où partent les réassorts.',
        quarantaine: 'Les retours fournisseur y attendent une décision.',
      },
      aucun: {
        vehicule: 'Aucun véhicule. Ajoutez-en un pour suivre son stock.',
        depot: 'Aucun dépôt. Ajoutez celui où arrivent vos livraisons.',
        quarantaine: 'Aucune zone de contrôle.',
      },
      fiche: 'À propos de cet emplacement',
      type: 'Type',
      immatriculation: 'Immatriculation',
      sansImmatriculation: 'Immatriculation non renseignée',
      conduitPar: 'Conduit par',
      conduitParNom: 'Conduit par {nom}',
      personne: 'personne',
      references: '{n} référence(s)',
      bouteilles: '{n} bouteille(s) à bord',
      mouvementLe: 'dernier mouvement le {date}',
      dernierMouvement: 'Dernier mouvement',
      aucunMouvement: 'Aucun mouvement',
      systeme: 'Système',
    },
    surveiller: {
      titre: 'À surveiller',
      usage: 'Ce qui demande une action : les emplacements à recharger, les écarts à régulariser, le matériel réservé.',
      aRecharger: 'À recharger',
      aRechargerAide: 'Un véhicule se recharge au dépôt, un dépôt chez le fournisseur.',
      rienARecharger: 'Chaque emplacement a sa quantité habituelle.',
      manque: 'manquant',
      preparerTransfert: 'Préparer le transfert depuis le dépôt',
      commander: 'Commander',
      motifReassort: 'Réassort vers {lieu}',
      sansDepot: 'Aucun dépôt n’est défini : un véhicule ne peut pas être rechargé d’ici.',
      ecarts: 'Écarts à régulariser',
      ecartsAide: 'Stock négatif ou écart d’inventaire : à vérifier puis justifier.',
      aucunEcart: 'Aucun écart.',
      regulariser: 'Régulariser',
      regulariserTitre: 'Régulariser cet écart ?',
      regulariserConsequence: 'Le stock n’est pas modifié. La justification clôt l’écart et reste dans l’historique.',
      justification: 'Justification',
      cloreEcart: 'Clore l’écart',
      regularise: 'Écart régularisé ; la justification reste dans l’historique.',
      regulariserEchec: 'La régularisation a échoué.',
      reserve: 'Réservé pour une intervention',
      reserveAide: 'Mis de côté pour une intervention à venir : il n’est plus disponible pour une autre.',
      rienDeReserve: 'Rien n’est réservé.',
      gardeJusquau: 'Gardé jusqu’au {date}',
      dejaUtilise: '{qte} déjà utilisé',
      sousSeuilAilleurs: 'Les articles sous le seuil d’alerte sont dans le catalogue.',
      voirSousSeuil: 'Voir',
    },
    // Inventaires physiques (décision 15 du 19/10/2026) : liste, lancement, comptage au téléphone, validation.
    inventaires: {
      titre: 'Inventaires',
      kicker: 'Inventaire',
      usage: {
        ouverts: 'Comptez un dépôt ou un véhicule : les écarts corrigent le stock une fois validés.',
        a_valider: 'Inventaires comptés : vérifiez les écarts, puis validez.',
        termines: 'Inventaires validés ou annulés, gardés dans l’historique.',
      },
      vues: { ouverts: 'En cours', a_valider: 'À valider', termines: 'Terminés' },
      vide: {
        ouverts: 'Aucun inventaire en cours. Lancez celui d’un dépôt ou d’un véhicule.',
        a_valider: 'Aucun inventaire n’attend de validation.',
        termines: 'Aucun inventaire terminé pour l’instant.',
      },
      compte: '{n} inventaire(s)',
      nouveau: 'Nouvel inventaire',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      ligne: '{nom} · créé le {date}',
      avancement: '{compte} / {total} compté(s)',
      aApprouver: '{n} écart(s) à approuver',
      prochaine: {
        brouillon: 'Commencer le comptage',
        en_cours: 'Compter puis envoyer',
        a_valider: 'Valider les écarts',
        valide: 'Terminé',
        annule: 'Annulé',
      },
      etapes: {
        brouillon: 'Commencez quand vous êtes sur place : le stock attendu est relevé à ce moment-là.',
        en_cours: 'Saisissez ce que vous voyez, article par article. Les comptages sont enregistrés au fur et à mesure.',
        a_valider: 'Les petits écarts passent seuls ; les gros, les machines et les fluides attendent une approbation.',
        a_validerAttente: 'Des écarts dépassent les seuils : une personne autorisée à approuver les ajustements doit valider.',
        valide: 'Les écarts retenus ont corrigé le stock. Ils restent dans l’historique des mouvements.',
      },
      creation: {
        titre: 'Nouvel inventaire',
        usage: 'Choisissez le dépôt ou le véhicule à compter, puis qui en est responsable.',
        lieu: 'Que faut-il compter ?',
        lieuAide: 'Un seul inventaire à la fois par emplacement.',
        lieuLibelle: 'Emplacement à compter',
        aucunLieu: 'Aucun dépôt ni véhicule : créez d’abord un emplacement.',
        responsable: 'Qui en est responsable ?',
        responsableAide: 'Souvent la personne qui compte ; vous par défaut.',
        responsableLibelle: 'Responsable',
        moi: '{nom} (vous)',
        manqueLieu: 'Choisissez l’emplacement à compter.',
        pret: 'L’inventaire est créé en brouillon : le comptage commence quand vous le décidez.',
        creer: 'Créer l’inventaire',
        fait: 'Inventaire créé. Commencez le comptage une fois sur place.',
      },
      fiche: {
        introuvable: 'Cet inventaire n’existe pas.',
        resume: 'Repères',
        emplacement: 'Emplacement',
        responsable: 'Responsable',
        cree: 'Créé le',
        commence: 'Comptage commencé',
        valide: 'Validé',
        validePar: 'par {nom}',
        ecarts: 'Écarts',
        ecartsAide: 'Compté moins attendu, au moment du comptage.',
        aucunEcart: 'Aucun écart pour l’instant.',
        conformes: 'Comptés sans écart',
        nonComptes: 'Pas encore comptés',
        nonComptesAide: 'Un article non compté garde son stock.',
        attendu: 'attendu {qte}',
        compte: 'compté {qte}',
        ecart: 'Écart',
        valeur: '{montant} au prix d’achat',
        approbation: {
          auto: 'Validé seul',
          patron_requis: 'À approuver',
          approuve: 'Approuvé',
          refuse: 'Refusé',
        },
        lignesVides: 'Aucun article à cet emplacement : comptez ce que vous trouvez.',
      },
      gestes: {
        start: 'Commencer le comptage',
        count: 'Compter',
        continuer: 'Continuer le comptage',
        submit: 'Envoyer à valider',
        validate: 'Valider l’inventaire',
        reopen: 'Reprendre le comptage',
        cancel: 'Annuler l’inventaire',
      },
      confirmer: {
        start: {
          titre: 'Commencer le comptage ?',
          texte: 'Le stock attendu de {lieu} est relevé maintenant. Comptez ensuite ce qui s’y trouve vraiment.',
          bouton: 'Commencer',
        },
        submit: {
          titre: 'Envoyer l’inventaire à valider ?',
          texte: '{n} article(s) compté(s). Le stock ne change qu’à la validation.',
          texteNonComptes: '{n} article(s) compté(s) ; {reste} non compté(s) garderont leur stock. Le stock ne change qu’à la validation.',
          bouton: 'Envoyer',
        },
        cancel: {
          titre: 'Annuler cet inventaire ?',
          texte: 'Le stock n’est pas modifié. L’inventaire reste dans l’historique avec votre motif.',
          bouton: 'Annuler l’inventaire',
          motif: 'Motif',
        },
      },
      fait: {
        start: 'Comptage commencé : le stock attendu est relevé.',
        submit: 'Inventaire envoyé à valider.',
        submitApprouver: 'Inventaire envoyé : {n} écart(s) attendent une approbation.',
        reopen: 'Le comptage est rouvert.',
        cancel: 'Inventaire annulé ; le stock n’a pas changé.',
        compte: 'Comptage enregistré.',
        valide: 'Inventaire validé : {n} ajustement(s) appliqué(s) au stock.',
      },
      comptage: {
        titre: 'Compter',
        usage: 'Saisissez la quantité présente. « Conforme » reprend la quantité attendue ; un champ vidé efface le comptage.',
        rechercher: 'Nom, référence ou code-barres',
        aCompter: 'Articles de l’emplacement',
        aCompterAide: 'Touchez « Conforme » quand la quantité attendue est la bonne.',
        attendu: 'attendu {qte}',
        dejaCompte: 'enregistré : {qte}',
        conforme: 'Conforme',
        conformeLibelle: 'Conforme à l’attendu : {nom}',
        quantiteLibelle: 'Quantité comptée : {nom}',
        aucunResultat: 'Aucun article ne correspond. Un article trouvé hors liste s’ajoute ci-dessous.',
        ajouter: 'Article trouvé hors liste',
        ajouterAide: 'Une pièce présente mais pas prévue ici : ajoutez-la, puis comptez-la.',
        enregistrer: 'Enregistrer le comptage',
        aEnregistrer: '{n} comptage(s) à enregistrer.',
        rien: 'Saisissez au moins une quantité.',
        pret: 'Les comptages sont enregistrés sur le serveur ; vous pourrez continuer plus tard.',
        pasEnCours: 'Cet inventaire ne se compte plus : revenez à sa fiche.',
        illisible: 'Quantité illisible pour « {nom} ».',
        entier: '« {nom} » se compte à l’unité : indiquez un nombre entier.',
      },
      validation: {
        titre: 'Valider l’inventaire',
        usage: 'Les écarts retenus corrigent le stock de l’emplacement.',
        decider: 'Écarts à approuver',
        deciderAide: 'Au-delà des seuils de l’entreprise, ou sur une machine ou un fluide.',
        decision: 'Décision pour {nom}',
        approuver: 'Approuver',
        refuser: 'Refuser',
        verifier: 'Vérifier',
        verifierAide: 'Rien ne change avant votre confirmation.',
        bilan: '{n} ajustement(s) appliqué(s) au stock.',
        bilanRefus: '{n} écart(s) refusé(s) : le stock reste tel quel pour ces articles.',
        bilanNonComptes: '{n} article(s) non compté(s) gardent leur stock.',
        manqueDecision: 'Décidez de chaque écart à approuver ({n} restant).',
        sansDroit: 'Des écarts attendent l’approbation d’une personne autorisée à approuver les ajustements de stock.',
        pasAValider: 'Cet inventaire n’attend pas de validation.',
      },
      reglages: {
        titre: 'Inventaires',
        aide: 'Un écart d’inventaire plus petit que ces deux seuils corrige le stock sans approbation. Les machines et les fluides demandent toujours une approbation.',
        quantite: 'Écart de quantité validé seul jusqu’à',
        valeur: 'Écart de valeur validé seul jusqu’à',
        valeurAide: 'Au prix d’achat de l’article.',
        unites: 'unités',
      },
    },
    article: {
      kicker: 'Article',
      titre: 'Article',
      introuvable: 'Cet article n’existe plus.',
      ligne: '{reference} · {categorie} · se compte en {unite}',
      commander: 'Commander',
      mouvement: 'Enregistrer un mouvement',
      modifier: 'Modifier l’article',
      archiver: 'Archiver l’article',
      remettre: 'Remettre au catalogue',
      archiverTitre: 'Archiver cet article ?',
      archiverConsequence: 'Il quitte le catalogue et ne peut plus être commandé. Son stock et son historique restent ; vous pourrez le remettre au catalogue.',
      archiverConfirmer: 'Archiver',
      brouillonTitre: 'Article à vérifier',
      brouillon: 'Créé en brouillon par la lecture d’une facture : vérifiez-le, puis validez-le pour l’utiliser.',
      valider: 'Valider l’article',
      reperes: 'Repères de l’article',
      enStock: 'En stock',
      emplacements: '{n} emplacement(s)',
      reserve: 'Réservé',
      reserveAide: 'pour des interventions',
      enCommande: 'En commande',
      commandes: '{n} commande(s)',
      seuil: 'Seuil d’alerte',
      aucunSeuil: 'Aucun',
      sousSeuil: 'Sous le seuil : à commander',
      ou: 'Où il se trouve',
      ouAide: 'Quantité présente, réservée et habituelle de chaque emplacement.',
      nullePart: 'Pas encore en stock, ni d’emplacement prévu. Il entrera à la réception d’une commande.',
      aGarder: 'à garder : {qte}',
      sansDotation: 'pas de quantité habituelle',
      reserveIci: '{qte} réservé',
      commandesEnCours: 'Commandes en cours',
      aucuneCommande: 'Aucune commande n’attend cet article.',
      attendu: 'attendu',
      mouvements: 'Derniers mouvements',
      aucunMouvement: 'Aucun mouvement pour l’instant.',
      de: 'de {lieu}',
      vers: 'vers {lieu}',
      achatVente: 'Achat et vente',
      fournisseur: 'Fournisseur habituel',
      prixVente: 'Prix de vente HT',
      prixAchat: 'Prix d’achat HT',
      codeBarres: 'Code-barres',
    },
    articleForm: {
      ajouter: 'Ajouter un article',
      modifier: 'Modifier l’article',
      usage: 'Un article se crée une fois ; son stock arrive ensuite par une réception de commande ou une entrée.',
      etapeArticle: 'L’article',
      etapeArticleAide: 'Ce qui permet de le reconnaître et de le retrouver.',
      reference: 'Référence',
      referenceAide: 'Votre référence ou celle du fabricant',
      designation: 'Désignation',
      etapeType: 'Type et unité',
      etapeTypeAide: 'L’unité ne change plus une fois du stock enregistré, sauf d’« Unités » à « Mètres » pour un tube ou un câble.',
      type: 'Type d’article',
      types: {
        piece: 'Une pièce que l’on remplace : moteur, joint, carte…',
        consommable: 'Ce qui s’use ou se coupe : tube, collier, visserie…',
        machine: 'Un appareil complet, suivi par numéro de série.',
        gaz_fluide: 'Fluide au poids ou au volume. Les bouteilles se suivent dans Fluides.',
      },
      unite: 'Se compte en',
      unites: { unite: 'Unités', kg: 'Kilos', litre: 'Litres', metre: 'Mètres' },
      etapeAchat: 'Achat et vente',
      etapeAchatAide: 'Facultatif : préremplit vos commandes et vos devis.',
      fournisseur: 'Fournisseur habituel',
      aucunFournisseur: '— Aucun —',
      ajouterFournisseur: 'Ajouter un fournisseur',
      prixAchat: 'Prix d’achat HT (€)',
      prixAchatAide: 'Visible seulement des personnes qui voient les marges',
      prixVente: 'Prix de vente HT (€)',
      codeBarres: 'Code-barres (facultatif)',
      codeBarresAide: 'Pour retrouver l’article en scannant son étiquette',
      etapeRangement: 'Où le ranger',
      etapeRangementAide: 'La quantité à garder dans chaque emplacement. Ce qui manque apparaît dans « À surveiller ».',
      aGarderDans: '{lieu} : à garder ({unite})',
      ajouterEmplacement: 'Ajouter un emplacement',
      aucunEmplacement: 'Aucun dépôt ni véhicule pour l’instant.',
      seuil: 'Seuil d’alerte, tous emplacements ({unite})',
      seuilAide: 'Sous ce total, l’article est signalé à commander. Vide : pas d’alerte.',
      manqueReference: 'Donnez une référence à l’article.',
      manqueDesignation: 'Donnez une désignation à l’article.',
      manqueType: 'Choisissez le type d’article.',
      fournisseurDisparu: 'Ce fournisseur n’existe plus : choisissez-en un autre.',
      prixIllisible: 'Vérifiez les prix (ex. : 12,50).',
      quantiteIllisible: 'Vérifiez les quantités (ex. : 2 ou 1,5).',
      codeBarresIllisible: 'Le code-barres compte 4 à 32 chiffres ou lettres.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      enregistrement: 'Enregistrement de l’article',
      pretAjouter: 'L’article rejoint le catalogue. Son stock arrivera par une réception ou une entrée.',
      pretModifier: 'Les modifications s’appliquent aussitôt aux prochaines commandes et aux alertes.',
      enregistrer: 'Enregistrer l’article',
      ajoute: 'Article ajouté au catalogue.',
      misAJour: 'Article mis à jour.',
    },
    commandes: {
      titre: 'Commandes',
      nouvelle: 'Nouvelle demande d’achat',
      rechercher: 'Numéro ou fournisseur',
      compte: '{n} commande(s)',
      ligne: '{numero} · demandée par {nom}',
      toutes: 'Toutes',
      aReceptionner: 'À réceptionner',
      aApprouver: 'À approuver',
      enCours: 'En cours',
      terminees: 'Terminées',
      usage: {
        toutes: 'Chaque commande passe par : demande, approbation si besoin, envoi, puis réception qui fait entrer le matériel en stock.',
        a_receptionner: 'Envoyées et pas encore toutes arrivées : réceptionnez la livraison quand elle arrive.',
        a_approuver: 'Demandes au-delà du seuil d’approbation : approuvez-les ou refusez-les avec un motif.',
        en_cours: 'Commandes ni reçues, ni clôturées, ni annulées.',
        terminees: 'Commandes reçues, clôturées ou annulées.',
      },
      vide: {
        toutes: 'Aucune commande. Créez la première avec « Nouvelle demande d’achat ».',
        a_receptionner: 'Aucune livraison attendue : toutes les commandes envoyées sont reçues.',
        a_approuver: 'Aucune demande n’attend d’approbation.',
        en_cours: 'Aucune commande en cours.',
        terminees: 'Aucune commande terminée.',
      },
      aucunResultat: 'Aucune commande ne correspond.',
    },
    commande: {
      kicker: 'Commande fournisseur',
      titre: 'Commande',
      introuvable: 'Cette commande n’existe plus.',
      gestes: {
        approve: 'Approuver',
        refuse: 'Refuser la demande',
        send: 'Envoyer au fournisseur',
        receive: 'Réceptionner la livraison',
        ack: 'Noter l’accusé du fournisseur',
        cancel: 'Annuler la commande',
        close: 'Clôturer la commande',
        return: 'Retourner des pièces',
      },
      fait: {
        approve: 'Commande approuvée : elle peut partir chez le fournisseur.',
        refuse: 'Demande refusée ; son auteur est averti avec le motif.',
        send: 'Bon de commande et e-mail mis en file d’envoi. Le résultat se lit dans le suivi.',
        ack: 'Accusé du fournisseur noté.',
        cancel: 'Commande annulée ; son demandeur est averti avec le motif.',
        close: 'Commande clôturée.',
      },
      confirmer: {
        send: {
          titre: 'Envoyer ce bon de commande ?',
          texte: 'Le bon est figé, son PDF généré et l’e-mail mis en file pour le fournisseur.',
          sansEmail: 'Le bon est figé et son PDF généré. Ce fournisseur n’a pas d’e-mail : transmettez-le vous-même.',
          bouton: 'Confirmer l’envoi',
        },
        refuse: {
          titre: 'Refuser cette demande d’achat ?',
          texte: '{nom} est averti avec votre motif. La demande ne pourra plus être approuvée.',
          bouton: 'Refuser la demande',
        },
        cancel: {
          titre: 'Annuler cette commande ?',
          texte: '{nom} est averti avec votre motif. La commande ne pourra plus être envoyée.',
          texteEnvoyee: 'Le fournisseur l’a déjà reçue : prévenez-le aussi. {nom} est averti avec votre motif.',
          bouton: 'Annuler la commande',
        },
        close: {
          titre: 'Clôturer avec des lignes non reçues ?',
          texte: '{n} ligne(s) restent attendues : la clôture les abandonne, et elles restent visibles dans l’historique.',
          bouton: 'Clôturer',
        },
      },
      motifLibelle: 'Motif',
      etapes: {
        demande: 'La demande est enregistrée.',
        a_approuver: 'Au-delà du seuil d’approbation : un responsable l’approuve ou la refuse.',
        approuvee: 'Il reste à l’envoyer au fournisseur.',
        envoyee: 'À la livraison, réceptionnez-la : le matériel entre en stock.',
        partiellement_recue: 'Une partie est arrivée ; le reste est attendu.',
        recue: 'Tout est arrivé. La commande peut être clôturée.',
        cloturee: 'Commande terminée.',
        retournee: 'Du matériel est reparti chez le fournisseur.',
      },
      annulee: 'Commande annulée',
      motif: '« {motif} » — {nom}, le {date}',
      sansMotif: 'Annulée sans motif enregistré.',
      resume: 'Résumé',
      fournisseur: 'Fournisseur',
      sansEmail: 'Pas d’e-mail : bon de commande à transmettre vous-même',
      total: 'Total',
      demandeePar: 'Demandée par',
      livraisonPrevue: 'Livraison prévue',
      envoyee: 'Envoyée',
      accuse: 'Accusé du fournisseur',
      notes: 'Notes',
      voirFournisseur: 'Voir le fournisseur',
      lignes: 'Articles commandés',
      prixUnitaire: '{prix} HT l’unité',
      entreEnStock: 'entre en stock à la réception',
      horsCatalogue: 'hors catalogue : n’entre pas en stock',
      recu: 'reçu',
      factures: 'Factures reçues',
      facturesAide: 'Les factures du fournisseur rapprochées de cette commande.',
      aucuneFacture: 'Aucune facture rapprochée pour l’instant.',
      factureSansNumero: 'Facture sans numéro',
      suivi: 'Réceptions et retours',
      aucuneReception: 'Aucune réception pour l’instant.',
      reception: 'Réception du {date}',
      receptionDetail: '{nom} · {n} ligne(s) · rangée(s) : {lieu}',
      retour: 'Retour de {qte} : {article}',
      classer: 'Classer',
      retourFait: 'Retour enregistré : {qte} en zone de contrôle. Classez-le après vérification.',
    },
    retour: {
      titre: 'Retourner des pièces',
      description: 'Pièces reçues de {fournisseur} qui repartent : elles passent en zone de contrôle, puis vous les classez.',
      etape1: 'Quelle pièce ?',
      etape1Aide: 'Seules les pièces reçues et pas encore retournées sont proposées.',
      restant: '{qte} retournable(s) · {ref}',
      etape2: 'Combien, et d’où ?',
      etape2Aide: 'La pièce quitte ce lieu pour la zone de contrôle.',
      quantite: 'Quantité à retourner',
      lieu: 'Retirée de',
      etape3: 'Pourquoi ?',
      etape3Aide: 'Le motif reste dans l’historique de la commande et du stock.',
      motif: 'Motif du retour',
      motifExemple: 'Compresseur défectueux, mauvaise référence…',
      choisirPiece: 'Choisissez la pièce à retourner.',
      choisirLieu: 'Choisissez d’où part la pièce.',
      indiquerMotif: 'Indiquez le motif du retour.',
      pret: 'La pièce passe en zone de contrôle ; rien ne part chez le fournisseur avant votre classement.',
      confirmer: 'Confirmer le retour',
      pied: 'Confirmation du retour',
      aucune: 'Aucune pièce de cette commande ne peut être retournée : rien n’a été reçu, ou tout est déjà retourné.',
      sansDroit: 'Votre compte ne peut pas enregistrer de retour.',
      revenir: 'Revenir à la commande',
    },
    classement: {
      titre: 'Classer la pièce retournée',
      aide: '{qte} de {article}. Le classement est définitif.',
      vendable: 'Vendable',
      vendableAide: 'Contrôlée, en bon état : elle retourne en stock.',
      defectueuse: 'Défectueuse',
      defectueuseAide: 'Hors d’usage : elle reste en zone de contrôle.',
      a_reparer: 'À réparer',
      a_reparerAide: 'Réparable : elle reste en zone de contrôle.',
      retour_fournisseur: 'Renvoyée au fournisseur',
      retour_fournisseurAide: 'Elle sort du stock, un avoir est attendu.',
      destination: 'Remettre en stock à',
      choisirClasse: 'Choisissez un classement.',
      choisirDestination: 'Choisissez où remettre la pièce.',
      bouton: 'Classer',
      fait: 'Pièce classée : {classe}.',
    },
    fournisseurs: {
      titre: 'Fournisseurs',
      usage: 'Les entreprises chez qui vous commandez : elles reçoivent vos bons de commande.',
      nouveau: 'Nouveau fournisseur',
      rechercher: 'Nom, contact, téléphone ou ville',
      compte: '{n} fournisseur(s)',
      commandesEnCours: '{n} commande(s) en cours',
      sansEmail: '{tel} · pas d’e-mail : bons de commande à transmettre vous-même',
      sansCoordonnees: 'Ni téléphone ni e-mail',
      vide: 'Aucun fournisseur. Ajoutez celui chez qui vous commandez le plus souvent.',
      aucunResultat: 'Aucun fournisseur ne correspond.',
    },
    fournisseur: {
      kicker: 'Fournisseur',
      titre: 'Fournisseur',
      introuvable: 'Ce fournisseur n’existe plus.',
      commander: 'Commander',
      modifier: 'Modifier',
      archiver: 'Archiver le fournisseur',
      reactiver: 'Réactiver le fournisseur',
      archiverTitre: 'Archiver {nom} ?',
      archiverConsequence: 'Il quitte le carnet et ne reçoit plus de commande. Ses commandes passées restent ; vous pourrez le réactiver.',
      archiverConsequenceArticles: 'Il quitte le carnet et ne reçoit plus de commande ; {n} article(s) n’auront plus de fournisseur habituel. Ses commandes passées restent ; vous pourrez le réactiver.',
      archiverConfirmer: 'Archiver',
      archive: '{nom} est archivé.',
      archiveBadge: 'Archivé',
      archiveAide: 'Fournisseur archivé : il n’est plus proposé pour les commandes.',
      coordonnees: 'Coordonnées',
      contact: 'Interlocuteur',
      telephone: 'Téléphone',
      email: 'E-mail des commandes',
      sansEmailAide: 'Sans e-mail, le bon de commande se transmet par vos moyens.',
      adresse: 'Adresse',
      articles: 'Articles',
      nbArticles: 'Fournisseur habituel de {n} article(s)',
      commandes: 'Commandes',
      commandesAide: 'Les dix plus récentes ; le nombre compte celles en cours.',
      toutesCommandes: 'Toutes',
      aucuneCommande: 'Aucune commande chez ce fournisseur.',
    },
    fournisseurForm: {
      ajouter: 'Ajouter un fournisseur',
      modifier: 'Modifier le fournisseur',
      usage: 'Il recevra vos bons de commande et pourra être le fournisseur habituel d’un article.',
      etapeNom: 'Le fournisseur',
      nom: 'Nom du fournisseur',
      etapeJoindre: 'Comment le joindre',
      etapeJoindreAide: 'Facultatif. L’e-mail reçoit les bons de commande envoyés depuis MyEquip.',
      interlocuteur: 'Interlocuteur',
      telephone: 'Téléphone',
      email: 'E-mail des commandes',
      adresse: 'Adresse',
      adresseAide: 'Pour une livraison à retirer ou un retour de matériel ; hors de France, finissez par le pays (« , BE »).',
      manqueNom: 'Donnez le nom du fournisseur.',
      nomTropLong: 'Le nom compte 120 caractères au plus.',
      emailIllisible: 'Vérifiez l’adresse e-mail.',
      telephoneTropLong: 'Le téléphone compte 40 caractères au plus.',
      adresseTropLongue: 'L’adresse compte 500 caractères au plus.',
      rienAChanger: 'Modifiez au moins un champ.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      enregistrement: 'Enregistrement du fournisseur',
      avecEmail: 'Les bons de commande pourront lui être envoyés par e-mail.',
      sansEmail: 'Sans e-mail, le bon de commande se transmet par vos propres moyens.',
      enregistrer: 'Enregistrer le fournisseur',
      ajoute: 'Fournisseur « {nom} » ajouté.',
      misAJour: 'Fournisseur mis à jour.',
      conflitTitre: 'Modifié entre-temps',
      recharger: 'Recharger',
    },
    factures: {
      titre: 'Factures reçues',
      usageGestion: 'Tickets et factures payés par l’entreprise : photo de la pièce, total et TVA. Ils partent chez Pennylane avec la pièce.',
      usageSaisie: 'Vos tickets et factures payés (repas, carburant, fournitures) : photo de la pièce, total et TVA.',
      usageLues: 'Anciennes factures fournisseurs lues automatiquement, conservées pour consultation.',
      ajouter: 'Ajouter une facture reçue',
      commercantInconnu: 'Commerçant non renseigné',
      factureFournisseur: 'Facture fournisseur',
      noteDeFrais: 'Note de frais',
      noteDeFraisDe: 'Note de frais · {nom}',
      payeePar: 'Payée par {nom}',
      dontTva: 'dont TVA {tva}',
      dansPennylane: 'Dans Pennylane',
      venueDePennylane: 'Venue de Pennylane',
      supprimeeDansPennylane: 'Supprimée dans Pennylane',
      videSaisie: 'Aucune facture reçue. Ajoutez le premier ticket ou la première facture payée avec sa photo.',
      videLues: 'Aucune facture reçue pour le moment.',
      mesDepenses: 'Mes dépenses',
      mesDepensesUsage: 'Photographiez le ticket ou la facture dès que vous payez : il part en comptabilité avec sa TVA.',
      ajouterDepense: 'Ajouter une dépense',
      videDepenses: 'Aucune dépense. Au restaurant ou à la pompe, ajoutez le ticket avec « Ajouter une dépense ».',
    },
    aCommander: {
      titre: 'À commander',
      refuse: 'Regrouper les besoins en commande demande aussi le droit de proposer des achats.',
      aCocher: 'Éléments à commander',
      demande: 'Demande d’achat',
      demandeAide: 'Vérifiez le fournisseur et les prix avant de créer la demande.',
      choisir: 'Choisir un fournisseur',
      choisirFournisseur: 'Choisissez le fournisseur de la commande.',
      prixIllisible: 'Vérifiez les prix (ex. : 12,50).',
      pret: '{n} élément(s) dans la demande',
    },
    mouvement: {
      titre: 'Mouvement de stock',
      reassort: 'Transfert de réassort',
      usage: 'Dites ce qui s’est passé : le mouvement est gardé dans l’historique du stock.',
      etapeQuoi: 'Que s’est-il passé ?',
      type: 'Type de mouvement',
      types: {
        sortie: { titre: 'J’ai utilisé ou sorti du matériel', aide: 'La quantité est retirée de l’emplacement.' },
        entree: { titre: 'J’ajoute du matériel hors commande', aide: 'Stock de départ ou pièce retrouvée. Une livraison se reçoit sur sa commande.' },
        transfert: { titre: 'Je déplace du matériel', aide: 'Du dépôt vers un véhicule, ou l’inverse.' },
        ajustement: { titre: 'Je corrige après un comptage', aide: 'Inventaire : on remet la quantité réelle.' },
        retour: { titre: 'Retour de matériel', aide: 'Revient d’un site vers un emplacement.' },
      },
      etapePiece: 'La pièce',
      etapePieceAide: 'Cherchez-la par référence, nom ou code-barres, ou scannez son étiquette.',
      etapeOuCombien: 'Où et combien',
      sens: 'Sens de la correction',
      ilEnManque: 'Il en manque',
      enPlus: 'Il y en a en plus',
      emplacementCompte: 'Emplacement compté',
      depuis: 'Depuis',
      vers: 'Vers',
      retireDe: 'Retiré de',
      ajouteA: 'Ajouté à',
      choisir: 'Choisir',
      ecart: 'Écart constaté',
      quantite: 'Quantité ({unite})',
      motif: 'Motif',
      motifAide: 'Gardé dans l’historique.',
      exempleSortie: 'Ex. : remplacement chez le client',
      exempleAjustement: 'Ex. : inventaire mensuel',
      manqueType: 'Dites ce qui s’est passé.',
      manquePiece: 'Choisissez la pièce.',
      manqueEmplacement: 'Choisissez l’emplacement.',
      memeEmplacement: 'Choisissez deux emplacements différents.',
      quantiteIllisible: 'Vérifiez la quantité (ex. : 2 ou 1,5).',
      manqueMotif: 'Donnez un motif.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      enregistrement: 'Enregistrement du mouvement',
      pret: 'Le stock se met à jour aussitôt ; le mouvement reste dans l’historique.',
      enregistrer: 'Enregistrer le mouvement',
      enregistre: 'Mouvement enregistré.',
    },
    // Q82 (décision du 18/10/2026) : sans le droit des marges, aucun prix d'achat n'est demandé ni montré.
    aCommanderSansPrix: 'Vérifiez le fournisseur : les prix viennent du catalogue.',
    demandeAchat: {
      kicker: 'Achats',
      titre: 'Nouvelle demande d’achat',
      usage: 'La demande suit les règles d’approbation de votre entreprise ; rien ne part chez le fournisseur à l’enregistrement.',
      etapeFournisseur: 'Fournisseur',
      etapeFournisseurAide: 'Celui à qui vous commandez.',
      fournisseur: 'Fournisseur',
      chercherFournisseur: 'Rechercher un fournisseur',
      aucunFournisseur: 'Aucun fournisseur n’est enregistré dans votre entreprise.',
      ajouterFournisseur: 'Ajouter un fournisseur',
      autreFournisseur: 'Choisir un autre fournisseur',
      aucunResultat: 'Aucun fournisseur ne correspond à cette recherche.',
      etapeArticles: 'Articles',
      etapeArticlesAide: 'Un article du catalogue entre en stock à la réception.',
      etapeArticlesAideSansPrix: 'Un article du catalogue entre en stock à la réception ; son prix vient du catalogue.',
      lignes: 'Articles de la demande',
      ligne: 'Article {n}',
      catalogue: 'Article du catalogue {n}',
      horsCatalogue: '— Hors catalogue (frais, prestation…) —',
      designation: 'Article {n}',
      designationExemple: 'Désignation ou référence',
      quantite: 'Quantité',
      quantiteUnite: 'Quantité ({unite})',
      prixUnitaire: 'Prix unitaire HT (€)',
      prixAnnonce: 'Prix annoncé HT (€), facultatif',
      prixAnnonceAide: 'Sans prix, la demande passe par l’approbation.',
      retirer: 'Retirer',
      retirerAria: 'Retirer l’article {n}',
      ajouter: 'Ajouter un article',
      maxLignes: '{n} articles au plus par demande.',
      total: 'Total de la demande',
      totalHt: 'Total HT',
      etapeLivraison: 'Livraison et note',
      etapeLivraisonAide: 'Facultatif.',
      livraison: 'Date de livraison souhaitée (facultatif)',
      sansDate: 'Pas de date imposée',
      note: 'Note (facultatif)',
      noteAide: 'Visible sur la commande.',
      manqueFournisseur: 'Choisissez le fournisseur.',
      manqueDesignation: 'Donnez une désignation à chaque article.',
      manqueNombres: 'Vérifiez les quantités et les prix.',
      manqueEntiers: 'Une pièce à l’unité se commande en nombre entier.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      pret: 'Total {montant} HT. Après approbation si elle est requise, vous l’envoyez au fournisseur.',
      pretSansPrix: '{articles}. Après approbation si elle est requise, la commande part chez le fournisseur.',
      enregistrement: 'Enregistrement de la demande',
      enregistrer: 'Enregistrer la demande d’achat',
      creee: 'Demande d’achat créée.',
    },
    factureRecue: {
      kicker: 'Facture fournisseur',
      titre: 'Facture reçue',
      titreReference: 'Facture {reference}',
      introuvable: 'Cette facture reçue n’existe plus.',
      corriger: 'Corriger la saisie',
      supprimer: 'Supprimer la saisie',
      supprimee: 'Saisie supprimée : elle ne partira pas en comptabilité.',
      confirmerTitre: 'Supprimer cette saisie ?',
      confirmerTexte: 'Elle ne partira pas en comptabilité et disparaîtra de la liste. Sa trace reste dans le journal de l’entreprise.',
      montants: 'Montants',
      horsTaxes: 'Hors taxes',
      tva: 'TVA',
      totalTtc: 'Total TTC',
      details: 'Paiement et saisie',
      payeAvec: 'Payé avec',
      noteDeFrais: '{moyen} · note de frais',
      payePar: 'Payé par',
      intervention: 'Intervention',
      note: 'Note',
      saisie: 'Saisie',
      saisiePar: '{date} par {nom}',
      rejetee: 'Facture rejetée : elle ne part pas en comptabilité.',
      venueDePennylane: 'Venue de Pennylane avec sa pièce : elle se corrige là-bas, MyEquip suit.',
      paiementPennylane: 'Paiement d’après Pennylane',
      etatPaiement: 'État',
      resteAPayer: 'Reste à payer',
      echeance: 'Échéance',
      verifieLe: 'Vérifié le',
      supprimeePennylane: 'Supprimée dans Pennylane : elle reste ici en l’état, vérifiez avec la comptabilité.',
      journal: 'Voir le journal Pennylane',
      piece: 'Pièce',
      sansPiece: 'Aucune pièce jointe.',
      pieceInfectee: 'Pièce rejetée par l’antivirus : elle n’est ni affichée ni envoyée.',
      pieceAnalyseImpossible: 'Analyse antivirus impossible : renvoyez la pièce.',
      pieceAlt: 'Pièce : {nom}',
      ouvrirPiece: 'Ouvrir la pièce',
      ouvrirPdf: 'Ouvrir la facture (PDF)',
      corrections: 'Historique des corrections',
    },
  },
  devis: {
    titre: 'Devis',
    nouveau: 'Nouveau devis',
    options: 'Options sélectionnables par le client',
    marge: 'Marge',
    validite: 'Validité',
    envoyerPourSignature: 'Envoyer pour signature',
    signerEnLigne: 'Signer en ligne',
    acompte: 'Acompte',
  },
  factures: {
    titre: 'Factures',
    types: { facture: 'Facture', avoir: 'Avoir', acompte: 'Acompte', situation: 'Situation' },
    emettre: 'Émettre',
    immuableApresEmission: 'Émise : elle ne se modifie plus. Une correction passe par un avoir.',
    creerAvoir: 'Créer un avoir',
    paiements: 'Paiements',
    enregistrerPaiement: 'Enregistrer un paiement',
    moyens: {
      virement: 'Virement',
      cheque: 'Chèque',
      especes: 'Espèces',
      carte: 'Carte',
      // Encaissement constaté par le rapprochement bancaire du logiciel comptable.
      banque: 'Encaissement bancaire',
    },
    echeance: 'Échéance',
    relances: 'Relances',
    transmissionPdp: 'Transmission plateforme agréée',
    // Refonte v4 de l'espace Ventes (17/10/2026) : listes, fiches, saisies et page publique.
    aucuneLigne: 'Aucune ligne.',
    rubrique: 'Ventes',
    listeDevis: {
      usage: 'Préparez un devis, faites-le signer en ligne, puis facturez-le.',
      ongletsAria: 'État des devis',
      onglets: {
        tous: 'Tous',
        brouillon: 'Brouillons',
        envoye: 'Envoyés',
        consulte: 'Lus',
        accepte: 'Acceptés',
        refuse: 'Refusés',
        expire: 'Expirés',
        revise: 'Révisés',
        annule: 'Annulés',
      },
      recherche: 'Numéro ou client',
      rechercheLibelle: 'Rechercher un devis par numéro ou par client',
      compte: '{n} devis',
      aucun: 'Aucun devis pour l’instant. Créez le premier avec « Nouveau devis ».',
      aucunEtat: 'Aucun devis dans cet état.',
      aucunResultat: 'Aucun devis ne correspond à cette recherche.',
      duClient: 'Devis de {client}',
      tous: 'Tous les devis',
      tousDuClient: 'Tous ses devis',
      emisLe: '{numero} · émis le {date}',
      valableJusquau: 'valable jusqu’au {date}',
      ttc: 'TTC',
      ttcMarge: 'TTC · marge {marge}',
      prochaines: {
        brouillon: 'À vérifier puis envoyer au client',
        envoye: 'Envoyé — en attente de lecture',
        consulte: 'Lu par le client — en attente de signature',
        accepte: 'Signé : à facturer',
        refuse: 'Refusé — une révision reste possible',
        expire: 'Expiré — créez une révision pour le relancer',
        revise: 'Remplacé par une révision',
        annule: 'Annulé',
      },
    },
    listeFactures: {
      usage: 'Émettez la facture, suivez son paiement ; une facture émise se corrige par un avoir.',
      ongletsAria: 'État des factures',
      onglets: {
        toutes: 'Toutes',
        brouillon: 'Brouillons',
        emise: 'À encaisser',
        partiellement_payee: 'Payées en partie',
        en_retard: 'En retard',
        litigieuse: 'En litige',
        payee: 'Payées',
        creditee: 'Annulées par avoir',
      },
      recherche: 'Numéro ou client',
      rechercheLibelle: 'Rechercher une facture par numéro ou par client',
      compte: '{n} facture(s)',
      aucune: 'Aucune facture. Préparez-en une, ou facturez une intervention ou un devis accepté.',
      aucuneEtat: 'Aucune facture dans cet état.',
      aucunResultat: 'Aucune facture ne correspond à cette recherche.',
      duClient: 'Factures de {client}',
      toutes: 'Toutes les factures',
      toutesDuClient: 'Toutes ses factures',
      filtreType: 'Type de document',
      tousTypes: 'Tous les types',
      typesPluriel: { facture: 'Factures', avoir: 'Avoirs', acompte: 'Acomptes', situation: 'Situations' },
      brouillon: '(brouillon)',
      emiseLe: 'émise le {date}',
      payes: '{montant} payés',
      ttc: 'TTC',
      resteDu: 'reste dû',
      prochaines: {
        brouillon: 'À vérifier puis émettre',
        emise: 'À encaisser',
        emiseAvant: 'À encaisser avant le {date}',
        partiellement_payee: 'Reste {montant} à encaisser',
        en_retard: 'Échéance dépassée le {date}',
        litigieuse: 'En litige',
        payee: 'Payée',
        creditee: 'Annulée par avoir',
        avoir: 'Avoir émis : il réduit le reste dû de sa facture',
        avoirSur: 'Avoir sur {numero}',
      },
    },
    ficheDevis: {
      kicker: 'Devis {numero}',
      introuvable: 'Ce devis est introuvable.',
      emis: 'Émis le {date}',
      valable: 'valable jusqu’au {date}',
      envoyer: 'Envoyer pour signature',
      renvoyer: 'Renvoyer le lien',
      facturer: 'Facturer',
      reviser: 'Créer une révision',
      modifier: 'Modifier le brouillon',
      pdf: 'Voir le PDF',
      email: 'Envoyer le PDF par e-mail',
      annuler: 'Annuler le devis',
      supprimer: 'Supprimer le brouillon',
      pennylane: 'Devis fait dans Pennylane. Il se lit ici ; son document et toute correction se font dans Pennylane.',
      pennylanePresent: 'Présent chez Pennylane.',
      etapes: {
        brouillon: 'Vérifier puis envoyer au client',
        brouillonAide: 'Le client reçoit un lien sécurisé pour lire et signer le devis en ligne. Une fois envoyé, le devis est figé : une révision le remplace.',
        envoye: 'En attente de lecture',
        envoyeAide: 'Envoyé le {date}. Vous verrez ici quand le client l’aura lu ou signé.',
        consulte: 'Lu par le client, en attente de signature',
        consulteAide: 'Le client a ouvert le lien. Renvoyez-le s’il ne le retrouve plus.',
        accepte: 'Signé : à facturer',
        accepteAide: 'Signé par {signataire} le {date}. Facturez-le en une fois, ou par acompte et situations.',
        accepteFacture: 'Signé et facturé',
        accepteFactureAide: 'Signé par {signataire} le {date}. Tout le montant accepté est facturé.',
        refuse: 'Refusé par le client',
        expire: 'Expiré',
        expireAide: 'Sa date de validité est passée : créez une révision pour le relancer.',
      },
      refusMotif: 'Motif donné : « {motif} »',
      refusSansMotif: 'Le client n’a pas donné de motif. Une révision reste possible.',
      annule: 'Devis annulé',
      annuleMotif: 'Motif : {motif}',
      revise: 'Remplacé par la révision {numero}',
      ouvrirRevision: 'Ouvrir la révision',
      contenu: 'Contenu du devis',
      lignes: 'Lignes du devis',
      introduction: 'Introduction',
      reperes: 'Repères',
      valableJusquau: 'Valable jusqu’au',
      envoyeLe: 'Envoyé le',
      acompteSignature: 'Acompte à la signature',
      marge: 'Marge',
      liens: 'Documents liés',
      interventionPreparee: 'Intervention préparée',
      interventionPrepareeAide: 'Créée à la signature, à planifier',
      interventionOrigine: 'Intervention d’origine',
      remplace: 'Remplace le devis {numero}',
      remplacePar: 'Remplacé par le devis {numero}',
      facturation: 'Facturation',
      facturationAide: '{facture} facturés sur {accepte} acceptés',
      resteAFacturer: 'Reste à facturer : {montant}',
      annulerTitre: 'Annuler ce devis ?',
      annulerConsequence: 'Le devis ne pourra plus être signé : le lien envoyé au client est coupé et sa page dira que le devis est annulé. Cette action ne peut pas être défaite.',
      annulerMotif: 'Motif de l’annulation',
      annulerMotifExemple: 'Ex. : le client a choisi une autre solution',
      annulerConfirmer: 'Annuler le devis',
      annuleConfirme: 'Devis annulé : le lien de signature est coupé.',
    },
    envoiDevis: {
      kicker: 'Envoi pour signature',
      titre: 'Envoyer le devis {numero}',
      titreRenvoi: 'Renvoyer le lien du devis {numero}',
      client: 'Client : {client}',
      dejaEnvoye: 'Ce devis n’est plus à envoyer : il a été signé, refusé, annulé ou remplacé.',
      aucunContact: 'Ce client n’a encore aucun contact. Ajoutez la personne qui doit signer, avec son e-mail ou son téléphone, puis revenez ici.',
      ouvrirClient: 'Ouvrir la fiche client',
      aQui: 'À qui ?',
      aQuiAide: 'La personne choisie reçoit le lien de signature.',
      destinataire: 'Destinataire',
      pasEmail: 'Pas d’e-mail',
      pasTelephone: 'Pas de téléphone',
      moyen: 'Par quel moyen ?',
      moyens: 'Moyens d’envoi',
      emailAvec: 'À {email}, avec le PDF et le lien de signature',
      emailSans: 'Ce contact n’a pas d’adresse e-mail',
      smsAvec: 'Au {telephone}, avec le lien de signature',
      smsSans: 'Ce contact n’a pas de numéro de téléphone',
      smsInactif: 'L’envoi de SMS n’est pas encore activé',
      suite: 'Ce qui va se passer',
      suiteRecoit: '{contact} reçoit le lien sécurisé, envoyé par MyEquip au nom de votre entreprise.',
      suiteSigne: 'Il lit le devis en ligne, coche les options proposées, puis signe ou refuse.',
      suiteFige: 'Le devis est figé à l’envoi : pour le changer ensuite, vous créerez une révision.',
      suiteSignature: 'À la signature, une intervention à planifier est préparée et le matériel prévu est réservé.',
      suiteRenvoi: 'Le devis ne change pas ; le lien déjà envoyé reste valable jusqu’à la fin de validité.',
      relire: 'Relire le PDF avant d’envoyer',
      manque: 'Choisissez un destinataire et un moyen d’envoi.',
      pret: '{contact} · {moyens}',
      envoyer: 'Envoyer à {contact}',
      renvoyer: 'Renvoyer le lien à {contact}',
      envoi: 'Envoi…',
      envoye: 'Devis envoyé à {contact} par {moyens}. Vous verrez ici quand il l’aura lu ou signé.',
      renvoye: 'Lien renvoyé à {contact} par {moyens}.',
    },
    facturerDevis: {
      kicker: 'Devis {numero}',
      titre: 'Facturer le devis',
      usage: 'Préparez une facture en brouillon à partir de ce que le client a accepté.',
      introuvable: 'Ce devis est introuvable.',
      nonAccepte: 'Seul un devis signé par le client se facture.',
      toutFacture: 'Tout le montant accepté de ce devis est déjà facturé.',
      quoi: 'Que facturer ?',
      quoiAide: 'Accepté : {accepte} TTC · déjà facturé : {facture}',
      types: {
        facture: 'Facture complète',
        factureAide: 'Toutes les lignes acceptées, options cochées comprises.',
        factureIndisponible: 'Déjà facturé en partie : facturez le solde en situation à 100 %.',
        acompte: 'Acompte',
        acompteAide: 'Un pourcentage ou un montant, avant les travaux.',
        situation: 'Situation',
        situationAide: 'L’avancement des travaux, en pourcentage du devis.',
      },
      combien: 'Combien ?',
      acompteMode: 'Acompte en',
      modes: { pourcentage: 'Pourcentage', montant: 'Montant' },
      pourcentage: 'Pourcentage du devis (%)',
      montant: 'Montant TTC (€)',
      avancement: 'Avancement cumulé des travaux (%)',
      avancementAide: 'Déjà facturé : {pourcentage} du devis.',
      recapitulatif: 'Récapitulatif',
      recapAide: 'Le brouillon reprend la TVA des lignes du devis ; vérifiez-le puis émettez-le.',
      aFacturer: 'À facturer',
      apres: 'Reste après cette facture',
      problemes: {
        type: 'Choisissez ce que vous facturez.',
        nombre: 'Indiquez un nombre positif, avec une virgule si besoin.',
        depasse: 'Ce montant dépasse ce qui reste à facturer ({montant}).',
        avancement: 'L’avancement doit dépasser ce qui est déjà facturé ({pourcentage}) sans dépasser 100 %.',
        zero: 'Indiquez un acompte supérieur à zéro.',
      },
      pourcentageAucun: 'Ni le devis ni vos réglages ne prévoient d’acompte : indiquez-le.',
      action: 'Préparer la facture',
      enCours: 'Préparation…',
      prepare: 'Brouillon préparé depuis le devis {numero}. Vérifiez-le puis émettez-le.',
    },
    ficheFacture: {
      introuvable: 'Cette facture est introuvable.',
      brouillonDescription: 'Brouillon : modifiable jusqu’à son émission.',
      emiseLe: 'Émise le {date}',
      echeance: 'échéance le {date}',
      emettre: 'Émettre la facture',
      emettreAvoir: 'Émettre l’avoir',
      emettreTitre: 'Émettre ce document ?',
      emettreConsequence: 'Il reçoit son numéro définitif et devient immuable : ses lignes, ses montants et les coordonnées facturées ne changeront plus. Une correction passera par un avoir.',
      emettreConfirmer: 'Émettre',
      emise: 'Document émis sous le numéro {numero}.',
      modifier: 'Modifier le brouillon',
      modifierCourt: 'Modifier',
      paiement: 'Enregistrer un paiement',
      paiementCourt: 'Encaisser',
      paiementNom: 'Encaisser, enregistrer un paiement',
      pdf: 'Voir le PDF',
      pdfEmise: 'Voir et télécharger le PDF',
      pdfCourt: 'PDF',
      email: 'Envoyer par e-mail',
      avoir: 'Créer un avoir',
      avoirTitre: 'Créer un avoir ?',
      avoirConsequence: 'Un avoir du montant restant est préparé en brouillon. La facture émise reste immuable et son historique est conservé.',
      avoirMotif: 'Motif de l’avoir',
      avoirConfirmer: 'Créer l’avoir',
      avoirCree: 'Avoir préparé en brouillon : vérifiez-le puis émettez-le.',
      litige: 'Signaler un litige',
      litigeTitre: 'Signaler un litige ?',
      litigeConsequence: 'La facture passe « En litige » : ses relances automatiques s’arrêtent et un paiement vu par Pennylane n’est plus reporté seul. Levez le litige une fois réglé.',
      litigeMotif: 'Motif du litige',
      litigeConfirmer: 'Signaler le litige',
      litigeOuvert: 'Litige signalé : la facture est « En litige ».',
      leverLitige: 'Lever le litige',
      leverLitigeTitre: 'Lever le litige ?',
      leverLitigeConsequence: 'La facture reprend l’état donné par ses paiements, ses avoirs et son échéance ; les relances automatiques, si elles sont activées, reprennent tant qu’elle reste due.',
      leverLitigeMotif: 'Comment le litige a été réglé',
      leverLitigeConfirmer: 'Lever le litige',
      litigeLeve: 'Litige levé : nouvel état de la facture, {etat}.',
      temps: 'Reprendre le temps confirmé',
      tempsRepris: 'Main-d’œuvre et déplacement repris du temps confirmé.',
      tempsAJour: 'Le brouillon suit déjà le temps confirmé.',
      supprimer: 'Supprimer le brouillon',
      tauxARenseigner: 'Taux à renseigner',
      tauxARenseignerAide: 'Une ligne de main-d’œuvre ou de déplacement est à 0 € : indiquez son prix ou supprimez-la avant d’émettre, et réglez vos tarifs dans Mon entreprise › Ventes.',
      horsLigne: 'Brouillon préparé hors ligne : la validation du serveur est requise avant émission.',
      pennylane: 'Facture faite dans Pennylane. Elle se lit ici et compte dans vos chiffres ; son document et toute correction se font dans Pennylane.',
      pennylaneAttente: 'Envoi vers Pennylane en attente de l’état des lieux : la facture partira dès sa confirmation.',
      pennylaneEcart: '{ecart}. MyEquip ne réécrit jamais une facture émise : vérifiez dans Pennylane, puis corrigez par un avoir si besoin.',
      pennylaneSupprimee: 'Cette facture a été supprimée dans Pennylane. Elle reste ici, car une facture émise ne s’efface pas : vérifiez avec votre comptable.',
      pennylaneAVerifier: 'À vérifier avec Pennylane.',
      pennylaneRetenu: 'Encaissée d’après Pennylane, paiement non reporté.',
      pennylanePrerempli: '« Encaisser » est prérempli ({montant}).',
      pennylaneReport: 'Encaissée d’après Pennylane : le paiement est reporté automatiquement au prochain relevé.',
      contenu: 'Contenu de la facture',
      contenuAvoir: 'Contenu de l’avoir',
      lignes: 'Lignes de la facture',
      lignesPennylane: 'Le détail des lignes se trouve dans Pennylane.',
      totaux: 'Totaux de la facture',
      totalHt: 'Total HT',
      tva: 'TVA',
      tvaAutoliquidee: 'TVA autoliquidée',
      totalTtc: 'Total TTC',
      paye: 'Payé',
      avoirs: 'Avoirs',
      resteAPayer: 'Reste à payer',
      paiements: 'Paiements',
      paiementReporte: 'Reporté depuis Pennylane{reference}.',
      paiementReference: 'Référence : {reference}',
      paiementAnnule: 'Annulé le {date} : {motif}',
      paiementAnnulerAction: 'Annuler ce paiement',
      paiementActions: 'Actions de ce paiement',
      paiementAnnulerTitre: 'Annuler ce paiement ?',
      paiementAnnulerConsequence: 'Pour un paiement saisi par erreur. Il reste affiché, barré par une contre-écriture datée et motivée ; le reste à payer et l’état de la facture sont recalculés. Un remboursement au client se fait à part.',
      paiementAnnulerMotif: 'Pourquoi ce paiement est-il annulé ?',
      paiementAnnulerExemple: 'Ex. : saisi sur la mauvaise facture, montant erroné, chèque refusé',
      paiementAnnulerConfirmer: 'Annuler le paiement',
      paiementAnnuleOk: 'Paiement annulé. Nouvel état de la facture : {etat}.',
      envoiSansDestinataire: 'Aucun contact « facturation » de ce client, ni aucun autre contact non technique qui voit les documents, n’a d’adresse e-mail : la facture ne lui est pas envoyée automatiquement. Complétez la fiche client, ou envoyez-la depuis « … › Envoyer par e-mail ».',
      avoirsLies: 'Avoirs liés',
      avoirsAide: 'Chaque avoir s’ouvre pour être vérifié puis émis.',
      reperes: 'Repères',
      liens: 'Documents liés',
      devisOrigine: 'Devis {numero}',
      factureOrigine: 'Corrige la facture {numero}',
      intervention: 'Intervention facturée',
      electronique: 'Facture électronique',
      simulation: 'simulation',
      test: 'test',
    },
    paiement: {
      titre: 'Enregistrer un paiement',
      reste: '{client} · reste à payer {montant}',
      combien: 'Combien et comment ?',
      montant: 'Montant (€)',
      montantAide: 'Reste à payer : {montant}',
      moyen: 'Moyen de paiement',
      reference: 'Référence (facultatif)',
      referenceAide: 'N° de chèque, libellé du virement…',
      quand: 'Quand ?',
      date: 'Date du paiement',
      action: 'Enregistrer le paiement',
      nonAttendu: 'Cette facture n’attend plus de paiement.',
      positif: 'Indiquez le montant reçu en euros, par exemple 120,50.',
      depasse: 'Le montant dépasse le reste à payer ({montant}).',
      sansDate: 'Indiquez la date du paiement.',
      enregistre: 'Paiement enregistré dans MyEquip. Nouvel état de la facture : {etat}.',
    },
    relancesFacture: {
      titre: 'Relances',
      suspendre: 'Suspendre les relances de cette facture',
      suspendreTitre: 'Suspendre les relances ?',
      suspendreConsequence: 'Aucune relance automatique ne partira pour cette facture tant que vous ne les reprenez pas.',
      suspendreMotif: 'Motif (facultatif)',
      suspendreExemple: 'Ex. : échéancier accordé, client qui a prévenu de son paiement',
      suspendreConfirmer: 'Suspendre les relances',
      reprendre: 'Reprendre les relances',
    },
    categories: {
      services: 'Prestation de services',
      biens: 'Livraison de biens',
      mixte: 'Biens et services',
    },
    editeur: {
      nouveauDevis: 'Nouveau devis',
      nouvelleFacture: 'Nouvelle facture',
      modifierDevis: 'Modifier le devis {numero}',
      modifierFacture: 'Modifier la facture {numero}',
      modifierAvoir: 'Modifier l’avoir {numero}',
      reviser: 'Réviser le devis {numero}',
      descriptionNouveauDevis: 'Le client, les lignes à partir d’un barème ou librement, puis les conditions.',
      descriptionNouvelleFacture: 'Un brouillon : il ne reçoit son numéro définitif qu’à l’émission.',
      descriptionModifier: 'Un brouillon reste modifiable jusqu’à son envoi ou son émission.',
      descriptionReviser: 'La version envoyée reste telle quelle. La révision est un brouillon jusqu’à son envoi.',
      retourDocument: 'Retour au document',
      etapeClient: 'Client et site',
      etapeClientAide: 'Le client facturé et, s’il y a lieu, le site.',
      chantier: 'Site concerné (facultatif)',
      aucunChantier: 'Aucun site précis',
      etapeLignes: 'Lignes',
      etapeLignesAide: 'Ce que vous vendez : pièces, main-d’œuvre, déplacement.',
      methode: 'Comment remplir le devis ?',
      methodeBareme: 'À partir d’un barème',
      methodeBaremeAide: 'Vos lignes et vos prix ; ses questions remplissent les quantités.',
      methodeBaremeAucun: 'Aucun barème pour les devis : créez-en un dans Mon entreprise › Ventes.',
      methodeLibre: 'Lignes libres',
      methodeLibreAide: 'Vous saisissez chaque prestation, pièce ou déplacement.',
      etapeConditions: 'Conditions',
      etapeConditionsAide: 'Validité, acompte, TVA et texte d’introduction.',
      etapeRecap: 'Récapitulatif',
      etapeRecapAide: 'Vérifiez les montants avant d’enregistrer le brouillon.',
      enregistrer: 'Enregistrer le brouillon',
      creerRevision: 'Créer la révision',
      enregistrement: 'Enregistrement…',
      totaux: 'Totaux et enregistrement',
      pret: 'Total TTC : {montant}',
      terrain: 'Les devis préparés sur le terrain restent soumis aux limites fixées par l’entreprise.',
      prerempliIntervention: 'Devis rattaché à l’intervention du {date}.',
      prerempliDevis: 'Facture préparée d’après le devis {numero}.',
      prefillInvalide: 'Le client indiqué dans l’adresse est introuvable : choisissez-le.',
      enregistre: 'Brouillon enregistré. Vérifiez le PDF puis envoyez-le au client.',
      misAJour: 'Brouillon mis à jour.',
      revisionCreee: 'Révision créée. L’ancienne version reste consultable.',
      echeance: 'Date d’échéance du paiement',
      echeanceAide: 'Vide : calculée à l’émission selon vos conditions (« {conditions} »), soit le {date} pour une émission aujourd’hui.',
      echeanceAideSans: 'Vide : calculée à l’émission selon le délai de paiement de l’entreprise.',
      acompte: 'Acompte demandé à la signature (%)',
      acompteAide: 'Proposé d’après vos réglages ; 0 si aucun acompte.',
      remiseAncienne: 'Le type « Remise » n’existe plus : indiquez la remise en % sur la ligne concernée, ou changez le type de cette ligne.',
      typeRemiseAncien: 'Remise (ancien type)',
      mentions: 'Mentions e-facture',
      mentionsAide: 'Reprises de la fiche client et du site, figées à l’émission.',
      siren: 'SIREN du client',
      sirenRepris: 'Vide : {siren}, repris du SIRET de la fiche client.',
      sirenExige: 'Exigé à l’émission pour un client professionnel en France : saisissez-le ou complétez la fiche client.',
      sirenFacultatif: 'Facultatif pour ce client.',
      sirenInvalide: 'Le SIREN compte 9 chiffres.',
      categorie: 'Catégorie d’opération',
      livraison: 'Adresse de livraison',
      livraisonSite: 'Vide : adresse du site ({adresse}).',
      livraisonAucune: 'Facultative : à remplir si les biens sont livrés ailleurs qu’à l’adresse de facturation.',
      debits: 'TVA sur les débits : option de l’entreprise, imprimée sur la facture.',
      franchise: 'Franchise en base de TVA : aucune TVA, mention « TVA non applicable, art. 293 B du CGI » imprimée.',
      tvaNonApplicable: 'Non applicable',
      // Devis préparé sans réseau (FLD-12, décision 6).
      horsLigne: 'Hors ligne : clients, sites et catalogue gardés sur l’appareil. Le devis sera numéroté au retour du réseau.',
      clientsAppareil: 'Hors ligne : clients de vos interventions gardés sur l’appareil.',
      enFile: 'Devis gardé sur l’appareil : numéroté au retour du réseau, puis à envoyer au client depuis sa fiche.',
    },
    signature: {
      chargement: 'Chargement du devis…',
      lienInvalide: 'Ce lien de signature a expiré ou n’est plus valable.',
      kicker: 'Devis à signer',
      titre: 'Devis {numero}',
      pour: 'Pour {client}',
      valable: 'Valable jusqu’au {date}',
      lignes: 'Lignes du devis',
      option: 'Option',
      optionRetenue: 'Option retenue',
      choisirOption: 'Ajouter l’option « {libelle} »',
      totaux: 'Totaux du devis',
      socleHt: 'Total HT',
      optionsHt: 'Options retenues (HT)',
      totalTtc: 'Total TTC (hors options)',
      acompte: 'Acompte demandé à la signature',
      signer: 'Signer le devis',
      signerAide: 'Votre nom et votre accord valent signature électronique.',
      nom: 'Votre nom (signataire)',
      accord: 'Je reconnais avoir pris connaissance du devis et l’accepte (bon pour accord).',
      accepter: 'Signer en ligne',
      signature: 'Signature…',
      refuser: 'Refuser le devis',
      refuserCourt: 'Refuser',
      votreAccord: 'Votre accord',
      refuserTitre: 'Refuser ce devis ?',
      refuserConsequence: '{entreprise} sera prévenue de votre refus. Vous pourrez lui demander une nouvelle proposition.',
      refuserMotif: 'Pourquoi ? (facultatif)',
      refuserExemple: 'Ex. : budget, délai, autre solution',
      refuserConfirmer: 'Refuser le devis',
      manque: 'Indiquez votre nom et cochez votre accord pour signer.',
      etats: {
        accepte: 'Devis accepté',
        accepteAide: 'Signé par {signataire} le {date}. {entreprise} organise l’intervention et revient vers vous.',
        accepteSansSignataire: '{entreprise} organise l’intervention et revient vers vous.',
        refuse: 'Devis refusé',
        refuseAide: 'Merci de votre réponse. {entreprise} reste à votre disposition pour une nouvelle proposition.',
        expire: 'Devis expiré',
        expireAide: 'Sa date de validité est passée. Contactez {entreprise} pour une proposition à jour.',
        annule: 'Devis annulé',
        annuleAide: '{entreprise} a annulé ce devis. Contactez-la pour toute question.',
        revise: 'Devis remplacé',
        reviseAide: '{entreprise} vous a envoyé une nouvelle version de ce devis : ouvrez le lien de son dernier message.',
      },
      appeler: 'Appeler {entreprise}',
    },
    /** Libellés courts des actions de l'en-tête « Relances » (le libellé complet passe aux lecteurs d'écran). */
    relancesCourt: { suspendre: 'Suspendre', reprendre: 'Reprendre' },
  },
  fluides: {
    titre: 'Fluides frigorigènes',
    prochainControle: 'Prochain contrôle',
    teqco2: 'Tonnes éq. CO₂',
    // Refonte v4 (vague 3) : onglets, saisies, échéancier, fiche CERFA à étapes.
    kicker: 'Conformité réglementaire',
    retour: 'Fluides',
    usage: 'Bouteilles, contrôles d’étanchéité et fiches CERFA : la preuve du suivi de chaque gramme de fluide.',
    aide: {
      titre: 'Comprendre les fluides',
      chaine: 'Une bouteille part du dépôt, monte dans un véhicule et sert à charger ou récupérer du fluide sur une machine pendant une intervention. L’opération rejoint le registre, puis la fiche CERFA. Le fluide récupéré se déclare ensuite sur Trackdéchets (bordereau BSFF), avec les données de la fiche.',
      controles: 'Le contrôle d’étanchéité revient selon la charge de la machine : l’onglet Échéances montre les prochains, du plus urgent au moins urgent.',
      stock: 'Les bouteilles se déplacent depuis leur fiche ; le reste du matériel se gère dans Stock et véhicules.',
    },
    ongletsAria: 'Rubriques des fluides',
    detecteurs: {
      affichage: 'Détecteurs affichés',
      actifs: 'Détecteurs en service',
      avecRetires: 'Avec les détecteurs retirés',
      etats: { retire: 'Retiré', expire: 'Étalonnage échu', bientot: 'À renouveler', ok: 'Étalonné', sans_echeance: 'Sans échéance' },
      etalonnageAvant: 'Étalonnage valable jusqu’au {date}',
      sansEcheance: 'Aucune échéance d’étalonnage saisie',
      confieA: 'Confié à {nom}',
      renouveler: 'Renouveler l’étalonnage',
      retirer: 'Retirer le détecteur',
      retablir: 'Rétablir le détecteur',
      retirerTitre: 'Retirer ce détecteur ?',
      retirerAide: 'Il ne sera plus proposé pour les contrôles d’étanchéité. Les contrôles déjà faits avec lui restent inchangés ; vous pourrez le rétablir.',
      titreNouveau: 'Ajouter un détecteur de fuite',
      titreModifier: 'Modifier un détecteur de fuite',
      usage: 'Le détecteur sert aux contrôles d’étanchéité ; un rappel vous prévient 30 jours avant la fin de son étalonnage.',
      etapeIdentite: 'Le détecteur',
      numero: 'Numéro de série',
      modele: 'Modèle (facultatif)',
      etapeEtalonnage: 'Étalonnage',
      etalonnageAide: 'À renouveler à chaque étalonnage. Un détecteur échu ne peut plus servir aux contrôles.',
      dernierEtalonnage: 'Dernier étalonnage',
      echeance: 'Valable jusqu’au',
      echeanceAide: 'Date limite d’étalonnage : le rappel part 30 jours avant.',
      etapeConfie: 'Qui l’a en charge',
      confieAide: 'Facultatif. Cette personne reçoit aussi le rappel d’étalonnage.',
      confie: 'Confié à',
      personne: 'Personne en particulier',
      enregistrement: 'Enregistrement du détecteur',
      pret: 'Le détecteur sera enregistré avec son étalonnage.',
      enregistrer: 'Ajouter le détecteur',
      enregistrerModif: 'Enregistrer les modifications',
      manqueNumero: 'Saisissez le numéro de série du détecteur.',
      echeanceAvant: 'L’échéance précède le dernier étalonnage.',
      inchange: 'Aucune modification à enregistrer.',
      cree: 'Détecteur ajouté.',
      modifie: 'Détecteur modifié.',
    },
    onglets: {
      bouteilles: 'Bouteilles', echeances: 'Échéances', controles: 'Contrôles', cerfa: 'CERFA', registre: 'Registre', bsff: 'BSFF', detecteurs: 'Détecteurs',
    },
    aides: {
      detecteurs: 'Les détecteurs de fuite de l’entreprise et la fin de leur étalonnage.',
      bouteilles: 'Où sont vos bouteilles et ce qu’il en reste. Touchez-en une pour la déplacer, noter une charge ou la rendre.',
      echeances: 'Les machines à contrôler, de la plus urgente à la moins urgente.',
      controles: 'Les contrôles d’étanchéité enregistrés, du plus récent au plus ancien.',
      cerfa: 'Un brouillon se corrige ; une fiche validée ne se modifie plus.',
      registre: 'Chaque opération sur les fluides, de la réception des bouteilles à leur retour, avec le bilan de l’année.',
      bsff: 'Les fiches validées dont du fluide part au traitement : à déclarer sur Trackdéchets.',
    },
    actions: {
      ajouterBouteille: 'Ajouter une bouteille',
      ajouterDetecteur: 'Ajouter un détecteur',
      enregistrerControle: 'Enregistrer un contrôle',
      preparerCerfa: 'Préparer une fiche CERFA',
      releves: 'Relevés frigoristes',
      stock: 'Stock et véhicules',
      valider: 'Valider et signer',
      modifier: 'Modifier le brouillon',
      supprimer: 'Supprimer le brouillon',
      pdf: 'PDF officiel',
      recapitulatif: 'Récapitulatif PDF',
      copierBsff: 'Copier les données',
      donneesCopiees: 'Données copiées',
      ouvrirTrackdechets: 'Ouvrir Trackdéchets',
      declarerBsff: 'Déclarer sur Trackdéchets',
      enregistrerNumeroBsff: 'Enregistrer le numéro',
      inscrireOperation: 'Inscrire une opération',
      corriger: 'Corriger l’opération',
    },
    // Registre (CMP-7) : nature des opérations et du fluide (CERFA 15497 pour la charge et la récupération).
    operations: {
      charge: 'Charge', recuperation: 'Récupération', reception: 'Réception', retour: 'Retour',
      // Natures retirées en 0196, gardées pour les lignes anciennes du registre.
      controle_etancheite: 'Contrôle d’étanchéité (ancien)', transfert_bouteille: 'Transfert de bouteille (ancien)',
    },
    natures: {
      vierge: 'Fluide vierge', recycle: 'Fluide recyclé', regenere: 'Fluide régénéré',
      traitement: 'Destiné au traitement', reutilisation: 'Conservé pour réutilisation',
      achat: 'Achat ou livraison', inventaire: 'Stock déjà présent',
      regeneration: 'Pour régénération', destruction: 'Pour destruction', reprise: 'Non utilisé, repris',
    },
    naturesAide: {
      vierge: 'Fluide neuf, jamais utilisé.',
      recycle: 'Fluide récupéré puis réutilisé, comme celui d’une bouteille de récupération.',
      regenere: 'Fluide retraité par un centre agréé, vendu comme régénéré.',
      traitement: 'Il partira en régénération ou en destruction.',
      reutilisation: 'Il sera rechargé sur une machine du même détenteur.',
      achat: 'Bouteille achetée ou livrée par le distributeur : compte dans les achats de l’année.',
      inventaire: 'Bouteille déjà en stock avant MyEquip : compte dans le stock, pas dans les achats.',
      regeneration: 'Le fluide usagé part chez un centre qui le régénère.',
      destruction: 'Le fluide usagé part pour être détruit.',
      reprise: 'Fluide neuf non utilisé, repris par le distributeur.',
    },
    recherche: {
      libelle: 'Rechercher',
      bouteilles: 'Numéro ou fluide',
      machines: 'Client, site ou machine',
    },
    compte: {
      bouteilles: '{n} bouteille(s)',
      machines: '{n} machine(s)',
    },
    vides: {
      detecteurs: 'Aucun détecteur de fuite. Ajoutez celui que vous utilisez pour vos contrôles.',
      bouteilles: 'Aucune bouteille enregistrée.',
      echeances: 'Aucun contrôle à prévoir sur cette période.',
      controles: 'Aucun contrôle d’étanchéité enregistré.',
      cerfa: 'Aucune fiche CERFA.',
      cerfaCreer: 'Une fiche porte sur une intervention faite sur une machine : « Préparer une fiche CERFA » vous guide.',
      registre: 'Aucune opération enregistrée.',
      bsff: 'Aucune fiche validée avec du fluide envoyé au traitement.',
      bsffRefuse: 'Cette liste couvre toute l’entreprise : elle demande le droit Fluides.',
      recherche: 'Aucun résultat pour cette recherche.',
    },
    periodes: {
      libelle: 'Période',
      retard: 'En retard', '30j': 'Sous 30 jours', '90j': 'Sous 90 jours', tous: 'Toutes les machines',
    },
    echeance: {
      depassee: 'En retard depuis le {date}',
      avant: 'Avant le {date}',
      nonPrevue: 'Pas de date prévue',
      dernier: 'Dernier contrôle : {resultat}, le {date}',
      aucun: 'Jamais contrôlée',
      aRendre: 'Bouteilles à rendre',
      aRendreAide: 'À récupérer ou à faire détruire : à rapporter au fournisseur.',
    },
    ligne: {
      controle: 'Contrôlé le {date} par {nom}',
      prochain: 'Prochain contrôle le {date}',
      ficheNumero: 'Fiche n° {numero}',
      operationDu: 'Opération du {date}',
      creeeLe: 'Créée le {date}',
      aValider: 'À valider et signer',
      bouteille: 'Bouteille {numero}',
      nonAffectee: 'Non affectée',
      contenu: '{contenu} sur {capacite} kg',
      bsffFiche: 'Fiche {numero}',
      bsffADeclarer: 'À déclarer sur Trackdéchets',
      bsffDeclare: 'BSFF {numero}',
      saisiPar: 'saisi par {nom}',
      contrePassation: 'Contre-passation',
      corrigee: 'Corrigée',
      miseEnService: 'Mise en service',
      motif: 'Motif : {motif}',
      aVerifier: 'À vérifier',
      aVerifierAide: {
        contenu_insuffisant: 'Plus de fluide chargé que la bouteille n’en contenait.',
        contenu_depasse: 'Plus de fluide récupéré que la bouteille ne peut en contenir.',
      },
    },
    // Fluides et CERFA sans réseau (FLD-8, décision 6) : gardés sur l'appareil, envoyés au retour du réseau.
    horsLigne: {
      lecture: 'Hors ligne : ce qui est gardé sur l’appareil depuis la dernière synchronisation.',
      bouteilles: 'Hors ligne : les bouteilles de votre véhicule, telles que gardées sur l’appareil.',
      fiches: 'Hors ligne : les fiches de vos interventions gardées sur l’appareil.',
      machineAbsente: 'Cette machine n’est pas gardée sur l’appareil : retrouvez du réseau pour la choisir.',
      photoAppareil: 'Gardée sur l’appareil, envoyée au retour du réseau',
      mouvementEnFile: 'Opération gardée sur l’appareil : inscrite au registre au retour du réseau.',
      contenuAVerifier: 'Sans réseau, l’opération est inscrite quand même au retour du réseau, marquée « À vérifier » pour le bureau.',
      controleEnFile: 'Contrôle gardé sur l’appareil : enregistré au retour du réseau.',
      ficheEnFile: 'Fiche gardée sur l’appareil : enregistrée au retour du réseau.',
      signatureEnFile:
        'Fiche signée sur l’appareil : vérifiée et numérotée au retour du réseau. Si elle est incomplète, elle reste en brouillon et « Envois en attente » le dit.',
      validation:
        'Hors ligne : la fiche sera vérifiée au retour du réseau, puis numérotée. Faites signer maintenant ; un manque sera signalé à l’envoi.',
      apercuIndisponible: 'L’aperçu du formulaire officiel revient avec le réseau.',
      enAttente: 'En attente d’envoi',
      signatureEnAttente: 'Signée sur l’appareil : validation au retour du réseau',
      refusee: 'Refusée par le serveur : {motif}',
    },
    bilan: {
      titre: 'Bilan {annee}',
      annee: 'Année du bilan',
      aide: 'Par fluide, en kilogrammes, à l’heure du geste ; les corrections sont déduites.',
      vide: 'Aucun fluide en stock ni aucune opération cette année.',
      teq: 'Chargé en t éq. CO₂',
      operations: 'Opérations',
      lignes: {
        stockDebut: 'Stock au 1er janvier',
        achete: 'Acheté ou livré',
        inventaire: 'Stock déjà présent, enregistré',
        charge: 'Chargé',
        chargeNeuves: 'dont mises en service',
        chargeExistantes: 'dont machines en service',
        chargeVierge: 'dont vierge',
        chargeRecycle: 'dont recyclé',
        chargeRegenere: 'dont régénéré',
        recupere: 'Récupéré',
        recupereTraitement: 'dont destiné au traitement',
        recupereReutilisation: 'dont conservé pour réutilisation',
        remisRegeneration: 'Remis pour régénération',
        remisDestruction: 'Remis pour destruction',
        rendu: 'Rendu non utilisé',
        stockFin: 'Stock au 31 décembre',
      },
    },
    export: {
      titre: 'Exporter le registre',
      aide: 'Les opérations ou le bilan de l’année de toute l’entreprise, en fichier à archiver ou à présenter lors d’un contrôle.',
      annee: 'Année',
      contenu: 'Contenu',
      contenus: { operations: 'Opérations', bilan: 'Bilan annuel' },
      format: 'Format',
      formats: { pdf: 'PDF', xlsx: 'Excel', csv: 'CSV' },
      preparer: 'Préparer le fichier',
      preparation: 'Préparation…',
      enFile: 'Le fichier se prépare : une notification vous préviendra quand il sera prêt.',
    },
    trackdechets: {
      avertissement: 'MyEquip ne transmet rien à Trackdéchets. Recopiez les données sur trackdechets.beta.gouv.fr, puis enregistrez ici le numéro du bordereau obtenu.',
      numero: 'Numéro du bordereau BSFF',
      numeroAide: 'Celui que Trackdéchets vous a donné.',
      detenteur: 'Détenteur (émetteur)',
      machine: 'Machine',
      fluide: 'Fluide récupéré',
      quantite: 'Quantité envoyée au traitement',
      contenants: 'Contenants',
      adr: 'Catégorie ADR',
      destination: 'Installation de destination',
    },
    confirmations: {
      supprimerTitre: 'Supprimer ce brouillon CERFA ?',
      supprimer: 'Seul ce brouillon non signé est supprimé. Le registre et les autres preuves restent conservés.',
    },
    feuille: {
      kicker: 'Bouteille',
      contenu: 'Contenu',
      usage: 'Usage',
      lieu: 'Où elle se trouve',
      detenteur: 'Détenteur',
      aucun: 'Aucun',
      voirStock: 'Voir le stock de {lieu}',
      geste: 'Que faire ?',
      deplacer: 'Déplacer',
      deplacerAide: 'Vers un véhicule ou le dépôt',
      charge: 'Charge',
      chargeAide: 'Fluide mis dans une machine',
      recuperation: 'Récupération',
      recuperationAide: 'Fluide repris d’une machine',
      rendre: 'Rendre',
      rendreAide: 'Au fournisseur ou au collecteur',
      continuer: 'Continuer',
      destination: 'Nouvel emplacement',
      deplacee: 'Bouteille déplacée.',
      rendue: 'Rendue au fournisseur : elle ne se déplace plus.',
      enCours: 'Enregistrement…',
      retourNature: 'Le fluide qu’elle contient',
      rendreBouteille: 'Rendre la bouteille',
      confirmerRetour: 'Confirmer le retour',
      retourConsequence: 'Définitif : la bouteille sort de l’entreprise avec ses {contenu} kg, inscrits au registre. Elle ne se déplace plus et rien ne s’y inscrit ensuite.',
      retourInscrit: 'Bouteille rendue : le retour est inscrit au registre.',
    },
    nouvelleOperation: {
      titre: 'Inscrire une opération',
      usage: 'Une charge ou une récupération de fluide sur une machine, depuis une bouteille : elle rejoint le registre et la fiche CERFA de l’intervention.',
      etapeBouteille: 'La bouteille et l’opération',
      etapeMachine: 'La machine',
      etapeQuantite: 'La quantité',
      etapeQui: 'Qui et quand',
      chercherBouteille: 'Chercher la bouteille',
      changerBouteille: 'Changer de bouteille',
      contenu: 'Contenu',
      operation: 'Opération',
      recuperationImpossible: 'Le fluide récupéré va dans une bouteille de récupération.',
      fluidesDifferents: 'La bouteille contient du {bouteille}, la machine est notée {machine} : vérifiez avant d’inscrire.',
      intervention: 'Intervention',
      horsIntervention: 'Hors intervention',
      interventionAide: 'La fiche CERFA de l’intervention reprend la quantité.',
      quantiteChargee: 'Quantité chargée (kg)',
      quantiteRecuperee: 'Quantité récupérée (kg)',
      resteBouteille: 'Il restera {reste} kg dans la bouteille.',
      nature: 'Nature du fluide',
      natureRecuperee: 'Devenir du fluide récupéré',
      recyclageConfirme: 'Recharger avec le fluide récupéré',
      recyclageAide: 'Fluide repris d’une machine du même détenteur ; il est inscrit comme recyclé.',
      miseEnService: 'Mise en service d’une machine neuve',
      miseEnServiceAide: 'Première charge de la machine : comptée à part dans le bilan.',
      operateur: 'Opérateur',
      operateurAide: 'Celui qui a fait le geste. Vous restez inscrit comme auteur de la saisie.',
      sansAttestation: '{nom} (sans attestation d’aptitude)',
      moi: 'Vous',
      attestationManquante: 'Votre attestation d’aptitude fluides n’est pas enregistrée : demandez au patron de l’ajouter à votre fiche de membre.',
      quand: 'Quand',
      maintenant: 'Maintenant',
      autreJour: 'Un autre jour',
      jour: 'Jour de l’opération',
      jourAide: 'Jusqu’à {jours} jours en arrière.',
      enregistrement: 'Inscription au registre',
      pret: 'L’opération rejoint le registre ; une erreur se corrige ensuite par une contre-passation.',
      inscrire: 'Inscrire au registre',
      inscrite: 'Opération inscrite au registre.',
      manqueBouteille: 'Choisissez la bouteille.',
      manqueOperation: 'Choisissez l’opération.',
      manqueMachine: 'Choisissez la machine.',
      manqueQuantite: 'Indiquez la quantité en kilogrammes, par exemple 0,5.',
      bouteilleInsuffisante: 'La bouteille ne contient que {contenu} kg.',
      bouteillePleine: 'La bouteille déborderait : capacité {capacite} kg.',
      manqueRecyclage: 'Confirmez la recharge avec le fluide récupéré.',
      manqueOperateur: 'Choisissez un opérateur titulaire d’une attestation d’aptitude.',
      manqueJour: 'Choisissez le jour de l’opération.',
      introuvable: 'Cette bouteille, cette machine ou cette intervention n’est pas accessible : choisissez-la.',
    },
    correction: {
      titre: 'Corriger une opération',
      usage: 'Le registre ne s’efface pas : une contre-passation annule l’opération, avec votre motif, et la bonne quantité s’inscrit à côté.',
      etapeOperation: 'L’opération inscrite',
      etapeCorrection: 'La correction',
      etapeMotif: 'Le motif',
      quand: 'Geste du',
      quantite: 'Quantité',
      bouteille: 'Bouteille',
      machine: 'Machine',
      operateur: 'Opérateur',
      choix: 'Que corriger ?',
      annuler: 'L’opération n’a pas eu lieu',
      annulerAide: 'Elle est annulée ; rien ne la remplace.',
      quantiteFausse: 'La quantité était fausse',
      quantiteFausseAide: 'Elle est annulée et la bonne quantité s’inscrit à sa place.',
      bonneQuantite: 'Bonne quantité (kg)',
      motif: 'Motif de la correction',
      motifAide: 'Il reste dans le registre et dans le journal d’audit.',
      enregistrement: 'Contre-passation',
      pret: 'La correction est définitive : elle reste visible dans le registre.',
      corriger: 'Contre-passer l’opération',
      confirmerTitre: 'Contre-passer cette opération ?',
      confirmer: 'Une ligne d’annulation s’ajoute au registre avec votre motif ; elle ne se supprime pas. Le contenu de la bouteille est recalculé.',
      corrigee: 'Opération corrigée.',
      dejaCorrigee: 'Cette opération a déjà été corrigée ou ne se corrige pas.',
      manqueChoix: 'Choisissez ce qui est faux.',
      manqueQuantite: 'Indiquez la bonne quantité en kilogrammes.',
      memeQuantite: 'C’est la quantité déjà inscrite.',
      manqueMotif: 'Expliquez la correction en quelques mots.',
    },
    nouvelleBouteille: {
      titre: 'Ajouter une bouteille',
      usage: 'Une bouteille suivie par son numéro : son fluide, ce qu’elle contient et où elle se trouve.',
      etapeBouteille: 'La bouteille',
      etapeContenu: 'Ce qu’elle contient',
      etapeLieu: 'Où elle se trouve',
      numero: 'Numéro de la bouteille',
      numeroAide: 'Gravé ou étiqueté sur la bouteille.',
      fluide: 'Fluide',
      usageBouteille: 'Usage',
      capacite: 'Capacité (kg)',
      contenuActuel: 'Contenu actuel (kg)',
      contenuAide: 'Une bouteille neuve de charge est pleine ; une bouteille de récupération est vide.',
      origine: 'D’où vient ce contenu ?',
      lieu: 'Emplacement',
      depot: 'Pas encore rangée',
      consignee: 'Bouteille consignée',
      oui: 'Oui', non: 'Non',
      enregistrement: 'Enregistrement de la bouteille',
      pret: 'La bouteille rejoint la liste ; elle se déplace ensuite depuis sa fiche.',
      enregistrer: 'Enregistrer la bouteille',
      enregistree: 'Bouteille {numero} enregistrée.',
      manqueNumero: 'Indiquez le numéro de la bouteille.',
      manqueFluide: 'Choisissez le fluide.',
      manqueCapacite: 'Indiquez la capacité en kilogrammes, par exemple 12 ou 12,5.',
      manqueContenu: 'Indiquez le contenu en kilogrammes.',
      tropPleine: 'Le contenu dépasse la capacité.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      fluideAbsent: 'Fluide absent de la liste',
      fluideAbsentResponsable: 'Fluide absent de la liste : demandez à votre responsable de l’ajouter.',
    },
    referentiel: {
      aVerifier: '{code} (à vérifier)',
      prgListe: 'PRG {prg}, liste des fluides MyEquip.',
      prgAVerifier: 'PRG {prg}, ajouté par votre entreprise : à vérifier.',
      prgAbsent: 'Fluide absent de la liste : indiquez son PRG, ou ajoutez-le depuis Fluides.',
      corriger: 'Corriger le PRG de {code}',
    },
    correctionFluide: {
      titre: 'Corriger un fluide ajouté',
      usage: 'Le PRG et la famille d’un fluide ajouté par votre entreprise. Ses machines reprennent le PRG corrigé ; les opérations déjà inscrites au registre gardent le leur.',
      introuvable: 'Ce fluide n’est pas dans la liste de votre entreprise.',
      liste: '{code} appartient à la liste MyEquip : son PRG officiel ne se modifie pas.',
      etape: 'Famille et PRG de {code}',
      enregistrement: 'Correction du fluide',
      pret: 'Le fluide reste « à vérifier ».',
      enregistrer: 'Enregistrer la correction',
      inchange: 'Modifiez la famille ou le PRG.',
      enregistre: '{code} corrigé : {n} machine(s) mise(s) à jour.',
    },
    nouveauFluide: {
      titre: 'Ajouter un fluide',
      usage: 'Un fluide absent de la liste MyEquip. Il reste « à vérifier » : ses machines sont contrôlées au moins tous les 12 mois.',
      etapeFluide: 'Le fluide',
      designation: 'Désignation',
      designationAide: 'Comme sur la bouteille, par exemple R-449A.',
      dejaListe: '{code} figure déjà dans la liste.',
      reference: '{code} est dans la liste MyEquip : il est ajouté avec son PRG officiel ({prg}).',
      etapeFamille: 'Famille et PRG',
      familleAide: 'La fiche technique du fluide les indique.',
      famille: 'Famille',
      familles: {
        HFC: 'HFC ou mélange contenant un HFC',
        HFO: 'HFO',
        HCFC: 'HCFC',
        naturel: 'Non fluoré (CO₂, ammoniac, hydrocarbure)',
        inconnue: 'Je ne sais pas',
      },
      prg: 'PRG (GWP)',
      prgAide: 'Nombre entier, de 0 à 30 000.',
      enregistrement: 'Ajout du fluide',
      pret: 'Le fluide rejoint la liste de votre entreprise, marqué « à vérifier ».',
      enregistrer: 'Ajouter le fluide',
      enregistre: '{code} ajouté à la liste des fluides.',
      manqueDesignation: 'Indiquez la désignation du fluide.',
      manqueFamille: 'Choisissez la famille du fluide.',
      manquePrg: 'Indiquez le PRG en nombre entier.',
    },
    nouveauControle: {
      reparation: {
        titre: 'Planifier la réparation de la fuite',
        aide: 'Rien n’a été créé : l’intervention de réparation s’ouvre préremplie, à vérifier. Le recontrôle est dû aujourd’hui dans l’échéancier.',
        planifier: 'Planifier la réparation',
        plusTard: 'Plus tard',
      },
      titre: 'Enregistrer un contrôle d’étanchéité',
      usage: 'Le résultat du contrôle d’une machine : il fixe la date du prochain.',
      etapeMachine: 'La machine',
      client: 'Client',
      machine: 'Machine',
      etapeResultat: 'Le résultat',
      etapeDetails: 'Détecteur, notes et photos',
      etapeDetailsAide: 'Facultatif, sauf le détecteur si vous en avez utilisé un.',
      chercher: 'Chercher la machine',
      changerMachine: 'Changer de machine',
      intervention: 'Intervention',
      retirerIntervention: 'Enregistrer hors de cette intervention',
      dernier: 'Dernier contrôle',
      resultat: 'Résultat du contrôle',
      resultats: {
        conforme: 'Aucune fuite, la machine est conforme.',
        fuite: 'Une fuite est détectée : la réparation suit.',
        non_applicable: 'La machine n’est pas soumise au contrôle.',
        reparation_requise: 'La fuite est localisée : réparation à faire.',
        recontrole_requis: 'Réparée : un nouveau contrôle doit confirmer.',
        interdit_remise_service: 'La machine ne doit pas être remise en service.',
      },
      resultatsAide: 'Seuls les résultats possibles après le dernier contrôle sont proposés.',
      detecteur: 'Détecteur utilisé',
      sansDetecteur: 'Aucun détecteur',
      detecteurExpire: '{numero} : étalonnage dépassé',
      notes: 'Notes',
      notesAide: 'Emplacement de la fuite, réparation prévue…',
      photos: 'Photos',
      ajouterPhoto: 'Ajouter une photo',
      envoiPhoto: 'Envoi de la photo…',
      photoRefusee: 'Photo refusée : {raison}',
      photoMax: 'Six photos au plus.',
      retirerPhoto: 'Retirer',
      enregistrement: 'Enregistrement du contrôle',
      pret: 'Le contrôle rejoint le registre de la machine ; il ne se modifie plus ensuite.',
      enregistrer: 'Enregistrer le contrôle',
      enregistre: 'Contrôle enregistré.',
      manqueMachine: 'Choisissez la machine contrôlée.',
      manqueResultat: 'Choisissez le résultat.',
      photoEnCours: 'Attendez la fin de l’envoi des photos.',
      introuvable: 'Cette machine ou cette intervention n’est pas accessible : choisissez la machine.',
      prochain: 'Prochain contrôle le {date}.',
    },
    cerfaPage: {
      kicker: 'Fluides frigorigènes',
      titreNouvelle: 'Préparer une fiche CERFA',
      titreModifier: 'Modifier la fiche CERFA',
      titreFiche: 'Fiche CERFA',
      usageNouvelle: 'Une fiche CERFA décrit une intervention sur une machine à fluide : il faut d’abord la machine, puis son intervention.',
      usageModifier: 'Fiche d’intervention 15497*04. À la validation, l’application remplit le formulaire officiel et y pose les signatures.',
      usageValidee: 'Fiche validée : elle ne se modifie plus. Le formulaire officiel signé reste conservé avec elle.',
      etapeIntervention: 'Intervention sur la machine',
      etapeMachine: 'Machine et fluide',
      etapeNature: 'Nature de l’intervention',
      etapeEtancheite: 'Contrôle d’étanchéité',
      etapeQuantites: 'Fluide chargé et récupéré',
      etapeReleves: 'Pressions et températures relevées',
      etapeObservations: 'Observations',
      enregistrement: 'Enregistrement de la fiche',
      pret: 'La fiche reste un brouillon modifiable jusqu’à sa validation et ses signatures.',
      creer: 'Créer le brouillon',
      enregistrer: 'Enregistrer le brouillon',
      enregistree: 'Brouillon CERFA enregistré.',
      lieeNonModifiable: 'L’intervention et la machine d’une fiche ne se changent pas.',
      prefillIntrouvable: 'L’intervention ou la machine de l’adresse n’est pas accessible : recherchez-la.',
      lectureSeule: 'Ce brouillon porte sur une intervention qui ne vous est pas confiée : il se lit, il ne se modifie pas.',
    },
    validation: {
      titre: 'Valider et signer la fiche',
      usage: 'Relisez l’aperçu du formulaire officiel, puis faites signer sur l’écran. Une fois validée, la fiche reçoit son numéro et ne se modifie plus.',
      apercu: 'Aperçu du formulaire',
      apercuAide: 'Le brouillon porte la mention « BROUILLON » : elle disparaît à la validation.',
      voirApercu: 'Voir l’aperçu du CERFA',
      preparation: 'Préparation…',
      aCompleter: 'À compléter avant de valider',
      ouvrirMachine: 'Ouvrir la fiche de la machine',
      pointsAVerifier: '{n} point(s) à vérifier',
      pointsAide: 'La fiche peut être validée ainsi : ces cases resteront vides ou incomplètes sur le CERFA.',
      operateur: 'Opérateur',
      operateurAide: 'Le technicien qui a réalisé l’opération signe pour l’entreprise.',
      detenteur: 'Détenteur',
      detenteurFacultatif: 'Faire aussi signer le détenteur',
      detenteurFacultatifAide: 'Facultatif pour cette charge ; le client signe sur l’écran.',
      nom: 'Nom du signataire',
      qualite: 'Qualité du signataire',
      manquants: '{n} élément(s) manquant(s) avant la validation.',
      completer: 'Compléter la fiche',
      valider: 'Valider la fiche',
      certification: '« Je soussigné certifie que l’opération ci-dessus a été effectuée. »',
      confirmerTitre: 'Valider cette fiche ?',
      confirmer: 'La fiche reçoit son numéro et devient définitive : elle ne pourra plus être modifiée. Le formulaire officiel signé sera produit et conservé avec la fiche.',
      validee: 'Fiche validée, numéro {numero}.',
      dejaValidee: 'Cette fiche est déjà validée.',
    },
  },
  suiviDemande: {
    refusee: 'Demande refusée',
    refuseeTexte: 'Votre demande n’a pas pu être prise en charge. Pour en savoir plus, appelez l’entreprise.',
    annulee: 'Intervention annulée',
    annuleeTexte: 'L’intervention prévue a été annulée. Appelez l’entreprise pour convenir d’une suite.',
    questionTitre: 'L’entreprise vous pose une question',
    questionSansTexte: 'L’entreprise a besoin d’une précision pour traiter votre demande.',
    reponse: 'Votre réponse',
    reponsePlaceholder: 'Écrivez votre réponse ici…',
    envoyer: 'Envoyer ma réponse',
    envoi: 'Envoi…',
    photoEchec: 'Photo non envoyée. Retirez-la et réessayez, ou envoyez la réponse sans elle.',
    photoUneSeule: 'Choisissez une photo.',
    reponseEnvoyee: 'Réponse envoyée',
    reponseEnvoyeeTexte: 'L’entreprise a bien reçu votre réponse et reprend votre demande.',
    reponseDejaTraitee: 'Cette demande n’attend plus de réponse. Appelez l’entreprise si besoin.',
    reponseTropCourte: 'Écrivez au moins deux caractères.',
    photoEnCours: 'Envoi de la photo en cours…',
  },
  qr: {
    quiEcrit: 'Qui fait la demande ?',
    cestNous: 'Nous sommes {client}',
    cestNousAnonyme: 'Nous sommes le client de cette machine',
    cestNousAide: 'Nous utilisons les coordonnées que {entreprise} a déjà : rien à saisir.',
    autresCoordonnees: 'Autres coordonnées',
    autresCoordonneesAide: 'Pour être recontacté à un autre nom, numéro ou e-mail.',
    espaceClient: 'Votre espace client',
    espaceClientAide: 'Retrouvez vos machines, leur historique et vos demandes, avec un lien de connexion reçu à l’adresse de votre contact : aucun mot de passe.',
    espaceClientOuvrir: 'Ouvrir mon espace client',
    scanner: 'Scanner un QR code',
    etiquette: 'Étiquette QR',
    imprimer: 'Imprimer l’étiquette',
    telecharger: 'Télécharger l’image du QR',
    declarerPanne: 'Déclarer une panne',
    symptome: 'Symptôme',
    impact: 'Impact sur votre activité',
    urgencePercue: 'Urgence perçue',
    coordonnees: 'Vos coordonnées',
    referenceDemande: 'Référence de votre demande',
    suivreDemande: 'Suivre ma demande',
    envoyerDemande: 'Envoyer la demande',
    ajouterPhoto: 'Ajouter une photo',
    description: 'Description',
    votreNom: 'Votre nom',
    telephone: 'Téléphone',
    demandeEnvoyee: 'Demande envoyée',
    conserverReference: 'Vous recevrez les mises à jour par e-mail ou SMS. Conservez cette référence.',
    qrInvalide: 'QR code invalide ou révoqué',
    appeler: 'Appeler {nom}',
    // Scanner à repli progressif
    scannerCamera: 'Scanner avec la caméra',
    importerImage: 'Importer une image du QR',
    saisirManuellement: 'Saisir le code manuellement',
    codeOuLien: 'Code ou lien du QR',
    ouvrir: 'Ouvrir',
    cameraIndisponible:
      'La caméra n’est pas disponible sur cet appareil ou n’a pas été autorisée. Vous pouvez importer une photo du QR code ou saisir son code à la main.',
    qrIntrouvableDansImage:
      'Aucun QR code n’a été reconnu dans cette image. Réessayez avec une photo plus nette, ou saisissez le code à la main.',
    viserQr: 'Visez le QR code collé sur la machine.',
    // Lien de suivi (décision 1 du 19/10/2026) : « envoyé » seulement s'il part vraiment.
    suiviEnvoye: 'Le lien de suivi part aussi sur les coordonnées que vous avez données.',
    suiviDejaEnvoye: 'Le lien de suivi vous a été envoyé sur les coordonnées que vous avez données.',
    suiviEnvoyeConnu: 'Le lien de suivi part aussi aux coordonnées que {entreprise} a déjà pour vous.',
    suiviDejaEnvoyeConnu: 'Le lien de suivi vous a été envoyé aux coordonnées que {entreprise} a déjà pour vous.',
    suiviAGarder: 'Gardez cette page ou sa référence : le lien de suivi ne part pas par SMS.',
    suiviReference: 'Votre demande est bien enregistrée : gardez sa référence.',
  },
  portail: {
    monDossier: 'Mon dossier',
    mesMachines: 'Mes machines',
    mesDemandes: 'Mes demandes',
    mesRendezVous: 'Mes rendez-vous',
    mesDocuments: 'Mes documents',
    accepterCreneau: 'Confirmer',
    demanderDeplacement: 'Demander à décaler',
    noterIntervention: 'Noter l’intervention',
    ajouterHistorique: 'Ajouter à l’historique',
    signalerProbleme: 'Signaler un problème',
    prochainRendezVous: 'Votre prochain rendez-vous',
    demandeEnCours: 'Votre demande en cours',
    machineASurveiller: 'Machine à surveiller',
    suivreIntervention: 'Suivre l’intervention',
    technicienEnRoute: 'Technicien en route — arrivée estimée vers {heure}',
    creneau: 'Créneau',
    rapportDisponible: 'Rapport disponible dans vos documents',
    telechargerRapport: 'Télécharger le rapport (PDF)',
    rapportEnPreparation: 'Le rapport PDF est en préparation.',
    ceQuiAEteFait: 'Ce que le technicien vous a laissé',
    ceQuiAEteFaitAide: 'Les notes et photos que l’entreprise a choisi de vous montrer.',
    photoIndisponible: 'Photo en cours de vérification',
    votreNote: 'Votre note',
    noteFacultative: 'Note (facultative)',
    commentaireFacultatif: 'Commentaire (facultatif)',
    historiqueMachine: 'Historique de la machine',
    machineConcernee: 'Machine concernée',
    decrivezProbleme: 'Décrivez ce que vous constatez',
    urgenceIndicative: 'Indicatif — l’entreprise qualifie la demande',
    demandeEnvoyee: 'Votre demande a bien été transmise. Vous serez informé de son avancement.',
    lienEnvoye:
      'Si votre adresse est connue, un lien de connexion à usage unique vient de vous être envoyé (valable 15 minutes).',
    lienExplication:
      'Recevez un lien de connexion sécurisé par e-mail — aucun mot de passe à retenir.',
    recevoirMonLien: 'Recevoir mon lien',
    connexionDossier: 'Connexion à votre dossier',
    accederDossier: 'Accéder à mon dossier',
    publicationImmediate:
      'Votre ajout est publié immédiatement et clairement étiqueté « fourni par le client ».',
    typeAjout: 'Type',
    titre: 'Titre',
    detail: 'Détail',
    typesHistorique: {
      intervention_passee: 'Intervention passée',
      panne: 'Panne',
      note: 'Note',
      document: 'Document',
      mesure: 'Mesure',
    },
    // --- Vague 4 : dossier, documents, fiches ---
    voirMesDocuments: 'Voir mes documents',
    documentsResume: '{n} devis, factures ou contrats, et vos rapports',
    rapportsSeulement: 'Vos rapports et fiches d’intervention. Les devis et factures sont visibles par le contact désigné par votre entreprise.',
    toutVoir: 'Tout voir',
    aucuneDemande: 'Aucune demande pour l’instant. Si une machine ne fonctionne pas comme d’habitude, signalez-le.',
    rendezVous: 'Rendez-vous',
    lieu: 'Lieu',
    machine: 'Machine',
    photo: 'Photo',
    photos: 'Photos',
    historiqueVide: 'Rien n’est encore noté pour cette machine. Vous pouvez ajouter une ancienne intervention, une panne ou une information utile.',
    documents: {
      aide: 'Vos rapports, fiches d’intervention, devis, factures et contrats. Touchez un document pour l’ouvrir.',
      aucun: 'Aucun document pour l’instant.',
      rapport: 'Rapport d’intervention',
      ficheFluides: 'Fiche d’intervention fluides',
      contrat: 'Contrat',
      aSigner: 'À signer',
      aRegler: 'Reste à régler : {montant}',
      ouvrir: 'Ouvrir le PDF',
      preparation: 'Préparation du PDF…',
      pdfIndisponible: 'Le PDF n’a pas pu être préparé. Réessayez dans un instant ou appelez l’entreprise.',
      signer: 'Signer le devis',
      details: 'Détails',
      commentRegler: 'Comment régler',
      commentReglerAide: 'Par virement, avec la référence indiquée. Pas de paiement en ligne.',
      types: {
        report: 'Rapport',
        quote: 'Devis',
        invoice: 'Facture',
        contract: 'Contrat',
        cerfa: 'Fiche fluides',
      },
    },
    bureau: {
      titre: 'Portail client',
      aide: 'Autorisez l’accès client, puis choisissez qui peut voir les devis, factures et contrats.',
      autorise: 'Accès client autorisé pour {nom}',
      accesAide: 'Portail et liens de signature ou de confirmation. Couper l’accès ferme aussi les liens déjà envoyés.',
      voitDocuments: '{nom} voit les documents',
    },
  },
  fournisseur: {
    bonDeCommande: 'Bon de commande {numero}',
    emisPar: 'Émis par {entreprise}',
    livraisonSouhaitee: 'livraison souhaitée le {date}',
    designation: 'Désignation',
    quantite: 'Quantité',
    prixUnitaire: 'Prix unitaire HT',
    recu: 'Reçu',
    totalHt: 'Total HT',
    accuserReception: 'Accuser réception de la commande',
    receptionAccusee: 'Réception accusée le {date}',
  },
  externe: {
    // Signature plateforme, discrète, en pied des espaces d'une entreprise (docs/BRAND.md).
    propulsePar: 'Propulsé par',
    appeler: 'Appeler',
    appelerEntreprise: 'Appeler {entreprise}',
    vosDonnees: 'Vos données personnelles',
    erreurs: {
      lienExpireTitre: 'Lien expiré ou déjà utilisé',
      lienExpireTexte: 'Ce lien n’est plus valable. Demandez-en un nouveau à l’entreprise ou depuis votre dossier.',
      horsLigneTitre: 'Pas de connexion',
      horsLigneTexte: 'Votre téléphone semble hors ligne. Vérifiez le réseau puis réessayez : votre lien reste valable.',
      indisponibleTitre: 'Service indisponible',
      indisponibleTexte: 'Ce service est momentanément indisponible. Contactez directement l’entreprise.',
      sessionTitre: 'Session expirée',
      sessionTexte: 'Pour protéger votre dossier, la connexion a pris fin. Reconnectez-vous pour continuer.',
      refuseTitre: 'Accès non autorisé',
      refuseTexte: 'Ce contenu n’est pas accessible avec votre compte. Contactez l’entreprise si besoin.',
      tropDeTentativesTitre: 'Trop de tentatives',
      tropDeTentativesTexte: 'Patientez quelques minutes avant de réessayer.',
      autreTitre: 'Une erreur est survenue',
      autreTexte: 'La page n’a pas pu être chargée. Réessayez dans un instant.',
      reessayer: 'Réessayer',
      nouveauLien: 'Recevoir un nouveau lien',
      seReconnecter: 'Se reconnecter',
    },
  },
  sousTraitant: {
    espace: 'Espace sous-traitant',
    mesMissions: 'Mes missions',
    aucuneMission: 'Aucune mission ne vous est attribuée pour le moment.',
    activerAcces: 'Activation de votre accès',
    motDePasseAide: '{n} caractères minimum',
    transmettre: 'Transmettre',
    contributionTransmise: 'Votre contribution a bien été transmise. Merci.',
    ecritureJusquAu: 'Vous pouvez compléter cette mission jusqu’au {date}.',
    lectureSeule: 'Votre fenêtre de contribution est fermée : cette mission est en lecture seule.',
    signatureAide: 'Nom du client qui signe. Vous ne signez jamais à sa place.',
    consentement: 'Le client certifie que l’intervention a été réalisée.',
    missionPour: 'Mission réalisée pour {entreprise}',
    // Espace sous-traitant v4 (B8, 18/10/2026)
    signatureEffacer: 'Effacer',
    aucuneMissionAide: 'Quand une entreprise vous confie une intervention, elle apparaît ici.',
    mesMissionsUsage: 'Les interventions qui vous sont confiées, et ce que vous pouvez y envoyer.',
    mission: 'Mission',
    completer: 'Compléter la mission',
    itineraire: 'Itinéraire',
    dateAConfirmer: 'Date à confirmer',
    annulee: 'Cette intervention a été annulée : il n’y a plus rien à envoyer.',
    surPlace: 'Sur place',
    quand: 'Quand',
    adresse: 'Adresse',
    machine: 'Machine',
    consignes: 'Consignes',
    contactSurPlace: 'Contact sur place',
    appeler: 'Appeler {nom}',
    vosDroits: 'Ce que vous pouvez envoyer',
    vosDroitsAide: 'Fixé par l’entreprise pour cette mission.',
    signatureDejaRecueillie: 'La signature du client a déjà été recueillie pour cette mission.',
    vosEnvois: 'Vos envois',
    aucunEnvoi: 'Rien d’envoyé pour l’instant.',
    envoiDu: 'Envoi du {date}',
    nPhotos: '{n} photo(s)',
    signe: 'signé',
    repris: 'Repris',
    recu: 'Reçu',
    droits: {
      report: 'Compte rendu',
      time: 'Temps passé',
      media: 'Photos',
      signature: 'Signature du client',
    },
    etat: {
      aCompleter: 'À compléter',
      envoyee: '{n} envoi(s)',
      lectureSeule: 'Lecture seule',
    },
    connexion: {
      usage: 'Connectez-vous pour voir les interventions qui vous sont confiées.',
      choisirEntreprise: 'Plusieurs entreprises vous ont invité : pour laquelle travaillez-vous ?',
      enCours: 'Connexion…',
      identifiantsInvalides: 'Adresse e-mail ou mot de passe incorrect.',
      tropDeTentatives: 'Trop de tentatives : patientez un quart d’heure avant de réessayer.',
      plusDeMission: 'Vos missions sont terminées : l’accès est fermé.',
      horsLigne: 'Pas de réseau : la connexion reprendra au retour du réseau.',
      oubli: 'Mot de passe oublié ? Demandez à l’entreprise de vous renvoyer un lien d’accès.',
    },
    invitation: {
      usage: 'Choisissez votre mot de passe pour ouvrir votre accès.',
      pour: 'Invitation de {entreprise}',
      expire: 'Lien valable jusqu’au {date}.',
      identifiant: 'Votre identifiant de connexion',
      confirmer: 'Confirmez le mot de passe',
      tropCourt: 'Le mot de passe doit faire au moins {n} caractères.',
      differents: 'Les deux mots de passe sont différents.',
      activer: 'Activer mon accès',
      activation: 'Activation…',
      lienMort: 'Ce lien d’activation a expiré, a déjà servi ou a été annulé. Demandez à l’entreprise de vous en renvoyer un.',
    },
    contribution: {
      usage: 'Ce que vous avez fait. L’entreprise le relit avant de le transmettre au client.',
      pret: 'Prêt à transmettre à l’entreprise.',
      envoiEnCours: 'Envoi…',
      reprendre: 'Reprenez ou ignorez la saisie précédente.',
      reconnectez: 'Reconnectez-vous ci-dessus pour transmettre : votre saisie est gardée.',
      rienASignaler: 'Ajoutez au moins un élément : compte rendu, temps, photo ou signature.',
      texteTropLong: 'Le compte rendu dépasse {n} caractères.',
      dureeInvalide: 'Chaque durée doit être comprise entre 1 minute et {h} heures.',
      dateInvalide: 'Le jour de travail ne peut pas être dans le futur.',
      photosEnCours: 'Patientez : des photos sont encore en cours d’envoi.',
      photosEnEchec: 'Retirez les photos refusées ou en échec avant de transmettre.',
      signataireManquant: 'Indiquez le nom du client qui signe.',
      signatureManquante: 'Le client doit signer dans le cadre (un simple point ne suffit pas).',
      consentementManquant: 'Cochez la déclaration du client.',
      rapportTitre: 'Compte rendu',
      rapportAide: 'Ce que vous avez constaté et fait. Facultatif.',
      rapportLibelle: 'Votre compte rendu',
      tempsTitre: 'Temps passé',
      tempsAide: 'Une ligne par jour et par nature. Laissez vide si rien à déclarer.',
      nature: 'Nature',
      travail: 'Travail',
      trajet: 'Trajet',
      jour: 'Jour',
      heures: 'Heures',
      minutes: 'Minutes',
      ajouterLigne: 'Ajouter une ligne',
      retirerLigne: 'Retirer cette ligne',
      photosTitre: 'Photos',
      photosAide: '{n} photos au plus. Elles sont vérifiées (antivirus) avant l’envoi.',
      ajouterPhoto: 'Prendre ou choisir une photo',
      retirerPhoto: 'Retirer la photo',
      photo: {
        envoi: 'Envoi…',
        analyse: 'Vérification…',
        pret: 'Prête',
        refuse: 'Refusée',
        echec: 'Échec',
      },
      signatureTitre: 'Signature du client',
      signataire: 'Nom du client qui signe',
      zoneSignature: 'Zone de signature du client',
      consentementTitre: 'Déclaration du client',
      sessionExpiree: 'Session expirée',
      sessionExpireeAide: 'Reconnectez-vous sans quitter la page : votre saisie reste à l’écran.',
      seReconnecter: 'Me reconnecter',
    },
    bureau: {
      titre: 'Sous-traitants',
      usage: 'Les entreprises qui interviennent pour vous, et leur accès aux missions confiées.',
      inviter: 'Inviter un sous-traitant',
      confier: 'Confier à un sous-traitant',
      menuReprendre: 'Sous-traitance',
      recherche: 'Rechercher une entreprise, un contact, un e-mail',
      filtreEtat: 'État de l’accès',
      tous: 'Tous',
      aucun: 'Aucun sous-traitant',
      aucunAide: 'Invitez l’entreprise : elle choisit son mot de passe et ne voit que les missions que vous lui confiez.',
      aucunLecture: 'Personne n’a encore été invité.',
      invitationJusquAu: 'Invitation valable jusqu’au {date}',
      nMissions: '{n} mission(s) en cours',
      reglages: 'Réglages',
      delaiGrace: 'Délai après clôture (jours)',
      delaiGraceAide: 'Le sous-traitant peut encore compléter la mission pendant ce délai, puis la consulter 30 jours.',
      delaiGraceBornes: 'Entre 0 et 90 jours.',
      statuts: {
        invite: 'Invité',
        actif: 'Actif',
        revoque: 'Révoqué',
      },
      droits: {
        canReport: 'Compte rendu',
        canTime: 'Temps passé',
        canMedia: 'Photos',
        canSignature: 'Signature du client',
      },
      droitsAide: {
        canReport: 'Son compte rendu reste interne jusqu’à votre reprise.',
        canTime: 'Facturable sur l’intervention, hors des temps et de la paie de l’équipe.',
        canMedia: 'Photos vérifiées par l’antivirus.',
        canSignature: 'Une seule signature du client par mission.',
      },
      invitation: {
        usage: 'Un lien d’activation part par e-mail ; il expire au bout de 7 jours.',
        entreprise: 'L’entreprise',
        entrepriseAide: 'Celle qui intervient pour vous.',
        raisonSociale: 'Nom de l’entreprise',
        contact: 'La personne à contacter',
        contactAide: 'Elle se connecte avec cet e-mail.',
        nom: 'Nom et prénom',
        telephone: 'Téléphone',
        facultatif: 'Facultatif',
        pret: 'Le lien d’activation part tout de suite.',
        envoyer: 'Envoyer l’invitation',
        envoi: 'Envoi…',
        envoyee: 'Invitation envoyée à {email}.',
        manqueEntreprise: 'Indiquez le nom de l’entreprise.',
        manqueContact: 'Indiquez le nom de la personne.',
        manqueEmail: 'Indiquez une adresse e-mail valide.',
        telephoneInvalide: 'Le téléphone ne doit contenir que des chiffres, espaces et « + ».',
        // Session d'assistance MyEquip : créer un accès externe passe par le patron.
        assistance: 'Une session d’assistance n’invite pas de sous-traitant et ne renvoie pas d’invitation : le patron le fait depuis son compte.',
      },
      fiche: {
        titre: 'Sous-traitant',
        coordonnees: 'Coordonnées',
        activeLe: 'Accès activé le',
        missions: 'Missions en cours',
        missionsAide: 'Pour confier une intervention, ouvrez-la puis « … » › Confier à un sous-traitant.',
        aucuneMission: 'Aucune mission en cours.',
        anciennes: 'Missions terminées ou retirées',
        enCours: 'En cours',
        jusquAu: 'Jusqu’au {date}',
        retiree: 'Retirée',
        aReprendre: '{n} envoi(s) à reprendre',
        reprisesEnAttente: '{n} envoi(s) attendent votre reprise.',
        attenteActivation: 'En attente d’activation : lien valable jusqu’au {date}.',
        invitationExpiree: 'Le lien d’activation a expiré : renvoyez l’invitation.',
        accesRevoque: 'Accès révoqué le {date} : plus aucune mission n’est visible.',
        renvoyer: 'Renvoyer l’invitation',
        reinviter: 'Rouvrir l’accès',
        reinitialiser: 'Réinitialiser l’accès',
        renvoyerConsequence: 'Un nouveau lien d’activation part à {email} ; l’ancien ne marche plus.',
        reinitialiserConsequence: 'Le mot de passe actuel cesse de fonctionner et un lien pour en choisir un nouveau part à {email}.',
        revoquer: 'Révoquer l’accès',
        revoquerConsequence: '{entreprise} perd aussitôt l’accès à toutes ses missions. Ses envois restent dans vos dossiers.',
        invitationRenvoyee: 'Lien d’activation envoyé.',
        revoque: 'Accès révoqué.',
      },
      intervention: {
        titre: 'Sous-traitance',
        usage: 'Qui intervient pour vous ici, et ce qu’il a envoyé.',
        retour: 'Intervention',
        qui: 'Sous-traitants sur cette intervention',
        personne: 'Personne pour l’instant.',
        personneClose: 'Aucun sous-traitant sur cette intervention.',
        modifierDroits: 'Modifier les droits',
        retirer: 'Retirer la mission',
        retirerConsequence: '{entreprise} ne verra plus cette intervention et ne pourra plus rien y envoyer.',
        retiree: 'Mission retirée.',
        aReprendre: 'Envois à reprendre',
        aReprendreAide: 'Internes tant que vous ne les reprenez pas.',
        rienAReprendre: 'Rien à reprendre.',
        nonRepris: 'À reprendre',
        signePar: 'signé par {nom}',
        reprendre: 'Reprendre dans le dossier',
        reprendreConsequence: 'Le compte rendu et ses photos rejoignent l’historique de la machine, visible du client ; une signature recueillie est rattachée au rapport en cours.',
        repris: 'Envoi repris dans le dossier.',
        reprisSigne: 'Envoi repris ; la signature du client est rattachée au rapport.',
        reprises: 'Envois repris',
      },
      // Un envoi en entier avant sa reprise (décision du 18/10/2026).
      envoi: {
        titre: 'Envoi du sous-traitant',
        introuvable: 'Cet envoi n’existe pas sur cette intervention.',
        envoyeLe: 'Envoyé le {date} par {contact}',
        avantReprise: 'Interne pour l’instant : le reprendre le rend visible du client.',
        reprisPar: 'Repris dans le dossier le {date} par {nom}.',
        reprisLe: 'Repris dans le dossier le {date}.',
        vide: 'Cet envoi ne contient ni texte, ni photo, ni temps, ni signature.',
        texte: 'Texte complet',
        photo: 'Photo du sous-traitant',
        total: 'Total {total} · facturable {facturable}',
        nonFacturable: 'Non facturable',
        signature: 'Signature du client',
        signataire: 'Signataire',
        mention: 'Mention acceptée',
        imageSignature: 'Signature de {nom}',
      },
      confierPage: {
        usage: 'À qui, puis ce qu’il pourra envoyer.',
        qui: 'À quel sous-traitant ?',
        quiAide: 'Seuls les sous-traitants invités ou actifs.',
        aucun: 'Aucun sous-traitant disponible : invitez-en un d’abord.',
        pasEncoreActive: 'Accès pas encore activé',
        droits: 'Ce qu’il pourra envoyer',
        droitsAide: 'Il ne voit que cette intervention, jamais vos prix ni vos autres clients.',
        choisir: 'Choisissez le sous-traitant.',
        unDroit: 'Accordez au moins un droit.',
        pret: 'Il verra l’intervention dès sa prochaine connexion.',
        confiee: 'Intervention confiée.',
        droitsModifies: 'Droits modifiés.',
      },
    },
  },
  urgences: {
    alerteCritique: 'Urgence critique',
    acquitter: 'Prendre en charge',
    // Prise en charge, en ligne ou mise en file hors ligne (WEB1-20).
    prise: {
      confirmee: 'Urgence prise en charge : l’équipe le voit, l’escalade s’arrête.',
      enFile: 'Hors ligne : la prise en charge partira au retour du réseau.',
      dejaPrise: 'Cette urgence est déjà prise en charge ou close.',
      echec: 'La prise en charge a échoué.',
    },
    appelerPatron: 'Appeler le patron',
    escaladeEnCours: 'Escalade en cours',
    // Fiche d'une alerte (vague 5) : état, dossier lié et décision.
    fiche: {
      sousTitre: 'Alerte et prise en charge',
      usage: 'Vérifiez l’état de l’alerte et ouvrez le dossier lié avant de décider.',
      retour: 'Retour à l’accueil',
      faits: 'Suivi de l’alerte',
      declenchee: 'Déclenchée le',
      priseEnCharge: 'Prise en charge le',
      appel: 'Appel au responsable',
      issue: 'Issue',
      dossier: 'Dossier lié',
      dossierUsage: 'Ce qui a déclenché l’alerte.',
      voirIntervention: 'Voir l’intervention liée',
      voirDemande: 'Voir la demande {reference}',
      demandeLiee: 'liée',
      demandeClient: 'Demande client liée : {reference}',
      sansDossier: 'Cette alerte a été créée sans intervention ni demande cliente liée. Coordonnez la suite avec l’équipe.',
      ackTitre: 'Prendre en charge cette urgence ?',
      ackConsequence: 'La prise en charge signale que l’alerte est suivie et arrête son escalade automatique.',
      ackConfirmer: 'Confirmer la prise en charge',
      resoudre: 'Résoudre l’urgence',
      resoudreTitre: 'Résoudre cette urgence ?',
      resoudreConsequence: 'L’issue sera conservée dans l’historique de l’alerte.',
      resoudreIssue: 'Issue de l’urgence',
      resoudreConfirmer: 'Enregistrer la résolution',
      resolue: 'Urgence résolue : rien d’autre à faire.',
      attente: 'En attente de prise en charge.',
      enCharge: 'Prise en charge : résolvez-la une fois la situation rétablie.',
      // Astreintes (19/10/2026) : pendant une astreinte, l'astreinte et le bureau la traitent.
      astreinte: 'D’astreinte maintenant',
      astreinteAide: 'Une astreinte est en cours : {noms} ou le bureau prend en charge cette urgence. Appelez la personne d’astreinte.',
      sansNumero: 'Pas de numéro enregistré',
      appelerPatronAide: 'Si vous ne pouvez pas gérer seul : l’appel est noté dans le suivi de l’alerte.',
      besoinPatron: 'Besoin du patron ?',
      appelEnCours: 'Appel…',
      patronSansNumero: 'Aucun numéro de patron enregistré : prévenez-le par un autre moyen.',
      repli: 'Personne d’astreinte à joindre',
      repliAide: 'Aucun numéro n’est enregistré pour la personne d’astreinte : appelez le bureau, sinon le patron.',
      repliBureau: 'Appeler le bureau',
      repliPatron: 'Appeler le patron {nom}',
      repliAucun: 'Aucun numéro de repli n’est enregistré : prévenez l’équipe par un autre moyen.',
      patronNumero: 'Numéro du patron : {numero}',
    },
  },
  parametres: {
    notifications: 'Notifications',
    theme: 'Thème',
    // « Système » suit l'appareil ; « Selon l'heure » passe en sombre du coucher au lever du soleil.
    themes: { clair: 'Clair', sombre: 'Sombre', auto: 'Système', heure: 'Selon l’heure' },
  },
  // Mon entreprise (refonte v4, 18/10/2026) : accueil en six groupes et une page par rubrique.
  entreprise: {
    titre: 'Mon entreprise',
    usage: 'Ce qui s’applique à toute l’équipe de {entreprise}.',
    aucunDroit: 'Votre rôle ne permet de régler aucune rubrique de l’entreprise.',
    groupes: {
      identite: 'Identité',
      membres: 'Membres et rôles',
      activite: 'Activité',
      ventes: 'Ventes',
      connexions: 'Connexions',
      abonnement: 'Abonnement',
    },
    sections: {
      identite: { titre: 'Identité et coordonnées', aide: 'Raison sociale, SIRET, TVA, adresse, téléphone' },
      apparence: { titre: 'Apparence des documents', aide: 'Logo, couleurs, mentions, e-mails, étiquettes QR' },
      documents: { titre: 'Documents de l’entreprise', aide: 'Règlement intérieur, consignes, lectures confirmées' },
      messagerie: { titre: 'Messagerie', aide: 'Annonces et conversations : activer, horaires calmes, conservation' },
      membres: { titre: 'Membres', aide: 'Inviter, accès Terrain, rôle de chacun' },
      roles: { titre: 'Rôles et hiérarchie', aide: 'Qui est au-dessus de qui, qui fait quoi' },
      comptable: { titre: 'Comptable', aide: 'Accès gratuit de votre comptable vérifié' },
      equipe: { titre: 'Disponibilités de l’équipe', aide: 'Absences, agendas, décisions et astreintes, dans Équipe' },
      sousTraitants: { titre: 'Sous-traitants', aide: 'Comptes des entreprises partenaires, missions confiées' },
      metiers: { titre: 'Métiers et machines', aide: 'Vos activités, les machines suivies chez les clients' },
      horaires: { titre: 'Heures habituelles', aide: 'Jours travaillés, début et fin de la journée' },
      terrain: { titre: 'Sur le terrain', aide: 'Planning des collègues, double authentification, signature' },
      suivi: { titre: 'Position et arrivée', aide: 'Position enregistrée, heure d’arrivée, technicien le plus proche' },
      temps: { titre: 'Temps de travail', aide: 'Heures supplémentaires, week-end, oubli de fin' },
      pieces: { titre: 'Pièces et inventaires', aide: 'Réservations libérées, seuil d’approbation des achats, écarts d’inventaire validés seuls' },
      checklists: { titre: 'Checklists des rapports', aide: 'Points à vérifier pendant une intervention, selon son type' },
      clients: { titre: 'Clients et carte', aide: 'Placement sur la carte, clients sans artisan' },
      fluides: { titre: 'Fluides et CERFA', aide: 'Attestation de capacité, installation de destination' },
      devis: { titre: 'Devis et facturation', aide: 'Bornes du devis, acompte, délai de paiement, TVA, numérotation, envoi des factures, taux horaire' },
      baremes: { titre: 'Barèmes', aide: 'Lignes et prix réutilisables' },
      catalogue: { titre: 'Catalogue de machines', aide: 'Types de machines, prix et visites d’entretien habituels' },
      relances: { titre: 'Relances automatiques', aide: 'Rappeler les factures impayées, sans relancer qui a payé' },
      avis: { titre: 'Avis clients', aide: 'Questionnaire après intervention' },
      integrations: { titre: 'Intégrations', aide: 'Comptabilité, agenda, journal des ventes' },
      donneesPersonnelles: { titre: 'Données personnelles', aide: 'Demandes RGPD de vos clients : accès, correction, suppression' },
      import: { titre: 'Importer des données', aide: 'Clients, sites, contacts, machines, fournisseurs, articles' },
      abonnement: { titre: 'Abonnement', aide: 'Essai en cours et facturation' },
      audit: { titre: 'Journal d’audit', aide: 'Qui a fait quoi, et quand : lecture seule' },
    },
    devis: {
      factures: {
        titre: 'Factures',
        aide: 'L’échéance d’une facture sans date saisie, comptée depuis son émission ; jamais pour un avoir.',
        delai: 'Délai de paiement',
        delaiAide: '0 : à réception. 30 jours : délai légal par défaut entre professionnels ; {max} au plus. Imprimé : « {conditions} », sauf conditions écrites dans Apparence des documents.',
        jours: 'jours',
        finDeMois: 'Fin de mois',
        finDeMoisAide: 'L’échéance tombe le dernier jour du mois atteint, {max} jours au plus (« 45 jours fin de mois »).',
        envoiAuto: 'Envoyer la facture au client à l’émission',
        envoiAutoAide: 'Par e-mail, PDF joint, aux contacts « facturation » du client (à défaut, aux autres contacts qui voient les documents, jamais à un contact technique). Coupé : envoyez-la depuis la fiche de la facture.',
      },
      tva: {
        titre: 'TVA',
        aide: 'Votre régime de TVA, imprimé sur les devis et les factures.',
        franchise: 'Franchise en base de TVA (art. 293 B du CGI)',
        franchiseAide: 'Devis et factures sans TVA, avec la mention « TVA non applicable, art. 293 B du CGI ». Un avoir suit sa facture.',
        debits: 'TVA sur les débits',
        debitsAide: 'Si vous avez opté pour le paiement de la TVA d’après les débits : la mention est imprimée sur chaque facture.',
      },
      numerotation: {
        titre: 'Numérotation',
        aide: 'Préfixe des factures et des avoirs, avec ou sans Pennylane.',
        prefixes: 'Factures {facture} · avoirs {avoir}',
        prochaineFacture: 'Prochaine facture : {numero}',
        prochainAvoir: 'Prochain avoir : {numero}',
        pageTitre: 'Numérotation des factures',
        pageAide: 'Le préfixe de vos factures et de vos avoirs. Un document émis garde toujours son numéro.',
        etape: 'Préfixes',
        etapeAide: 'Si vous facturiez avant MyEquip, prenez un préfixe différent de celui de votre ancien logiciel : deux factures ne portent jamais le même numéro.',
        prefixeFactures: 'Préfixe des factures',
        prefixeAvoirs: 'Préfixe des avoirs',
        formatInvalide: 'Une lettre, puis jusqu’à cinq lettres ou chiffres.',
        prefixesEgaux: 'Factures et avoirs doivent porter des préfixes différents.',
        reserveDevis: '« DE » est réservé aux devis.',
        dejaAutreSerie: '« {prefixe} » a déjà numéroté des {quoi} cette année : il donnerait deux fois le même numéro. Choisissez-en un autre.',
        serieArretee: 'La série {serie} s’arrête à {compte} en {annee} ; la suivante commence à {numero}.',
        factureEmise: 'facture émise',
        facturesEmises: 'factures émises',
        avoirEmis: 'avoir émis',
        avoirsEmis: 'avoirs émis',
        conflit: 'Pennylane utilise déjà des numéros en « {prefixe} »{exemple} : changez le préfixe des {quoi}.',
        quoiFactures: 'factures',
        quoiAvoirs: 'avoirs',
        inchanges: 'Les préfixes n’ont pas changé.',
        pret: 'Factures en {facture}, avoirs en {avoir}.',
        piedLibelle: 'Changement des préfixes',
        enregistrer: 'Enregistrer les préfixes',
        confirmerTitre: 'Changer les préfixes ?',
        confirmerTexte: 'Les prochaines factures porteront {facture}, les prochains avoirs {avoir}. Les documents déjà émis gardent leur numéro.',
        confirmer: 'Enregistrer',
        enregistre: 'Préfixes enregistrés pour les prochaines factures.',
      },
    },
    apparence: {
      conditionsPaiementAide: 'Vide : tirées du délai de paiement réglé dans Devis et facturation (ou de l’échéance saisie sur la facture), comme l’échéance des factures.',
    },
    // Checklists du rapport (Q23) : une modification crée une nouvelle version, les rapports remplis gardent la leur.
    checklists: {
      usage: 'Les points que le technicien coche ou renseigne dans le rapport. Modifier une checklist crée une nouvelle version : les rapports déjà remplis gardent la leur.',
      creer: 'Créer une checklist',
      liste: 'Checklists',
      videTitre: 'Aucune checklist pour l’instant',
      videTexte: 'Créez la première : ses points apparaissent dans le rapport des interventions du type choisi.',
      plafond: '{n} checklists actives au plus : retirez-en une pour en créer une autre.',
      toutes: 'Toutes les interventions',
      requis: '{n} requis',
      nouvelle: 'Nouvelle checklist',
      modifier: 'Modifier « {nom} »',
      introuvable: 'Cette checklist a été remplacée par une version plus récente, ou retirée.',
      versionAide: 'Enregistrer crée une nouvelle version : les rapports déjà remplis gardent celle qu’ils citent, les prochains prennent la nouvelle.',
      etapeNom: 'Nom et usage',
      nom: 'Nom de la checklist',
      nomExemple: 'Ex. Entretien chambre froide',
      proposee: 'Proposée pour',
      etapePoints: 'Points à vérifier',
      etapePointsAide: 'Dans l’ordre où le technicien les verra.',
      point: 'Point {n}',
      libelle: 'Intitulé du point {n}',
      genre: 'Réponse attendue au point {n}',
      genres: { bool: 'Oui ou non', number: 'Un nombre', text: 'Un texte', photo: 'Des photos' },
      unite: 'Unité du point {n} (facultatif)',
      uniteExemple: 'Ex. °C, bar',
      requisLibelle: 'Requis pour terminer l’intervention',
      photosAvant: 'Photos avant exigées (point {n})',
      photosApres: 'Photos après exigées (point {n})',
      photosAide: 'Le point se coche seul quand le rapport a ces photos.',
      retirerCourt: 'Retirer',
      retirerPoint: 'Retirer le point {n}',
      ajouterPoint: 'Ajouter un point',
      pied: 'Enregistrement de la checklist',
      pret: '{nom} · {points}',
      enregistrer: 'Enregistrer la checklist',
      enregistrerVersion: 'Enregistrer la nouvelle version',
      problemeNom: 'Donnez un nom à la checklist.',
      problemeLibelle: 'Écrivez l’intitulé de chaque point.',
      problemePhotos: 'Indiquez un nombre de photos entre 0 et {max}.',
      problemeReprise: 'Reprenez ou ignorez la saisie précédente.',
      retirer: 'Retirer cette checklist',
      retirerTitre: 'Retirer la checklist « {nom} » ?',
      retirerConsequence: 'Elle n’est plus proposée dans les nouveaux rapports. Les rapports déjà remplis la gardent, avec leurs réponses.',
      retirerConfirmer: 'Retirer la checklist',
    },
    // Gestes refusés par l'API en session d'assistance (SUPPORT_DENIED_* dans apps/api/src/plugins/auth.ts).
    assistance: {
      membre: 'Une session d’assistance ne change ni le rôle, ni le statut, ni l’accès Terrain d’un membre, et ne crée aucun lien d’activation ou de récupération : le patron le fait depuis son compte.',
      pennylane: 'Une session d’assistance ne connecte ni ne déconnecte Pennylane et ne saisit aucun jeton : le patron le fait depuis son compte.',
      doubleAuthentification: 'Une session d’assistance ne change pas cette règle : le patron le fait depuis son compte.',
      roles: 'Une session d’assistance ne crée, ne modifie, ne range ni ne supprime aucun rôle : le patron le fait depuis son compte.',
    },
  },
  journalAudit: {
    recherche: 'Filtrer',
    filtreActeur: 'Qui',
    tousActeurs: 'Tout le monde',
    filtreAction: 'Sur quoi',
    toutesActions: 'Tout',
    filtrePeriode: 'Période',
    periodes: { tout: 'Toute la période', jour: 'Dernières 24 h', semaine: '7 derniers jours', mois: '30 derniers jours' },
    vide: 'Aucune entrée ne correspond à ces filtres.',
    videAucune: 'Le journal est vide pour l’instant.',
    liste: 'Entrées du journal d’audit',
    acteurs: { platform: 'Assistance MyEquip', system: 'Système', contact: 'Client (portail)', api_key: 'Clé d’accès', user: 'Compte supprimé' },
    detailTitre: 'Détail de l’entrée',
    quand: 'Date',
    qui: 'Auteur',
    quoi: 'Action',
    champ: 'Champ modifié',
    motif: 'Motif',
    objet: 'Objet concerné',
    code: 'Code',
    avant: 'Avant',
    apres: 'Après',
    valeursReplie: 'Valeurs avant et après',
    aucuneValeur: 'Aucune valeur enregistrée.',
    vide2: 'vide',
    oui: 'oui',
    non: 'non',
    fermer: 'Fermer',
    aide: 'Le journal garde, sans possibilité de le modifier, ce qui change dans l’entreprise : qui l’a fait, quand et sur quoi. Il est réservé aux comptes qui ont le droit de le consulter.',
    familles: {
      admin: 'Assistance MyEquip', app_version: 'Versions de l’application', article: 'Articles', auth: 'Connexions et sécurité',
      bsff: 'Bordereaux de fluides', cerfa: 'CERFA', company: 'Entreprise', company_document: 'Documents de l’entreprise',
      contract: 'Contrats', customer: 'Clients', customer_contact: 'Contacts clients', customer_tag: 'Étiquettes clients',
      device: 'Appareils', document: 'Documents envoyés', employment: 'Conditions d’emploi', equipment: 'Machines',
      equipment_history: 'Historique des machines', escalation: 'Escalades', feature_flag: 'Fonctions activées', feedback: 'Avis clients',
      fluid_cylinder: 'Bouteilles de fluide', google: 'Agenda Google', gdpr_request: 'Demandes RGPD', impersonation: 'Assistance temporaire',
      import: 'Imports', integration: 'Intégrations', intervention: 'Interventions', intervention_needs: 'Besoins d’intervention',
      intervention_note: 'Notes d’intervention', inventory: 'Inventaires', invoice: 'Factures', job: 'Tâches de fond',
      leak_check: 'Contrôles d’étanchéité', legal_document: 'Documents légaux', machine_model: 'Catalogue de machines',
      maintenance_proposal: 'Propositions de maintenance', mission_grant: 'Missions confiées', onboarding: 'Mise en route',
      oncall: 'Astreintes', orphan_customers: 'Clients sans artisan', payment: 'Paiements', pennylane: 'Pennylane',
      portal: 'Portail client', po_return: 'Retours fournisseur', pricing_template: 'Barèmes', purchase_order: 'Commandes fournisseur',
      quote: 'Devis', report: 'Rapports', reservation: 'Réservations de pièces', reserved_name: 'Noms réservés', role: 'Rôles',
      schedule_event: 'Planning', service_request: 'Demandes', settings: 'Réglages', signature_exception: 'Signatures en exception',
      site: 'Sites', stock_location: 'Emplacements de stock', subcontractor: 'Sous-traitants', subscription: 'Abonnement',
      supplier: 'Fournisseurs', supplier_invoice: 'Factures reçues', support: 'Aide', sync_conflict: 'Conflits de synchronisation',
      task: 'Tâches', time: 'Temps de travail', time_entry: 'Saisies de temps', user: 'Membres',
    },
    verbes: {
      created: 'créé', updated: 'modifié', deleted: 'supprimé', archived: 'archivé', restored: 'restauré', sent: 'envoyé',
      accepted: 'accepté', refused: 'refusé', cancelled: 'annulé', emitted: 'émis', published: 'publié', signed: 'signé',
      login: 'connexion', logout: 'déconnexion', revoked: 'révoqué', activated: 'activé', invited: 'invité', closed: 'clos',
      reopened: 'rouvert', transition: 'changement d’état', recorded: 'enregistré', applied: 'appliqué', received: 'réceptionné',
      reordered: 'réordonné', released: 'libéré', extended: 'prolongé', moved: 'déplacé', located: 'localisé',
      password_changed: 'mot de passe changé', password_reset: 'mot de passe réinitialisé', email_changed: 'e-mail changé',
      email_corrected: 'e-mail corrigé', email_change_requested: 'changement d’e-mail demandé (code envoyé)',
      email_change_expired: 'changement d’e-mail expiré', email_change_locked: 'changement d’e-mail bloqué (trop d’essais)',
      email_change_failed: 'changement d’e-mail impossible', email_change_cancelled: 'changement d’e-mail annulé',
branding_updated: 'apparence modifiée', dunning_updated: 'relances modifiées',
      document_prefixes_changed: 'préfixes de numérotation modifiés', legal_identity_updated: 'identité légale modifiée',
      draft_created: 'brouillon créé', draft_updated: 'brouillon modifié', draft_deleted: 'brouillon supprimé',
      credit_note_created: 'avoir créé', credited: 'crédité', tags_updated: 'étiquettes modifiées',
      step_up: 'confirmation renforcée', step_up_failed: 'confirmation renforcée échouée', session_closed: 'session fermée',
      logout_all: 'toutes les sessions fermées', mfa_disabled: 'double authentification désactivée',
      mfa_activated: 'double authentification activée', mfa_reset: 'double authentification réinitialisée',
      mfa_email_enabled: 'code par e-mail choisi en secours',
      passkey_login: 'connexion par clé d’accès', passkey_registered: 'clé d’accès ajoutée', passkey_removed: 'clé d’accès retirée',
      refresh_reuse_detected: 'session suspecte coupée', started: 'démarré', ended: 'terminé', acknowledged: 'lecture confirmée',
      reminded: 'rappel envoyé', converted: 'converti', resolved: 'résolu', blocked: 'bloqué', unblocked: 'débloqué',
      done: 'terminée', imported_from_pennylane: 'importé depuis Pennylane', sent_to_pennylane: 'envoyé à Pennylane',
    },
    action: '{objet} : {verbe}',
    actionInconnue: 'Action enregistrée',
  },
  // Assistant d'import Excel/CSV (décision 15 du 19/10/2026) : reprise des données d'un autre outil.
  importDonnees: {
    titre: 'Importer des données',
    usage: 'Reprenez les fiches d’un autre logiciel ou d’un tableur : rien n’est écrit avant votre validation.',
    entites: {
      clients: { titre: 'Clients', aide: 'À importer en premier : les autres fichiers s’y rattachent par le nom du client.' },
      sites: { titre: 'Sites', aide: 'Les lieux de vos clients, avec leur adresse.' },
      contacts: { titre: 'Contacts', aide: 'Les personnes à joindre chez vos clients, dont celles qui reçoivent les factures.' },
      equipements: { titre: 'Machines', aide: 'Les machines de vos clients ; un site absent est créé s’il a une adresse.' },
      fournisseurs: { titre: 'Fournisseurs', aide: 'Vos grossistes et fabricants.' },
      articles: { titre: 'Articles', aide: 'Pièces, fluides et consommables, avec leurs prix.' },
    },
    etats: { simule: 'À valider', applique: 'Importé', annule: 'Annulé' },
    lignes: { ok: 'Prête', doublon: 'Doublon', erreur: 'Erreur' },
  },
  superadmin: {
    titre: 'Super-administration',
    entreprises: 'Entreprises',
    ajouterEntreprise: 'Ajouter une entreprise',
    abonnements: 'Abonnements',
    sante: 'Santé de la plateforme',
    jobs: 'File de tâches',
    featureFlags: 'Déploiements progressifs',
    sauvegardes: 'Sauvegardes',
    impersonation: 'Ouvrir une assistance temporaire',
    motifRequis: 'Motif / ticket obligatoire',
    banniereImpersonation: 'Session d’assistance en cours — vos actions sont journalisées',
    banniereImpersonationLecture: 'Assistance (lecture) en cours — consultation seule, aucune modification possible',
    entreprise: 'Entreprise',
    interne: 'interne',
    utilisateursActifs: '{n} utilisateur(s) interne(s) actif(s)',
    utilisateursNonCalcule: 'Utilisateurs internes actifs : non calculé',
    nonCalculeAide:
      'Le recomptage périodique n’a pas encore eu lieu : aucun chiffre de facturation n’est disponible. Démarrez le worker pour l’obtenir.',
    recompteLe: 'recompté le {date}',
    abonnementDe: 'Abonnement de {nom}',
    changer: 'Changer…',
    modifierAbonnement: 'Modifier l’abonnement',
    choisirEtat: 'Choisir un état…',
    etatFinal: 'État final : aucune transition disponible',
    aucunAbonnement: 'Aucun abonnement',
    aucuneTransition: 'Aucune transition disponible',
    confirmerAbonnement: 'Modifier cet abonnement ?',
    transitionAbonnement:
      'L’abonnement de {nom} passera de « {avant} » à « {apres} ». Le changement prend effet immédiatement.',
    ecrituresBloquees: 'Les écritures des utilisateurs seront bloquées.',
    ecrituresAutorisees: 'Les écritures des utilisateurs seront autorisées.',
    accesFerme:
      'Toute l’équipe perdra l’accès à ses données, lectures comprises ; seul l’écran de suspension restera.',
    patronPrevenu: 'Le patron sera prévenu par e-mail (et SMS si un fournisseur est configuré).',
    motifTransition: 'Motif de la modification',
    confirmerChangement: 'Confirmer le changement',
    nouvelleEntreprise: 'Nouvelle entreprise',
    raisonSociale: 'Raison sociale',
    emailPatron: 'E-mail du patron',
    nomPatron: 'Nom du patron',
    creerEtInviter: 'Créer l’entreprise et inviter le patron',
    echecsDefinitifs: 'Échecs définitifs (rejouables)',
    aucunEchec: 'Aucun échec définitif',
    fileTaches: 'File de tâches',
    plateforme: 'Plateforme',
    filtrerEtat: 'Filtrer par état',
    tousLesEtats: 'Tous les états',
    aucuneTache: 'Aucune tâche pour ce filtre.',
    rafraichir: 'Rafraîchir',
    prochaineExecution: 'Prochaine exécution',
    tenant: 'Entreprise',
    tacheEtats: {
      en_file: 'En file',
      planifiee: 'Planifiée',
      en_cours: 'En cours',
      a_reessayer: 'À réessayer',
      reussie: 'Réussie',
      echec_final: 'Échec définitif',
      annulee: 'Annulée',
    },
    confirmerReplay: 'Rejouer cette tâche en échec ? Un nouveau job lié sera créé.',
    nonRejouable: 'Seul un échec définitif se rejoue.',
    aucunFlag: 'Aucun déploiement progressif en cours',
    desactive: 'désactivé',
    rejouer: 'Rejouer',
    tentatives: '{n} tentative(s)',
    enFile: '{n} en file',
    echecs: '{n} échec(s)',
    workerActif: 'Traitement automatique actif',
    workerSilencieux: 'Worker silencieux depuis {n} min',
    workerJamaisDemarre: 'Traitement automatique non démarré',
    workerJamaisDemarreAide:
      'Aucun battement reçu : les tâches de fond (e-mails, PDF, recomptage des abonnements) ne sont pas traitées. Démarrez le service worker.',
    dernierBattement: 'Dernier battement',
    autoriserEcriture: 'Autoriser l’écriture (encadrée et journalisée)',
    ouvrirSession: 'Ouvrir la session d’assistance',
    impersonationAvertissement:
      'Le client est notifié et voit une bannière ; toutes les actions sont journalisées avec le motif. Session courte, lecture seule par défaut.',
    // Console de la plateforme en pages (refonte v4, vague 4).
    console: {
      introuvable: 'Page introuvable',
      terminer: 'Terminer',
      coque: {
        identite: 'Administration MyEquip',
        rubriques: 'Rubriques de la console',
        accueil: 'Accueil',
        entreprises: 'Entreprises',
        assistance: 'Assistance',
        taches: 'Tâches',
        comptables: 'Comptables',
        outils: 'Outils',
      },
      verification: {
        titre: 'Confirmer votre identité administrateur',
        texte: 'Pour protéger les accès clients, une vérification récente est nécessaire. Utilisez un nouveau code de votre application d’authentification ou un code de secours.',
        code: 'Code de vérification administrateur',
        confirmer: 'Confirmer mon identité',
        enCours: 'Vérification…',
        annulee: 'Vérification d’identité annulée : rien n’a été envoyé.',
      },
      connexion: {
        kicker: 'Plateforme MyEquip',
        usage: 'Réservé à l’équipe MyEquip. La double authentification est obligatoire.',
        activation: 'Activez votre compte avec un mot de passe d’au moins 16 caractères. La connexion suivante vous demandera de configurer la double authentification.',
        nouveauMotDePasse: 'Nouveau mot de passe',
        confirmerMotDePasse: 'Confirmer le mot de passe',
        motDePasseAide: '16 caractères minimum.',
        activer: 'Activer mon compte',
      },
      motif: {
        etape: 'Motif',
        aide: 'Qui l’a demandé et pourquoi : il reste dans le journal de la plateforme et de l’entreprise.',
        libelle: 'Motif et demande du client',
        instruction: 'Instruction du client et motif',
        compte: '{n} / 500 caractères.',
        manque: 'Écrivez le motif ({n} caractères au moins).',
        long: 'Le motif dépasse {n} caractères.',
      },
      accueil: {
        kicker: 'Plateforme',
        usage: 'Ce qui attend l’équipe MyEquip, puis les entreprises et leurs demandes.',
        chiffres: 'Vue d’ensemble de la plateforme',
        entreprises: 'Entreprises',
        essais: 'En essai',
        demandes: 'Demandes à traiter',
        tickets: 'Tickets ouverts',
        taches: 'Tâches à examiner',
        attention: 'Abonnements à surveiller',
        outils: 'Outils',
      },
      demandesEntreprises: {
        titre: 'Demandes des entreprises',
        aide: 'Une reprise se confirme en repassant l’abonnement à « Actif » depuis la fiche. Une copie des données s’ouvre d’elle-même quand l’archive en libre-service du patron dépasse ses limites : à remettre dans le mois.',
        aucune: 'Aucune demande de reprise ou de données en attente.',
        reprise: 'Reprise de l’abonnement',
        donnees: 'Copie de ses données',
        traiter: 'Marquer traitée',
        confirmer: 'Marquer cette demande comme traitée ?',
        fait: 'Ce qui a été fait',
        aTraiter: 'À traiter',
        traitee: 'Traitée',
      },
      entreprises: {
        usage: 'Créez les entreprises, suivez leurs abonnements et ouvrez une assistance temporaire si nécessaire.',
        rechercher: 'Rechercher une entreprise',
        filtre: 'Filtrer les abonnements',
        tous: 'Tous les abonnements',
        aucune: 'Aucune entreprise pour cette recherche.',
      },
      creation: {
        usage: 'L’entreprise démarre en essai de 30 jours ; son patron reçoit un lien d’activation valable 14 jours.',
        etapeEntreprise: 'Entreprise',
        interne: 'Entreprise pilote interne',
        interneAide: 'Accès actif, sans facturation automatique.',
        etapePatron: 'Patron',
        etapePatronAide: 'Il choisira son mot de passe avec le lien reçu par e-mail.',
        manqueEntreprise: 'Saisissez la raison sociale (et un SIRET de 14 chiffres s’il est connu).',
        manquePatron: 'Saisissez le nom et l’adresse e-mail du patron.',
        pret: 'Essai de 30 jours, invitation du patron par e-mail.',
        pretInterne: 'Pilote interne : accès actif sans facturation, invitation du patron par e-mail.',
        faite: '{nom} est créée. L’invitation part vers {email}.',
      },
      fiche: {
        kicker: 'Fiche entreprise',
        usage: 'Identité, abonnement, équipe et historique de l’entreprise.',
        onglets: 'Rubriques de la fiche',
        identite: 'Identité',
        equipe: 'Équipe',
        historique: 'Historique',
        modifier: 'Modifier',
        modifierIdentite: 'Modifier l’identité',
        inviter: 'Inviter une personne',
        ticket: 'Créer un ticket d’assistance',
        retirer: 'Retirer l’entreprise',
        abonnementAide: 'Le changement prend effet tout de suite ; le patron est prévenu quand il le concerne.',
        demandes: 'Demandes de l’entreprise',
        donneesMetier: 'Les données métier se consultent dans une session d’assistance temporaire, journalisée chez l’entreprise.',
      },
      identite: {
        titre: 'Identité de l’entreprise',
        usage: 'Raison sociale, SIRET et téléphone public, sur instruction de l’entreprise.',
        etape: 'Identité',
        siret: 'SIRET',
        siretAide: '14 chiffres, ou vide.',
        activite: 'Activité',
        telephone: 'Téléphone public',
        telephoneAide: 'Affiché sur les étiquettes QR et la page publique.',
        creee: 'Créée le',
        pilote: 'Pilote',
        rien: 'Aucune modification à enregistrer.',
        manqueNom: 'Le nom ne peut pas être vide.',
        pret: 'Enregistré dans le journal de l’entreprise avec votre motif.',
        faite: 'Identité enregistrée.',
      },
      abonnement: {
        aucun: 'Aucun abonnement',
        etat: 'État',
        finEssai: 'Fin d’essai',
        usage: 'État actuel : {etat}. L’administration place l’état voulu, y compris pour rouvrir un abonnement terminé.',
        etapeEtat: 'Nouvel état',
        etapeEtatAide: 'Le changement prend effet immédiatement.',
        nouvelEtat: 'Nouvel état de l’abonnement',
        manqueEtat: 'Choisissez le nouvel état.',
        accesFerme: 'Toute l’équipe perd l’accès à ses données ; seul l’écran de suspension reste.',
        ecrituresBloquees: 'Les écritures des utilisateurs sont bloquées.',
        ecrituresAutorisees: 'Les écritures des utilisateurs sont autorisées.',
        patronPrevenu: 'Le patron est prévenu par e-mail.',
        fait: 'Abonnement passé à « {etat} ».',
      },
      retrait: {
        titre: 'Retirer l’entreprise',
        usage: 'Ferme tous les accès de l’entreprise. Rien n’est supprimé automatiquement.',
        consequenceTitre: 'Geste lourd',
        consequence: 'L’abonnement passe à « Suspendu » et toute l’équipe perd l’accès. Les données restent conservées jusqu’à la fin de la conservation légale ; le geste est tracé dans le journal de la plateforme et de l’entreprise.',
        conservation: 'Conservation légale jusqu’au',
        conservationAide: 'Facultatif : date jusqu’à laquelle rien ne peut être supprimé.',
        etapeConfirmation: 'Confirmation',
        saisir: 'Saisissez RETIRER pour confirmer',
        manqueConfirmation: 'Saisissez RETIRER pour confirmer.',
        pret: '{nom} sera retirée.',
        action: 'Retirer l’entreprise',
        fait: 'Entreprise retirée : ses accès sont fermés.',
      },
      equipe: {
        comptes: 'Comptes par état',
        titre: 'Équipe et invitations',
        aide: 'Invitation nominative sur instruction de l’entreprise. Votre compte de la plateforme reste distinct.',
        rechercher: 'Rechercher un membre',
        aucun: 'Aucun compte pour cette recherche.',
        sansIdentifiant: 'Identifiant absent',
        sansEmail: 'Sans e-mail',
        mfa: 'Double authentification',
        sansMfa: 'Sans double authentification',
      },
      historique: {
        plateforme: 'Journal de la plateforme',
        plateformeAide: 'Les gestes de la console sur cette entreprise, avec leur motif.',
        entreprise: 'Journal de l’entreprise',
        entrepriseAide: '30 dernières opérations de la plateforme, sans secret ni contenu métier.',
        abonnement: 'Historique d’abonnement',
        aucun: 'Rien n’est encore enregistré.',
        aucunAbonnement: 'Aucun changement enregistré.',
        consultation: 'Consultation administrative',
        sansMotif: 'Sans motif écrit',
      },
      invitation: {
        titre: 'Inviter une personne',
        usage: 'Le destinataire choisira son mot de passe et activera son compte. Cette invitation doit être demandée par l’entreprise.',
        etapePersonne: 'Personne invitée',
        etapePersonneAide: 'L’e-mail est facultatif : sans lui, remettez le lien vous-même.',
        nom: 'Nom complet',
        email: 'E-mail du destinataire',
        identifiant: 'Identifiant de connexion',
        monAdresse: 'Utiliser mon adresse administrateur',
        etapeRole: 'Rôle dans l’entreprise',
        role: 'Rôle',
        roleAide: {
          dispatcher: 'Planning, clients et ventes.',
          technicien: 'Interventions sur le terrain.',
          patron: 'Tous les droits de l’entreprise.',
        },
        attestation: 'Demande de l’entreprise',
        demandee: 'L’entreprise a demandé cette invitation et le rôle indiqué.',
        manqueIdentite: 'Saisissez le nom et un identifiant (3 à 40 minuscules, chiffres, point, tiret).',
        manqueDemande: 'Confirmez que l’entreprise a demandé cette invitation.',
        pret: 'Invitation en tant que {role}, lien valable 7 jours.',
        action: 'Créer et envoyer l’invitation',
        faite: 'Invitation créée',
        lien: 'Invitation créée. Le lien expire dans 7 jours ; l’e-mail est en file d’envoi s’il est renseigné.',
      },
      membre: {
        kicker: 'Compte de l’entreprise',
        usage: 'Accès, récupération et dépannage du compte. Aucun mot de passe ni secret n’est lisible.',
        compte: 'Compte',
        role: 'Rôle',
        terrain: 'Terrain',
        identifiant: 'Identifiant',
        identifiantAide: 'Minuscules, chiffres, point, tiret ou soulignement (3 à 40).',
        email: 'Adresse e-mail',
        emailAide: 'Une nouvelle adresse reste à confirmer par son titulaire ; l’ancienne est prévenue.',
        telephone: 'Téléphone',
        telephoneAide: 'Utilisé pour les SMS d’alerte d’abonnement du patron.',
        nom: 'Nom complet',
        etat: 'Accès',
        doubleAuth: 'Double authentification',
        mfaAReconfigurer: 'Authentificateur à reconfigurer',
        renouveler: 'Renouveler le lien',
        recuperation: 'Créer un lien de récupération',
        reactiver: 'Réactiver',
        modifierIdentite: 'Modifier l’identité du compte',
        mfa: 'Réinitialiser l’authentificateur perdu',
        sessions: 'Fermer toutes les sessions',
        suspendre: 'Suspendre l’accès',
        retirer: 'Retirer l’accès',
        motif: 'Identité vérifiée, instruction du client et motif',
        lienTitre: 'Lien à remettre',
        lienRecuperation: 'Lien créé, valable une heure. L’e-mail a été mis en file si le compte possède une adresse. La double authentification reste conservée.',
        lienInvitation: 'Nouveau lien créé. L’ancien lien a été invalidé. L’e-mail, s’il existe, est en file d’envoi.',
        fait: 'Modification confirmée.',
        securite: 'Sessions et évènements de sécurité',
        securiteAide: 'Utiles au dépannage, sans suivi des activités métier : jusqu’à 25 sessions et 20 évènements.',
        sessionsActives: 'Sessions actives',
        evenements: 'Évènements de sécurité',
        mobile: 'Application mobile',
        navigateur: 'Navigateur',
        connecteLe: 'Connexion le {date}',
        aucuneSession: 'Aucune session active.',
        identiteTitre: 'Identité du compte',
        identiteUsage: 'Nom, identifiant, e-mail et téléphone, sur instruction de l’entreprise.',
        identiteEtape: 'Identité',
        identiteFaite: {
          none: 'Identité du compte enregistrée.',
          verification: 'Enregistré. Un lien de confirmation part vers la nouvelle adresse ; l’ancienne est prévenue.',
          invitation: 'Enregistré. L’invitation repart vers la nouvelle adresse.',
        },
        confirmer: {
          password: {
            titre: 'Créer un lien de récupération ?',
            texte: 'Le destinataire choisira son nouveau mot de passe. Le lien est à usage unique, expire dans une heure et conserve la double authentification.',
            action: 'Créer le lien',
          },
          reissue: {
            titre: 'Renouveler cette invitation ?',
            texte: 'Tous les anciens liens d’activation seront invalidés. Un nouveau lien sera préparé et l’e-mail mis en file d’envoi s’il est renseigné.',
            action: 'Renouveler l’invitation',
          },
          mfa: {
            titre: 'Réinitialiser cet authentificateur ?',
            texte: 'L’appli de codes, les clés d’accès (Face ID, empreinte), le code par e-mail, les sessions et accès hors ligne seront invalidés. La personne devra se reconnecter avec son mot de passe et configurer un nouvel authentificateur.',
            action: 'Réinitialiser la double authentification',
          },
          sessions: {
            titre: 'Fermer toutes les sessions de ce compte ?',
            texte: 'Le compte reste actif ; ses sessions, jetons et autorisations hors ligne seront révoqués. Une nouvelle connexion sera nécessaire.',
            action: 'Fermer les sessions',
          },
          suspend: {
            titre: 'Suspendre l’accès de {nom} ?',
            texte: 'Les sessions et le hors-ligne seront révoqués. Les interventions futures planifiées seront désaffectées. Les preuves et documents restent conservés.',
            action: 'Suspendre l’accès',
          },
          revoke: {
            titre: 'Retirer l’accès de {nom} ?',
            texte: 'Retrait définitif : le compte ne pourra plus se connecter, son identifiant et son adresse sont libérés. Les sessions et le hors-ligne seront révoqués, les interventions futures désaffectées. Les preuves et documents restent conservés. S’il revient, une nouvelle invitation sera nécessaire.',
            action: 'Retirer l’accès',
          },
          reactivate: {
            titre: 'Réactiver l’accès de {nom} ?',
            texte: 'Le compte pourra de nouveau se connecter avec ses droits existants.',
            action: 'Réactiver',
          },
        },
      },
      assistance: {
        titre: 'Assistance des entreprises',
        usage: {
          demandes: 'Écrites depuis « Aide et contact ». Chaque demande est une conversation ; l’auteur est prévenu de chaque réponse.',
          tickets: 'Conservez la demande de l’entreprise dans un ticket, puis ouvrez un accès temporaire. Clôturer le ticket ferme ses sessions.',
          sessions: 'Une session permet de consulter l’application du client pour son assistance. Fermez-la dès la fin de votre intervention.',
        },
        nouveauTicket: 'Créer un ticket d’assistance',
        demandes: 'Demandes',
        tickets: 'Tickets',
        sessions: 'Accès temporaires',
        rechercherDemande: 'Titre, entreprise ou numéro',
        rechercherTicket: 'Rechercher un ticket ou une entreprise',
        demandesAffichees: 'Demandes affichées',
        filtres: {
          a_traiter: 'À traiter',
          attente_client: 'En attente de l’entreprise',
          resolue: 'Résolues',
          all: 'Toutes',
        },
        etatTickets: 'État des tickets',
        filtresTickets: { ouvert: 'Ouverts', resolu: 'Résolus', all: 'Tous' },
        aucuneDemande: 'Aucune demande pour ce filtre.',
        aucunTicket: 'Aucun ticket pour ce filtre.',
        aucuneSession: 'Aucune session.',
        ligneDemande: 'N° {numero} · {entreprise} · {sujet}',
        ligneDemandeDetail: '{sujet} · {n} message(s) · dernier {date}',
        nonLue: 'Non lue',
        sessionsAffichees: 'Sessions affichées',
        enCours: 'En cours',
        historique: 'Historique',
        terminee: 'Terminée',
        ecriture: 'écriture autorisée',
        lecture: 'lecture seule',
        ligneSession: '{admin} · {mode} · expire le {date}',
        fermer: 'Fermer cette session',
        fermerTitre: 'Fermer cette session d’assistance ?',
        fermerTexte: 'Son accès temporaire sera révoqué. Le ticket et les traces restent conservés.',
      },
      demande: {
        kicker: 'Demande d’une entreprise',
        numero: 'Demande n° {numero}',
        membre: 'Membre de l’entreprise',
        assistance: 'Assistance',
        prendre: 'Prendre en charge',
        repondre: 'Répondre',
        repondreResoudre: 'Répondre et marquer résolue',
        prevenu: 'L’auteur est prévenu et lit la réponse dans « Aide et contact ».',
        contexte: 'Contexte de la demande',
        entreprise: 'Entreprise',
        auteur: 'Auteur',
        sujet: 'Sujet',
        ecritDepuis: 'Écrit depuis',
        application: 'Application',
        envoyee: 'Envoyée',
        conversation: 'Conversation',
        priseEnCharge: 'Prise en charge{qui}',
        par: 'par {nom}',
        closeEntreprise: 'Close par l’entreprise',
        resolue: 'Marquée résolue',
        reponse: 'Votre réponse',
        reponseLibelle: 'Réponse à l’entreprise',
        reponseAide: '{n} / {max} caractères.',
        etats: {
          nouvelle: 'Nouvelle',
          prise_en_charge: 'À traiter',
          attente_client: 'En attente de l’entreprise',
          resolue: 'Résolue',
          autre: 'En cours',
        },
        sujets: {
          question: 'Question',
          probleme: 'Problème',
          idee: 'Idée',
          compte: 'Compte ou équipe',
          facturation: 'Abonnement',
          autre: 'Autre sujet',
        },
      },
      ticket: {
        kicker: 'Ticket d’assistance',
        usage: 'Décrivez la demande reçue et sa référence. Le patron est notifié. N’inscrivez aucun mot de passe ni secret.',
        etapeEntreprise: 'Entreprise',
        rechercher: 'Rechercher l’entreprise',
        entreprise: 'Entreprise du ticket',
        etapeDemande: 'Demande',
        etapeDemandeAide: 'Quelques mots suffisent.',
        objet: 'Objet de la demande',
        demande: 'Demande et instruction du client',
        demandeAide: 'Limite : 2 000 caractères.',
        manqueEntreprise: 'Choisissez l’entreprise.',
        manqueObjet: 'L’objet compte 5 caractères au moins.',
        manqueDemande: 'La demande compte 10 caractères au moins.',
        pret: 'Le patron sera notifié de l’ouverture du ticket.',
        action: 'Créer le ticket et notifier le patron',
        cree: 'Ticket créé, le patron est notifié.',
        reference: 'Réf. {ref}',
        etats: { ouvert: 'Ouvert', resolu: 'Résolu' },
        demandeTitre: 'Demande',
        ouvertLe: 'Ouvert le',
        clotureLe: 'Clôturé le',
        entrepriseTitre: 'Entreprise concernée',
        voirFiche: 'Ouvrir la fiche entreprise',
        ouvrirAssistance: 'Ouvrir l’assistance de ce ticket',
        cloturer: 'Clôturer le ticket',
        cloturerTitre: 'Clôturer ce ticket d’assistance ?',
        cloturerTexte: 'Le ticket sera conservé dans l’historique. Toutes ses sessions d’assistance seront fermées immédiatement.',
        resolution: 'Résolution et motif de clôture',
      },
      session: {
        etapeDelegation: 'Compte de délégation',
        etapeDelegationAide: 'La session utilise les droits métier de ce patron. Le journal d’audit attribue vos actions à votre compte administrateur.',
        delegation: 'Compte de délégation',
        aucunPatron: 'Aucun patron actif : une session d’assistance ne peut pas être ouverte.',
        manqueDelegation: 'Choisissez le compte de délégation.',
        manqueMotif: 'Écrivez le motif (5 caractères au moins).',
        etapeCadre: 'Cadre de l’assistance',
        duree: 'Durée de l’assistance',
        durees: { 15: '15 minutes', 30: '30 minutes', 60: '1 heure' },
        ecritureAide: 'Lecture seule par défaut. Les accès personnels et les rôles restent protégés.',
        pret: 'Session de {duree}, {mode}. Le patron est notifié.',
      },
      taches: {
        usage: 'E-mails, documents et synchronisations sont traités automatiquement. Une tâche « à réessayer » attend sa prochaine tentative ; seul un échec définitif se rejoue ici.',
        compte: '{attente} en attente · {essais} nouvelles tentatives prévues · {echecs} échecs à examiner',
        traitement: 'Le service de traitement exécute les tâches en arrière-plan.',
        dejaRejouee: 'Déjà rejouée',
        rejouerTitre: 'Rejouer {tache} ?',
        rejouerTexte: 'Une nouvelle tâche liée sera mise en file pour {pour}. L’historique d’exécution reste conservé.',
        rejouerIntegration: 'Elle écrit chez {integration} : vérifiez d’abord que l’échec n’a rien laissé de l’autre côté.',
      },
      outils: {
        titre: 'Outils avancés',
        usage: 'Réglages techniques et registres. L’assistance quotidienne reste dans Entreprises et Assistance.',
        tous: 'Tous les outils',
        journal: 'Journal de la plateforme',
        versions: 'Versions et déploiements',
        documents: 'Documents et acceptations',
        noms: 'Noms réservés',
      },
      journal: {
        usage: 'Chaque geste de la console qui touche la plateforme ou une entreprise, avec son motif. Rien ne s’y modifie ni ne s’y efface.',
      },
      versions: {
        usage: 'Versions minimales des applications et activations progressives préparées dans le code.',
        applications: 'Versions des applications',
        applicationsAide: 'Une version sous le minimum affiche « Mise à jour requise ».',
        aucune: 'Aucune version publiée.',
        minimum: 'Minimum accepté : {version}',
        grace: 'Délai jusqu’au {date}',
        blocage: 'Blocage de sécurité',
        plateformes: { android: 'Android', ios: 'iOS', web: 'Web' },
        drapeauxAide: 'Réservé aux changements techniques préparés dans le code.',
        etapes: {
          internal: 'Interne',
          pilot: 'Pilote',
          progressive: 'Progressif',
          global: 'Général',
          rolled_back: 'Retiré',
        },
        publication: 'Les publications se font par l’API d’exploitation, avec votre identité revérifiée et un motif : elles sont tracées au journal de la plateforme.',
      },
      noms: {
        usage: 'Aucun nom d’utilisateur ni nom d’entreprise ne peut reprendre ces termes, même déguisés (majuscules, accents, tirets, chiffres à la place des lettres).',
        ajouter: 'Réserver un nom',
        ajouterUsage: '« Dans le nom » bloque tout nom qui contient le terme ; sinon seul le nom exact est bloqué.',
        ajouts: 'Ajouts de l’administration',
        aucun: 'Aucun terme ajouté.',
        base: 'Liste de base ({n} termes, fixée dans le code)',
        baseAide: 'Ces termes ne se retirent pas depuis la console.',
        dansLeNom: '{terme} (dans le nom)',
        retirer: 'Retirer',
        retirerTitre: 'Retirer « {terme} » des noms réservés ?',
        retirerTexte: 'Un nouveau compte ou une nouvelle entreprise pourra de nouveau porter ce nom.',
        etape: 'Terme',
        terme: 'Terme à réserver',
        regle: 'Règle',
        contient: 'Dans le nom',
        contientAide: 'Bloquer s’il apparaît dans le nom.',
        exact: 'Nom exact',
        exactAide: 'Bloquer seulement le nom exact.',
        raison: 'Raison (facultatif)',
        manque: 'Saisissez un terme de 2 caractères au moins.',
        pret: 'Le terme s’applique dès l’enregistrement.',
        reserver: 'Réserver',
        ajoute: '« {terme} » est réservé.',
      },
      documents: {
        usage: 'Le site public se modifie dans les fichiers du projet. Ce registre archive les versions validées et suit leur acceptation.',
        ajouter: 'Ajouter un document',
        ajouterUsage: 'Enregistré comme brouillon : la publication se confirme ensuite depuis la liste.',
        aucun: 'Aucun document publié : aucune acceptation n’est exigée.',
        ligne: '{type} · version {version}',
        demo: 'Exemple de démonstration, non validé',
        verifier: 'Vérifier',
        publier: 'Publier',
        publierTitre: 'Publier ce document ?',
        publierTexte: 'La version publiée actuelle du même type sera archivée. Les nouvelles invitations devront accepter « {titre} ».',
        motif: 'Motif et validation obtenue',
        types: { terms: 'Conditions d’utilisation', privacy: 'Politique de confidentialité' },
        avertissement: 'Cet écran enregistre une version et son empreinte ; il ne remplace pas la validation d’un professionnel du droit.',
        etapeIdentite: 'Document',
        type: 'Type',
        version: 'Version',
        titreDocument: 'Titre',
        etapeTexte: 'Texte exact',
        etapeTexteAide: 'Le texte publié est conservé sans modification.',
        url: 'URL publique HTTPS',
        texte: 'Texte exact à archiver',
        texteAide: 'Son empreinte SHA-256 est calculée sur cet appareil et revérifiée par le serveur.',
        empreinte: 'Empreinte SHA-256',
        manqueIdentite: 'Saisissez la version et le titre.',
        manqueUrl: 'L’adresse publique commence par https://.',
        manqueTexte: 'Collez le texte exact à archiver.',
        pret: 'Enregistré comme brouillon, sans effet tant qu’il n’est pas publié.',
        enregistrer: 'Enregistrer comme brouillon',
        enregistre: 'Brouillon enregistré.',
      },
      roles: {
        patron: 'Patron',
        dispatcher: 'Bureau / planning',
        technicien: 'Technicien terrain',
        autre: 'Membre',
      },
      metiers: {
        refrigeration: 'Réfrigération',
        other: 'Autre activité',
        unconfigured: 'Non configurée',
      },
      activites: {
        admin_company_inspected: 'Fiche entreprise consultée',
        admin_company_updated: 'Identité de l’entreprise modifiée',
        user_invited: 'Invitation créée',
        user_activation_link_reissued: 'Invitation renouvelée',
        admin_member_status_changed: 'Accès d’un membre modifié',
        admin_member_security_inspected: 'Sécurité du compte consultée',
        admin_member_mfa_reset: 'Authentificateur réinitialisé',
        admin_member_sessions_revoked: 'Sessions du compte fermées',
        admin_member_profile_updated: 'Identité d’un compte modifiée',
        user_password_reset_link_issued: 'Lien de récupération préparé',
        support_ended_by_owner: 'Assistance terminée par le patron',
        support_ticket_created: 'Ticket d’assistance ouvert',
        support_ticket_resolved: 'Ticket d’assistance clôturé',
        impersonation_started: 'Session d’assistance ouverte',
        impersonation_ended: 'Session d’assistance fermée',
        company_created: 'Entreprise créée',
        company_offboarded: 'Entreprise retirée',
        subscription_transitioned: 'Abonnement modifié',
        job_replayed: 'Tâche rejouée',
        feature_flag_created: 'Déploiement progressif créé',
        feature_flag_updated: 'Déploiement progressif modifié',
        feature_flag_rolled_out: 'Étape de déploiement changée',
        app_version_published: 'Version d’application publiée',
        legal_document_created: 'Document juridique enregistré',
        legal_document_published: 'Document juridique publié',
        reserved_name_added: 'Nom réservé ajouté',
        reserved_name_removed: 'Nom réservé retiré',
        orphan_customers_toggled: 'Clients d’un artisan parti : réglage changé',
        autre: 'Opération d’administration',
      },
      evenements: {
        auth_login: 'Connexion',
        auth_mfa_activated: 'Authentificateur configuré',
        auth_device_trusted: 'Appareil de confiance ajouté',
        auth_device_trust_revoked: 'Appareil de confiance oublié',
        auth_step_up: 'Identité confirmée',
        user_password_reset: 'Mot de passe renouvelé',
        user_password_reset_link_issued: 'Lien de récupération préparé',
        admin_member_mfa_reset: 'Authentificateur réinitialisé',
        admin_member_sessions_revoked: 'Sessions fermées',
        admin_member_status_changed: 'Accès modifié',
        user_invited: 'Invitation créée',
        autre: 'Évènement de sécurité',
      },
    },
  },
  rgpd: {
    titre: 'Données personnelles',
    faireDemande: 'Faire une demande RGPD',
    typeDemande: 'Type de demande',
    acces: 'Accès / export',
    correction: 'Correction',
    suppression: 'Suppression',
    // Traitement par l'entreprise (Mon entreprise › Données personnelles, API1-12).
    traitement: {
      kicker: 'Demande RGPD',
      onglets: { aTraiter: 'À traiter', traitees: 'Traitées' },
      ongletsLabel: 'Demandes RGPD',
      videATraiter: 'Aucune demande à traiter.',
      videTraitees: 'Aucune demande traitée pour l’instant.',
      types: {
        acces_export: 'Accès à ses données',
        correction: 'Correction de ses données',
        suppression: 'Suppression de ses données',
      },
      recueLe: 'Reçue le {date}',
      dueLe: 'réponse avant le {date}',
      enRetard: 'En retard',
      retard: 'La réponse était due le {date} : répondez au plus vite.',
      echeance: 'Répondez avant le {date} (un mois après la réception).',
      demande: 'Demande',
      type: 'Type',
      email: 'E-mail',
      recue: 'Reçue le',
      due: 'Réponse due le',
      precisions: 'Précisions',
      traitementTitre: 'Traitement',
      identiteVerifiee: 'Identité vérifiée le',
      traitePar: 'Traitée par',
      reponseEnvoyee: 'Réponse envoyée le',
      note: 'Réponse et ce qui a été fait',
      exceptions: 'Conservé et pourquoi',
      etapes: {
        identite: 'Vérifiez que la demande vient bien de la personne (même adresse e-mail que sa fiche, ou pièce d’identité).',
        acces: 'Préparez l’export de ses données, téléchargez-le et envoyez-le-lui, puis répondez.',
        correction: 'Corrigez ses données dans ses fiches, puis répondez en disant ce qui a été corrigé.',
        suppression: 'Supprimez ou anonymisez ses données dans ses fiches, puis répondez en disant ce qui est conservé et pourquoi (factures 10 ans…).',
        cloturer: 'La réponse est partie : clôturez la demande.',
      },
      identiteOk: 'Identité vérifiée',
      identiteAVerifier: 'Identité à vérifier',
      refuser: 'Refuser la demande',
      cloturer: 'Clôturer la demande',
      repondre: 'Répondre : demande exécutée',
      preparerExport: 'Préparer l’export',
      telechargerExport: 'Télécharger l’export',
      exportEnCours: 'Export en préparation : la page se met à jour toute seule.',
      exportPret: 'Export prêt : téléchargez-le pour l’envoyer à la personne.',
      exportEchec: 'La préparation de l’export a échoué : relancez-la.',
      reponse: 'Votre réponse',
      reponseAide: 'Envoyée telle quelle à la personne par e-mail.',
      noteManquante: 'Décrivez ce qui a été fait.',
      exceptionsAide: 'Envoyé aussi à la personne : ce que la loi oblige à garder (factures 10 ans, CERFA…), ou « Aucune ».',
      exceptionsManquantes: 'Indiquez ce qui est conservé, ou « Aucune ».',
      confirmerReponse: 'Envoyer la réponse ?',
      consequenceReponse: 'La personne reçoit un e-mail disant que sa demande est exécutée. Ce n’est plus modifiable ensuite.',
      confirmerRefus: 'Refuser cette demande ?',
      consequenceRefus: 'La personne reçoit un e-mail avec votre motif. Ce n’est plus modifiable ensuite.',
      motifRefus: 'Motif du refus (envoyé à la personne)',
      envoyer: 'Envoyer la réponse',
      refusEnvoye: 'Refus envoyé à la personne.',
      reponseEnvoyeeOk: 'Réponse envoyée à la personne.',
      cloturee: 'Demande clôturée.',
      introuvable: 'Demande introuvable',
      retour: 'Données personnelles',
    },
  },
  unites: {
    unite: 'unité',
    kg: 'kg',
    litre: 'L',
    metre: 'm',
  },
  symptomes: {
    temperature_haute: 'Température trop haute',
    temperature_basse: 'Température trop basse',
    bruit_anormal: 'Bruit anormal',
    fuite_eau: 'Fuite d’eau',
    givre_important: 'Givre important',
    arret_complet: 'Arrêt complet',
    alarme_affichee: 'Alarme affichée',
    autre: 'Autre problème',
  },
  articles: {
    categories: {
      piece: 'Pièce détachée',
      machine: 'Machine',
      gaz_fluide: 'Fluide frigorigène',
      consommable: 'Consommable',
    },
  },
  emplacements: {
    depot: 'Dépôt',
    vehicule: 'Véhicule',
    quarantaine: 'Zone de contrôle',
  },
  contrats: {
    titre: 'Contrats de maintenance',
    prestations: {
      main_oeuvre: 'Main-d’œuvre',
      deplacement: 'Déplacement',
      pieces: 'Pièces',
      fluides: 'Fluides',
      urgences: 'Urgences',
    },
    modes: {
      inclus: 'Inclus',
      plafonne: 'Plafonné',
      facturable: 'Facturable en plus',
    },
    renouvellementManuel: 'Le renouvellement est manuel : aucune reconduction automatique.',
    version: 'Version {n}',
    plafond: 'plafond {montant}',
    // Facturation récurrente (décision 10 du 19/10/2026, lot BIL-6) : des brouillons à valider.
    facturation: {
      periodes: {
        mensuel: 'Chaque mois',
        trimestriel: 'Chaque trimestre',
        annuel: 'Chaque année',
      },
      termes: {
        a_echoir: 'À échoir',
        terme_echu: 'Terme échu',
      },
      termesAide: {
        a_echoir: 'Facture au début de chaque période.',
        terme_echu: 'Facture le lendemain de la fin de chaque période.',
      },
      aucune: 'Pas de facture automatique',
      libelle: 'Facturation du contrat',
      terme: 'Moment de la facture',
      aide: 'Un brouillon de facture est préparé à chaque période ; il reste à vérifier et à émettre.',
      sansPrix: 'Indiquez le prix annuel pour que les factures se préparent.',
      ligne: 'Contrat de maintenance « {label} »',
      lignePeriode: 'Période du {debut} au {fin}',
      lignePeriodeProrata: 'Période du {debut} au {fin}, au prorata de la fin du contrat',
      lignePeriodeReste: 'Période du {debut} au {fin}, au prorata (reste non encore facturé)',
      notification: 'Facture du contrat « {label} » à vérifier ({montant} HT)',
    },
    // Refonte v4 du 17/10/2026 : contrats complets, propositions rangées sous Contrats.
    liste: {
      usage: 'Les visites d’entretien promises à vos clients, et les propositions qui les préparent.',
      usagePropositions: 'Des simulations de prix à une ou deux visites d’entretien par an, à transformer en contrat ou en devis.',
      nouveau: 'Nouveau contrat',
      nouvelleProposition: 'Nouvelle proposition',
      baremes: 'Barèmes de maintenance',
      recherche: 'Client, contrat, site, ville…',
      rechercheLibelle: 'Chercher un contrat',
      recherchePropositions: 'Client ou titre…',
      compte: '{n} contrat(s)',
      comptePropositions: '{n} proposition(s)',
      ongletsAria: 'États des contrats',
      onglets: {
        tous: 'Tous',
        brouillon: 'Brouillons',
        actif: 'Actifs',
        en_pause: 'Suspendus',
        a_renouveler: 'À renouveler',
        termine: 'Terminés',
        resilie: 'Résiliés',
        propositions: 'Propositions',
      },
      aides: {
        tous: 'Chaque contrat ouvre sa fiche : ce qu’il couvre, ses visites d’entretien, son PDF.',
        brouillon: 'Rien n’est planifié : complétez-les, faites-les signer, puis activez-les.',
        actif: 'Les visites d’entretien se planifient seules dans la fenêtre prévue.',
        en_pause: 'Aucune visite d’entretien n’est générée tant que le contrat est suspendu.',
        a_renouveler: 'Le renouvellement est manuel : renouvelez ou terminez chacun.',
        termine: 'Arrivés à échéance sans renouvellement ; leur historique reste.',
        resilie: 'Arrêtés avant leur fin ; leur historique reste.',
        propositions: 'Une proposition mène à un contrat ou à un devis.',
      },
      vides: {
        tous: 'Aucun contrat pour l’instant.',
        brouillon: 'Aucun brouillon.',
        actif: 'Aucun contrat actif.',
        en_pause: 'Aucun contrat suspendu.',
        a_renouveler: 'Aucun contrat à renouveler.',
        termine: 'Aucun contrat terminé.',
        resilie: 'Aucun contrat résilié.',
        propositions: 'Aucune proposition enregistrée.',
      },
      videCreer: 'Créez le premier avec « Nouveau contrat ».',
      videCreerProposition: 'Créez la première avec « Nouvelle proposition ».',
      aucunResultat: 'Rien ne correspond à cette recherche.',
      duClient: 'Contrats de {client}',
      tousClients: 'Tous les clients',
      tousLesMois: 'Tous les {n} mois',
      unParAn: 'Une visite d’entretien par an',
      prochaineVisite: 'prochaine visite d’entretien le {date}',
      aucuneVisite: 'aucune visite d’entretien prévue',
      parAnCourt: 'par an',
      deuxPassages: '2 visites d’entretien par an : {montant}',
      unPassage: '1 visite d’entretien par an',
      contratCree: 'Contrat créé',
      devisPrepare: 'Devis préparé',
    },
    prochaineEtape: {
      brouillon: 'À activer une fois signé par le client',
      actif: 'En cours : les visites d’entretien se planifient seules',
      en_pause: 'Suspendu : aucune visite d’entretien n’est générée',
      a_renouveler: 'Arrive à échéance : à renouveler',
      termine: 'Terminé',
      resilie: 'Résilié',
    },
    fiche: {
      kicker: 'Contrat de maintenance',
      introuvable: 'Ce contrat est introuvable.',
      essentiel: 'L’essentiel',
      client: 'Client',
      rythme: 'Rythme',
      fenetre: 'Rendez-vous fixé dans une fenêtre de {n} jours',
      periode: 'Période',
      depuis: 'Depuis le {date}',
      jusquau: 'jusqu’au {date}',
      sansFin: 'sans date de fin',
      prix: 'Prix annuel',
      prixHt: '{montant} HT',
      prochaineVisite: 'Prochaine visite d’entretien',
      pasPlanifiee: 'Pas encore planifiée',
      visitePlanifiee: 'Le {date}',
      planifierVisite: 'Planifier la visite d’entretien',
      planifierVisiteAide: 'Visite d’entretien du contrat : son client et son site sont repris ; choisissez la date et qui intervient.',
      facturation: 'Facturation',
      facturationValeur: '{periode}, {terme}',
      facturationAucune: 'Pas de facture automatique',
      prochaineFacture: 'Prochaine facture le {date} ({montant} HT)',
      facturationFinie: 'Toutes les périodes sont passées.',
      facturesPreparees: 'Factures préparées',
      facturesPrepareesAide: 'Une facture par période, préparée en brouillon puis émise par le bureau.',
      periodeFacture: 'Du {debut} au {fin}',
      factureSupprimee: 'Brouillon supprimé',
      rentabilite: 'Rentabilité',
      rentabiliteAide: 'Ce que le contrat a rapporté et coûté jusqu’ici, hors taxes.',
      rentabilitePrix: 'Prix annuel',
      rentabiliteForfait: 'Forfait facturé',
      rentabiliteHorsForfait: 'Facturé hors forfait',
      rentabilitePieces: 'Coût des pièces posées',
      rentabilitePiecesInconnues: '{n} pièce(s) sans prix d’achat, non comptée(s)',
      rentabiliteTravail: 'Temps de travail',
      rentabiliteTrajet: 'Temps de trajet',
      rentabiliteVisites: 'Interventions clôturées',
      rentabiliteMainOeuvre: 'La main-d’œuvre n’est pas chiffrée : seuls les temps sont donnés.',
      delais: 'Délais garantis',
      delaiPrise: 'Dépannage commencé sous {duree}',
      delaiResolution: 'terminé sous {duree}',
      delaisAide: 'Comptés depuis la demande du client.',
      proposition: 'Issu de la proposition',
      notes: 'Notes',
      nonRenseigne: 'Non renseigné',
      compris: 'Ce qui est compris',
      comprisAide: 'Inclus, plafonné ou facturé en plus, prestation par prestation.',
      aucunCompris: 'Aucune prestation comprise : tout est facturé à part.',
      machines: 'Machines entretenues',
      machinesAide: 'Le contrat porte sur ces machines précises.',
      marqueInconnue: 'Marque non renseignée',
      numero: 'n° {numero}',
      visites: 'Visites d’entretien',
      visitesAide: 'Placées seules dans la fenêtre prévue, puis confirmées par le client.',
      visitesBrouillon: 'Les visites d’entretien seront planifiées à l’activation.',
      aucuneVisite: 'Aucune visite d’entretien planifiée pour le moment.',
      laProchaine: 'Prochaine visite d’entretien',
      fenetreVisite: 'Du {debut} au {fin}',
      versions: 'Versions et avenants',
      versionsAide: 'La version signée ne change plus : un avenant en crée une nouvelle.',
      signee: 'Signée le {date}',
      avenantDu: 'Avenant du {date}',
      // Actions, de la plus courante à la plus rare.
      activer: 'Activer',
      modifier: 'Modifier',
      reprendre: 'Reprendre le contrat',
      renouveler: 'Renouveler',
      voirPdf: 'Voir le PDF',
      avenant: 'Faire un avenant',
      suspendre: 'Suspendre',
      resilier: 'Résilier',
      terminer: 'Terminer',
      supprimer: 'Supprimer le brouillon',
      prochaine: {
        brouillon: 'Faire signer, puis activer',
        brouillonAide: 'Une fois activé, la version est figée (les changements passeront par un avenant) et les visites d’entretien se planifient.',
        a_renouveler: 'Renouveler ou terminer',
        a_renouvelerAide: 'Rien n’est reconduit tout seul : renouvelez pour continuer les visites d’entretien, ou terminez le contrat.',
        en_pause: 'Contrat suspendu',
        en_pauseAide: 'Aucune visite d’entretien n’est générée. Reprenez-le quand la situation est réglée.',
      },
      confirmer: {
        activerTitre: 'Activer ce contrat ?',
        activer: 'Confirmez que le client a signé. La version actuelle est figée et les prochaines visites d’entretien sont planifiées automatiquement.',
        activerBouton: 'Activer',
        reprendreTitre: 'Reprendre ce contrat ?',
        reprendre: 'Les prochaines visites d’entretien seront générées. Les rendez-vous annulés auparavant ne sont pas restaurés.',
        reprendreBouton: 'Reprendre le contrat',
        renouvelerTitre: 'Renouveler ce contrat ?',
        renouveler: 'Le contrat redevient actif : ses prochaines visites d’entretien seront planifiées. Faites un avenant si le prix ou la fin changent.',
        renouvelerBouton: 'Renouveler',
        suspendreTitre: 'Suspendre ce contrat ?',
        suspendreBouton: 'Suspendre le contrat',
        suspendreMotif: 'Motif de la suspension',
        resilierTitre: 'Résilier ce contrat ?',
        resilierBouton: 'Résilier le contrat',
        resilierMotif: 'Motif de la résiliation',
        resilierPhrase: 'RÉSILIER',
        terminerTitre: 'Terminer ce contrat ?',
        terminerBouton: 'Terminer le contrat',
        terminerMotif: 'Motif (non renouvelé, client parti…)',
        impact: 'Les éléments futurs seront annulés, l’historique reste intact.',
        impactVisites: '{n} visite(s) d’entretien à venir',
        impactInterventions: '{n} intervention(s) planifiée(s)',
        impactReservations: '{n} réservation(s) de stock',
        impactCalcul: 'Calcul de l’impact…',
        termeEchuNonPrepare: 'Facturé à terme échu : la période en cours ne sera pas préparée. Facturez à la main ce qui a déjà été assuré.',
        definitif: 'C’est définitif : un contrat résilié ne reprend pas.',
        supprimerTitre: 'Supprimer ce brouillon ?',
        supprimer: 'Le brouillon disparaît de la liste. Rien n’a été signé ni planifié.',
        supprimerBouton: 'Supprimer le brouillon',
      },
      fait: {
        activer: 'Contrat activé : la version signée est figée et les prochaines visites d’entretien sont en cours de planification.',
        en_pause: 'Contrat suspendu : les éléments futurs sont annulés, l’historique est conservé.',
        actif: 'Contrat repris : les prochaines visites d’entretien vont être générées.',
        renouveler: 'Contrat renouvelé : les prochaines visites d’entretien seront planifiées.',
        resilie: 'Contrat résilié : les éléments futurs sont annulés, l’historique est conservé.',
        termine: 'Contrat terminé : les éléments futurs sont annulés, l’historique est conservé.',
        supprime: 'Brouillon supprimé.',
        cree: 'Contrat créé en brouillon. Activez-le dès que le client l’a signé.',
        modifie: 'Brouillon enregistré.',
        avenant: 'Avenant enregistré : version {n}.',
      },
      pdfTitre: 'Contrat {label}',
      pdfPreparation: 'Le serveur met le contrat en page, quelques secondes.',
    },
    saisie: {
      titreNouveau: 'Nouveau contrat de maintenance',
      titreModifier: 'Modifier le brouillon',
      titreProposition: 'Contrat depuis la proposition',
      usage: 'Le contrat est créé en brouillon : rien n’est planifié avant que vous l’activiez.',
      usageModifier: 'Tant qu’il n’est pas activé, tout se corrige ; ensuite, ce sera par un avenant.',
      usageProposition: 'Le client et le prix viennent de la proposition ; choisissez le site et les machines.',
      etapeClient: 'Client',
      etapeChantier: 'Site',
      etapeChantierAide: 'Un contrat couvre un site du client.',
      aucunChantier: 'Ce client n’a aucun site. Ajoutez-en un depuis sa fiche.',
      etapeMachines: 'Machines entretenues',
      etapeMachinesAide: 'Un contrat porte toujours sur des machines précises.',
      machinesLibelle: 'Machines couvertes',
      aucuneMachine: 'Aucune machine n’est enregistrée sur ce site. Ajoutez-la d’abord depuis la fiche client.',
      toutCocher: 'Tout cocher',
      toutDecocher: 'Tout décocher',
      etapeVisites: 'Visites d’entretien et durée',
      formule: 'Formule de la proposition',
      formuleUn: '1 visite d’entretien par an',
      formuleDeux: '2 visites d’entretien par an',
      conseil: 'Le catalogue de machines conseille {n} visite(s) d’entretien par an ({machines}) : une tous les {mois} mois.',
      conseilDuree: 'Environ {duree} sur place.',
      appliquerConseil: 'Appliquer le rythme conseillé',
      rythme: 'Rythme des visites d’entretien',
      rythmeMois: 'Une visite d’entretien tous les {n} mois',
      rythmeAn: 'Une visite d’entretien par an',
      rythmeMensuel: 'Une visite d’entretien par mois',
      fenetre: 'Souplesse pour fixer le rendez-vous',
      fenetreJours: '{n} jours',
      fenetreAide: 'MyEquip propose chaque visite d’entretien dans cette fenêtre, pour regrouper les déplacements.',
      debut: 'Début du contrat',
      duree: 'Durée',
      dureeSansFin: 'Sans date de fin',
      dureeAns: '{n} an(s)',
      dureeAutre: 'Choisir la date de fin',
      fin: 'Fin du contrat',
      etapePrix: 'Nom, prix et facturation',
      nom: 'Nom du contrat',
      nomAuto: 'Entretien — {site}',
      prix: 'Prix annuel HT (€, facultatif)',
      prixExemple: 'Ex. : 1 200',
      prixProposition: 'Prix de la proposition : {montant} ({base}).',
      notes: 'Notes (facultatif)',
      etapeCompris: 'Ce qui est compris dans le prix',
      etapeComprisAide: 'Pour chaque prestation : incluse, incluse jusqu’à un plafond, ou facturée en plus.',
      modeInclus: 'Inclus',
      modePlafonne: 'Plafond',
      modeFacture: 'En plus',
      plafond: 'Plafond {prestation} (€ HT)',
      // Délais garantis (Q69) : ce qu'un dépannage du site doit tenir, compté depuis la demande.
      etapeDelais: 'Délais garantis (facultatif)',
      etapeDelaisAide: 'En cas de panne sur ce site : les délais promis au client, comptés depuis sa demande. MyEquip prévient avant l’échéance.',
      delaiPriseEnCharge: 'Dépannage commencé sous (heures)',
      delaiResolution: 'Dépannage terminé sous (heures)',
      delaiExemple: 'Ex. : 4',
      manque: {
        client: 'Choisissez le client.',
        chantier: 'Choisissez le site.',
        machines: 'Cochez au moins une machine entretenue.',
        nom: 'Donnez un nom au contrat.',
        prix: 'Le prix annuel est mal saisi.',
        plafond: 'Indiquez le montant de chaque plafond.',
        periode: 'La fin du contrat précède son début.',
        delai: 'Un délai garanti est mal saisi : un nombre d’heures, un an au plus.',
        copie: 'Reprenez ou ignorez la saisie précédente.',
        rien: 'Aucun changement à enregistrer.',
      },
      pret: 'Le contrat sera créé en brouillon.',
      pretModifier: 'Le brouillon sera mis à jour.',
      creer: 'Créer le contrat',
      enregistrer: 'Enregistrer le brouillon',
      enregistrement: 'Enregistrement du contrat',
      conflitTitre: 'Ce brouillon a changé entre-temps',
      conflit: 'Quelqu’un l’a modifié pendant votre saisie. Rechargez-le : votre saisie reste sur cet appareil et se reprend.',
      recharger: 'Recharger',
      nonModifiable: 'Ce contrat est activé : il se modifie par un avenant.',
      dejaConverti: 'Cette proposition a déjà donné un contrat.',
      ouvrirContrat: 'Ouvrir le contrat',
    },
    avenant: {
      titre: 'Faire un avenant',
      usage: 'La version signée reste la référence ; l’avenant crée une nouvelle version, avec son motif.',
      etapeChanges: 'Ce qui change',
      etapeChangesAide: 'Ne touchez qu’à ce qui change ; le reste est repris tel quel.',
      etapeMachines: 'Machines et prestations',
      etapeMotif: 'Motif',
      motif: 'Pourquoi cet avenant ?',
      motifAide: 'Il est gardé avec la nouvelle version (ajout d’une machine, nouveau prix…).',
      pret: 'Version {n} à l’enregistrement.',
      enregistrer: 'Enregistrer l’avenant',
      enregistrement: 'Enregistrement de l’avenant',
      manque: {
        rien: 'Indiquez au moins un changement.',
        motif: 'Indiquez le motif de l’avenant (3 caractères au moins).',
      },
      impossible: 'Un avenant se fait sur un contrat actif ou suspendu.',
    },
    propositions: {
      kicker: 'Proposition de maintenance',
      titreNouvelle: 'Proposer un contrat de maintenance',
      titreModifier: 'Modifier la proposition',
      usage: 'Choisissez les prestations et le nombre de visites d’entretien par an, puis remettez la proposition au client.',
      introuvable: 'Cette proposition est introuvable.',
      formules: 'Tarifs proposés',
      passagesParAn: '{n} visites d’entretien par an',
      nombrePassages: 'Nombre de visites d’entretien par an',
      passagesAide: 'Saisissez le nombre prévu pour ce client, de 1 à 365.',
      comparerPassages: 'Autre nombre de visites d’entretien à comparer (facultatif)',
      comparerAide: 'Laissez vide pour proposer un seul rythme.',
      avantRemise: '{montant} avant remise',
      remise: 'Remise de {taux} %',
      prestations: 'Prestations comptées',
      parPassage: 'par visite d’entretien',
      uneFois: 'une seule fois',
      bareme: 'Barème',
      base: { ht: 'Prix HT', ttc: 'Prix TTC', unspecified: 'Base à confirmer' },
      suite: 'Suite donnée',
      contratDe: 'Contrat « {label} »',
      devisNumero: 'Devis {numero}',
      // Actions
      creerContrat: 'Créer le contrat',
      preparerDevis: 'Préparer le devis',
      modifier: 'Modifier',
      imprimer: 'Imprimer',
      supprimer: 'Supprimer la proposition',
      supprimerTitre: 'Supprimer cette proposition ?',
      supprimerConsequence: 'Elle disparaît de la liste. Elle n’a mené à aucun contrat ni devis.',
      supprimee: 'Proposition supprimée.',
      enregistree: 'Proposition enregistrée.',
      devisTitre: 'Préparer le devis',
      devisUsage: 'Un brouillon de devis reprend les prestations de la formule choisie ; vous le relisez avant de l’envoyer.',
      devisFormule: 'Formule du devis',
      devisCreer: 'Créer le brouillon de devis',
      devisImpossible: 'Le barème de cette proposition ne dit pas si ses prix sont HT ou TTC, ni leur TVA : préparez le devis dans l’éditeur.',
      devisIntro: '{titre} — {formule}.',
      // Éditeur à étapes
      etapeClient: 'Client',
      etapeBareme: 'Barème',
      etapeBaremeAide: 'Les prix viennent d’un barème de votre entreprise.',
      baremeConseille: 'Conseillé par le catalogue : {machines}',
      baremeLignes: '{n} ligne(s) · {base}',
      aucunBareme: 'Aucun barème de maintenance. Créez-en un dans Mon entreprise → Barèmes, ou demandez-le au responsable.',
      baremeChange: 'Ce barème a changé depuis (version {n}). La proposition garde ses tarifs ; les actualiser remet les quantités à zéro.',
      actualiser: 'Actualiser les tarifs',
      tarifsGardes: 'Tarifs enregistrés avec cette proposition. Choisir un barème les remplace et remet les quantités à zéro.',
      etapePrestations: 'Prestations',
      etapePrestationsAide: 'Comptez ce que comprend une visite d’entretien chez ce client.',
      etapeFormules: 'Visites d’entretien et prix',
      tauxRemise: 'Taux de remise — {formule} (%)',
      titreProposition: 'Titre de la proposition',
      titreDefaut: 'Proposition de contrat de maintenance',
      manque: {
        client: 'Choisissez le client.',
        bareme: 'Choisissez un barème.',
        prestation: 'Comptez au moins une prestation.',
        titre: 'Donnez un titre à la proposition.',
        remise: 'Les remises vont de 0 à 100 %.',
        passages: 'Indiquez un nombre entier de visites d’entretien entre 1 et 365.',
        copie: 'Reprenez ou ignorez la saisie précédente.',
      },
      pret: '{un} pour 1 visite d’entretien · {deux} pour 2 visites d’entretien',
      enregistrer: 'Enregistrer la proposition',
      enregistrement: 'Enregistrement de la proposition',
      retirer: 'Retirer une unité : {libelle}',
      ajouter: 'Ajouter une unité : {libelle}',
      simulation: 'Simulation · {base} · conditions à confirmer avant émission du devis.',
      baseAConfirmer: 'TVA et base des prix à confirmer',
    },
    // Finitions de la vague 3 (18/10/2026) : prix réservés (Q82), proposition convertie figée.
    etapeNom: 'Nom du contrat',
    propositionFigee: 'Cette proposition a déjà mené à un contrat ou à un devis : elle ne se modifie plus.',
    voirProposition: 'Voir la proposition',
  },
  bouteilles: {
    kinds: { charge: 'Charge', recuperation: 'Récupération' },
  },
  // Clients et machines, refonte v4 (17/10/2026) : liste, fiche en onglets, saisies.
  clients: {
    titre: 'Clients',
    gestion: {
      repertoire: 'Répertoire du téléphone',
      fusionner: 'Fusionner avec un autre client',
      fusionTitre: 'Fusionner deux clients',
      supprimerContact: 'Supprimer le contact',
      fusionFaite: 'Clients fusionnés. Leur historique est réuni dans cette fiche.',
      anciennesFiches: 'Anciennes fiches réunies',
    },
    usage: 'Vos clients, leurs sites et leurs machines.',
    nouveau: 'Nouveau client',
    rechercher: 'Nom, téléphone, ville…',
    rechercheLibelle: 'Rechercher un client',
    compte: '{n} client(s)',
    aucun: 'Aucun client pour l’instant.',
    aucunResultat: 'Aucun client ne correspond à ces critères.',
    sansCoordonnees: 'Sans e-mail ni téléphone',
    sansEmail: '{contact} · sans e-mail',
    sansTelephone: '{contact} · sans téléphone',
    nbSites: '{n} sites',
    filtres: {
      afficher: 'Afficher',
      tous: 'Tous les clients',
      professionnels: 'Professionnels',
      particuliers: 'Particuliers',
      ajoutes: 'Ajoutés depuis',
      toujours: 'Toujours',
      semaine: '7 jours',
      mois: '30 jours',
    },
    menu: {
      importer: 'Importer mes contacts',
      importerFichier: 'Importer un fichier Excel ou CSV',
      etiquettes: 'Gérer les étiquettes',
      carte: 'Voir les sites sur la carte',
      liste: 'Voir la liste des clients',
    },
    carteUsage: 'Les sites de vos clients, placés sur la carte.',
    carte: {
      libelle: 'Carte des sites clients',
      places: 'Sites sur la carte',
      sansPosition: 'Sites sans position',
      sansPositionAide: 'Un site se place tout seul quand son adresse est trouvée. Ouvrez-en un pour corriger son adresse ou relever sa position sur place.',
      sansPositionLecture: 'Ces sites n’ont pas encore de position enregistrée.',
      adresseIntrouvable: '{adresse} · adresse introuvable',
      ouvrirFiche: 'Ouvrir la fiche client',
      aucunSite: 'Aucun site à afficher',
      aucunSiteAide: 'Les sites de vos clients apparaîtront ici.',
      aucunSitePlace: 'Aucun site placé sur la carte',
      placement: 'Un site se place tout seul quand son adresse est trouvée, ou quand sa position est relevée sur place.',
      indisponible: 'Cet appareil ne peut pas afficher la carte. Les sites restent listés ci-dessous.',
      zoomPlus: 'Rapprocher la carte',
      zoomMoins: 'Éloigner la carte',
      fond: 'Fond de carte',
      contributeurs: '© les contributeurs d’OpenStreetMap',
    },
    nature: { professionnel: 'Professionnel', particulier: 'Particulier' },
    fiche: {
      ecrire: 'Écrire à {nom}',
      kicker: 'Client',
      introuvable: 'Ce client est introuvable.',
      onglets: 'Rubriques de la fiche client',
      apercu: 'Aperçu',
      apercuUsage: 'Qui joindre, où intervenir et comment facturer.',
      machines: 'Machines',
      machinesUsage: 'Les machines suivies chez ce client, site par site.',
      interventions: 'Interventions',
      interventionsUsage: 'Les interventions passées et à venir chez ce client.',
      ventes: 'Ventes',
      ventesUsage: 'Ses devis et ses factures.',
      nouvelleIntervention: 'Nouvelle intervention',
      modifier: 'Modifier la fiche',
      nouveauDevis: 'Nouveau devis',
      ajouterPhoto: 'Ajouter une photo',
      remplacerPhoto: 'Remplacer la photo',
      photoEnvoi: 'Envoi de la photo…',
      photoAnalyse: 'Photo en cours d’analyse antivirus…',
      photoRefusee: 'Photo refusée par l’analyse antivirus.',
      photoAnalyseImpossible: 'Analyse antivirus impossible : renvoyez la photo.',
      photoGoogle: 'Établissement identifié via Google Places{source}.',
      ficheGoogle: 'Voir la fiche Google',
      doublons: 'Fiches en double',
      doublonsTitre: 'Fiche en double ?',
      doublonsAide: 'Ces fiches partagent une coordonnée avec celle-ci. Ouvrez-les pour comparer.',
      differents: 'Ce sont deux clients différents',
      archiver: 'Archiver le client',
      archiverTitre: 'Archiver « {nom} » ?',
      archiverConsequence: 'Le client disparaît de la liste, de la recherche et des nouvelles saisies. Ses interventions, devis et factures restent consultables. L’archivage ne se défait pas depuis l’application.',
      archive: '« {nom} » est archivé.',
      manqueTout: 'Ni e-mail ni téléphone : ce client ne peut recevoir ni devis ni facture depuis MyEquip, ni être prévenu rapidement.',
      manqueEmail: 'Pas d’e-mail : devis et factures ne partent pas depuis MyEquip et le client n’a pas accès à son espace.',
      manqueTelephone: 'Pas de téléphone : impossible de le joindre vite par SMS ou par appel.',
      completer: 'Compléter',
      contacts: 'Contacts',
      ajouterContact: 'Ajouter un contact',
      aucunContact: 'Aucun contact enregistré.',
      appeler: 'Appeler {nom}',
      actionsContact: 'Actions sur {nom}',
      supprimerContact: 'Supprimer le contact',
      supprimerContactTitre: 'Supprimer {nom} ?',
      supprimerContactConsequence: 'Il quitte les contacts du client et ses accès au portail client sont fermés tout de suite. Les documents déjà envoyés restent dans l’historique.',
      supprimerContactConfirmer: 'Supprimer',
      sites: 'Sites',
      ajouterSite: 'Ajouter un site',
      aucunSite: 'Aucun site : ajoutez-en un pour y planifier une intervention.',
      surPlace: 'Sur place : {nom}',
      itineraire: 'Itinéraire',
      itineraireVers: 'Itinéraire vers {site}',
      planifierIci: 'Planifier ici',
      photos: 'Photos du site',
      historiqueSite: 'Historique de ce site',
      modifierSite: 'Modifier le site',
      facturation: 'Facturation',
      nature: 'Type de client',
      siret: 'SIRET',
      adresseFacturation: 'Adresse de facturation',
      pays: 'Pays',
      tva: 'N° de TVA intracommunautaire',
      regime: 'TVA de ses devis et factures',
      tvaNormale: 'TVA normale',
      autoliquidee: 'Autoliquidée — {regime}',
      nonRenseigne: 'Non renseigné',
      notes: 'Notes',
      ajouter: 'Ajouter',
      ajouterMachineSur: 'Ajouter une machine sur {site}',
      machinesDe: 'Machines de {site}',
      aucuneMachine: 'Aucune machine sur ce site.',
      aucunSiteMachines: 'Aucun site : ajoutez un site pour y rattacher des machines.',
      sansNumero: 'Sans n° de série',
      fluideControle: '{fluide} · prochain contrôle le {date}',
    },
    ventes: {
      devis: 'Devis',
      factures: 'Factures',
      aucunDevis: 'Aucun devis pour ce client.',
      aucuneFacture: 'Aucune facture pour ce client.',
      derniers: 'Les {n} derniers devis.',
      dernieres: 'Les {n} dernières factures.',
      brouillon: 'Brouillon',
      emisLe: 'émis le {date}',
      emiseLe: 'émise le {date}',
      valableJusquau: 'valable jusqu’au {date}',
      echeance: 'échéance le {date}',
      ttc: 'TTC',
      resteDu: 'reste dû',
    },
    etiquettes: {
      titre: 'Étiquettes',
      pageTitre: 'Étiquettes de clients',
      pageUsage: 'Vos propres mots pour classer vos clients (« Sous contrat », « Syndic », « À rappeler »…) et les retrouver dans la liste. Elles restent dans votre entreprise.',
      vos: 'Vos étiquettes',
      nouvelle: 'Nouvelle étiquette',
      exemple: 'Ex. Sous contrat',
      longueur: '{n} caractères au plus.',
      tropLong: 'Ce nom dépasse {n} caractères.',
      complet: 'Vous avez atteint {n} étiquettes : supprimez-en une pour en créer une autre.',
      creer: 'Créer l’étiquette',
      enregistrement: 'Enregistrement…',
      lectureSeule: 'Votre rôle permet de voir les étiquettes, pas de les modifier.',
      aucune: 'Aucune étiquette pour l’instant',
      aucuneAide: 'Créez-en une, puis attribuez-la depuis la fiche d’un client.',
      aucunClient: 'Aucun client',
      renommer: 'Renommer',
      renommerTitre: 'Renommer « {nom} »',
      nom: 'Nom de l’étiquette',
      supprimer: 'Supprimer',
      supprimerTitre: 'Supprimer l’étiquette « {nom} » ?',
      supprimerPortee: 'Elle sera retirée de {clients}. Les clients eux-mêmes ne sont pas supprimés.',
      supprimerLibre: 'Aucun client ne la porte.',
      choisir: 'Choisir',
      choisirTitre: 'Étiquettes de ce client',
      choisirAide: 'Chaque case s’enregistre tout de suite.',
      etiquettesDuClient: 'Étiquettes du client',
      aucunePosee: 'Aucune étiquette sur ce client.',
      maximum: '{n} étiquettes au plus par client.',
      gerer: 'Gérer les étiquettes',
      termine: 'Terminé',
    },
    modifier: {
      titre: 'Modifier la fiche',
      usage: 'Identité, coordonnées, facturation et notes du client.',
      enregistrer: 'Enregistrer la fiche',
      enregistrement: 'Enregistrement de la fiche client',
      enregistre: 'Fiche enregistrée.',
      rienAChanger: 'Modifiez une information pour enregistrer.',
      copieAReprendre: 'Reprenez ou ignorez la saisie précédente.',
      conflitTitre: 'Fiche modifiée entre-temps',
      conflit: 'Quelqu’un a modifié cette fiche pendant votre saisie : rien n’a été écrasé. Rechargez-la, puis reprenez votre saisie gardée sur cet appareil.',
      recharger: 'Recharger la fiche',
      etapeClient: 'Le client',
      raisonSociale: 'Nom / raison sociale',
      nomComplet: 'Nom complet',
      siret: 'SIRET (facultatif)',
      siretAide: '14 chiffres',
      etapeJoindre: 'Comment le joindre ?',
      etapeJoindreAide: 'Pour envoyer devis et factures, ouvrir son espace client et le prévenir rapidement.',
      contactPrincipal: 'Contact principal',
      contactFacultatif: 'Contact (facultatif)',
      tvaAide: 'Exigé sur une facture en autoliquidation.',
      adresseFacturationAide: 'Exigée pour émettre une facture : rue, code postal et ville ; hors de France, finissez par le pays (« , BE »).',
      tvaDepuisSiret: 'Calculer depuis le SIRET : {tva}',
      autoliquidationEffet: 'Ses documents seront sans TVA, avec la mention légale ; chacun peut changer de régime.',
      autoliquidationTva: 'Une facture en autoliquidation exige le n° de TVA du client.',
      etapeNotes: 'Notes (facultatives)',
      notesAide: 'Accès, habitudes, consignes : visibles par votre équipe.',
    },
  },
  contacts: {
    roles: {
      // Valeur technique conservée : c'est le contact principal du client, pas un
      // administrateur de la plateforme (décision du 11 octobre 2026).
      administrateur: 'Contact principal',
      technique: 'Technique',
      facturation: 'Facturation',
    },
  },
  equipements: {
    ajouterEvenementPasse: 'Noter un événement passé',
    categories: {
      chambre_froide: 'Chambre froide',
      vitrine_refrigeree: 'Vitrine réfrigérée',
      groupe_frigorifique: 'Groupe frigorifique',
      climatisation: 'Climatisation',
      pompe_a_chaleur: 'Pompe à chaleur',
      meuble_frigorifique: 'Meuble frigorifique',
      centrale_froid: 'Centrale de froid',
      autre: 'Autre machine',
    },
    numeroSerie: 'N° de série',
    historique: 'Historique',
    // Fiche machine, refonte v4 (17/10/2026).
    fiche: {
      kicker: 'Machine',
      introuvable: 'Cette machine est introuvable.',
      // Réseau absent : fiche lue sur l'appareil ; notices non gardées (WEB1-08).
      horsLigne: 'Hors ligne : fiche gardée sur cet appareil. Carnet, notices et QR code reviennent avec le réseau.',
      nouvelleIntervention: 'Nouvelle intervention',
      noterEvenement: 'Noter un événement',
      noter: 'Noter',
      modifier: 'Modifier la machine',
      voirQr: 'Voir le QR code',
      regenererQr: 'Régénérer le QR code',
      regenererTitre: 'Régénérer le QR code ?',
      regenererConsequence: 'L’ancien QR code cesse de fonctionner tout de suite : l’étiquette collée sur la machine ne mènera plus nulle part. Il faudra imprimer et coller la nouvelle, et transmettre le nouveau lien si besoin.',
      regenererConfirmer: 'Régénérer et invalider l’ancien',
      cycle: {
        arreter: 'Mettre à l’arrêt',
        remettre: 'Remettre en service',
        deplacer: 'Déplacer vers un autre site',
        demanteler: 'Démanteler la machine',
        archiver: 'Archiver la machine',
        titreArret: 'Mettre la machine à l’arrêt',
        titreService: 'Remettre la machine en service',
        titreDemantelement: 'Démanteler la machine',
        titreArchivage: 'Archiver la machine',
        titreDeplacement: 'Déplacer la machine',
        aideArret: 'La machine reste dans la fiche du client, marquée « À l’arrêt ». Vous pourrez la remettre en service.',
        aideService: 'La machine repasse « En service » pour les interventions et les contrôles.',
        aideDemantelement: 'Définitif : la machine est retirée du site et ne change plus d’état. Elle reste dans l’historique du client. Si elle contient encore du fluide, faites d’abord signer la fiche CERFA de récupération ; sinon, expliquez par écrit pourquoi.',
        aideArchivage: 'La machine disparaît des listes, du planning et de l’étiquette QR. Son historique reste conservé.',
        aideDeplacement: 'Le QR code collé sur la machine reste valable. Seuls les autres sites de ce client sont proposés.',
        motif: 'Motif',
        motifFacultatif: 'Motif (facultatif)',
        motifAide: 'Gardé dans l’historique de la machine et dans le journal.',
        site: 'Nouveau site',
        aucunAutreSite: 'Ce client n’a pas d’autre site. Ajoutez d’abord un site à sa fiche.',
        motifCourt: 'Indiquez le motif (3 caractères au moins).',
        choisirSite: 'Choisissez le nouveau site.',
        prete: 'Prêt à enregistrer',
        enregistre: 'Machine mise à jour.',
        deplacee: 'Machine déplacée.',
        archivee: 'Machine archivée.',
      },
      qrRegenere: 'Le nouveau QR code est actif. L’ancienne étiquette ne fonctionne plus : imprimez la nouvelle.',
      qrTitre: 'QR code de la machine',
      qrUsage: 'La page publique qu’il ouvre permet de déclarer une panne. Le suivi reçu après l’envoi se limite aux étapes, au créneau et à l’heure d’arrivée : ni position ni dossier machine.',
      qrAlt: 'QR code : {url}',
      commeLeClient: 'Voir comme le client',
      identite: 'La machine',
      site: 'Site',
      miseEnService: 'Mise en service',
      garantie: 'Garantie jusqu’au',
      notes: 'Notes',
      fluide: 'Fluide frigorigène',
      fluideType: 'Fluide',
      charge: 'Charge',
      prg: 'PRG (GWP)',
      dernierControle: 'Dernier contrôle d’étanchéité',
      aucunControle: 'Aucun enregistré',
      nonPrevu: 'Non prévu',
      periodicites: {
        reglementaire: 'Obligatoire tous les {n} mois',
        saisie: 'Tous les {n} mois (intervalle saisi)',
        sous_seuil: 'Sous les seuils : pas de contrôle obligatoire',
        hors_champ: 'Fluide non fluoré : pas de contrôle obligatoire',
        a_verifier: 'À vérifier : tous les {n} mois par prudence',
      },
      intervalleAide: 'Facultatif. Sans saisie, la périodicité réglementaire s’applique ; une saisie ne peut que la raccourcir.',
      controleDepasse: 'Le contrôle d’étanchéité est en retard : planifiez-le.',
      controleBientot: 'Le prochain contrôle d’étanchéité arrive dans moins d’un mois.',
      detection: 'Détection permanente des fuites',
      oui: 'Oui',
      non: 'Non',
      historiqueUsage: 'Les interventions faites avec MyEquip s’y ajoutent toutes seules : ouvrez-en une pour son dossier complet.',
      aucuneIntervention: 'Aucune intervention avec MyEquip sur cette machine.',
      evenements: 'Relevés et événements notés',
      systeme: 'Système',
      signale: 'signalé',
      memeSite: 'Autres machines de ce site',
      memeSiteAide: 'Toutes les machines de {site}, sans scanner chaque QR code.',
    },
    notices: {
      titre: 'Notices',
      aide: 'Notices et schémas réservés à votre équipe ; les anciennes versions restent consultables.',
      ajouter: 'Ajouter',
      ajouterNotice: 'Ajouter une notice',
      nouvelle: 'Nouvelle notice',
      aucune: 'Aucune notice liée à cette machine.',
      versionInconnue: 'Version non précisée',
      ancienne: 'ancienne version',
      analyse: 'analyse antivirus en cours',
      refusee: 'refusée par l’antivirus',
      analyseImpossible: 'analyse antivirus impossible : renvoyez la notice',
      fabricant: 'Page du fabricant',
      chargement: 'Ouverture de la notice, quelques secondes.',
    },
    assistant: {
      titre: 'Assistant technique',
      aide: 'Les notices choisies et votre question sont transmises à Claude, l’assistant d’Anthropic. Vérifiez la référence et les sources avant d’appliquer une procédure.',
      indisponible: 'L’assistant est indisponible tant que MyEquip n’a pas configuré son accès à Claude.',
      notices: 'Notices à interroger (3 au plus)',
      historique: 'Inclure l’historique de la machine',
      historiqueAide: 'Pour chercher une panne : dernières interventions, pièces changées et événements de la fiche, sans données du client.',
      referencesHistorique: 'Dans l’historique',
      historiqueVerifier: 'Extrait repris de l’historique de la machine.',
      question: 'Votre question sur les notices',
      poser: 'Poser la question',
      fabricant: 'Recherche chez le fabricant',
      fabricantAide: 'Elle utilise la marque, le modèle et ce thème, sans votre question ni les données du site.',
      rechercher: 'Rechercher chez le fabricant',
      encours: 'Recherche en cours…',
      reponse: 'Réponse de l’assistant',
      sourcesInsuffisantes: 'Sources insuffisantes : cette réponse reste à vérifier.',
      autreModele: 'La notice concerne un autre modèle : vérifiez sa compatibilité.',
      references: 'Extraits cités',
      aVerifier: 'Extrait repris de la notice : vérifiez-le dans le PDF avant d’agir.',
      source: 'Source : {titre}',
    },
    videos: {
      titre: 'Vidéos',
      aide: 'Les démonstrations et consignes de cette machine, à ouvrir sur YouTube.',
      ajouter: 'Ajouter une vidéo',
      aucune: 'Aucune vidéo pour cette machine.',
      regarder: 'Voir sur YouTube',
      regarderTitre: 'Voir « {titre} » sur YouTube',
      retirer: 'Retirer la vidéo',
      retirerQuestion: 'Retirer cette vidéo ?',
      retirerAide: 'Le lien sera retiré de la documentation de cette machine. La vidéo restera sur YouTube.',
      lien: 'Le lien YouTube',
      url: 'Adresse de la vidéo',
      urlInvalide: 'Choisissez un lien vidéo YouTube en https://.',
      titreVideo: 'Titre de la vidéo',
      titreRequis: 'Donnez un titre à la vidéo.',
      reprise: 'Reprenez ou ignorez la saisie précédente.',
      confidentialite: 'Une vidéo non répertoriée est visible par toute personne qui possède son lien. YouTube s’ouvre seulement quand vous choisissez de la regarder.',
      ajoutee: 'Vidéo ajoutée à la documentation.',
      ajouterCourt: 'Ajouter',
    },
  },
  accueil: {
    tableauDeBord: 'Tableau de bord',
    interventionsDuJour: 'Interventions du jour',
    impayes: 'Impayés',
    sansIntervention: 'Sans intervention aujourd’hui',
    maintenant: 'Maintenant',
    ensuite: 'Ensuite',
    continuer: 'Continuer',
    aucuneInterventionAujourdhui: 'Aucune intervention aujourd’hui',
    journeeVideRassurante:
      'Rien de prévu pour l’instant. Vous serez prévenu à la moindre affectation.',
    voirLePlanning: 'Voir le planning',
    toutVaBien: 'Rien ne demande votre attention. Bonne journée.',
    prendreEnCharge: 'Prendre en charge',
    // Accueil unique (17/10/2026)
    aTraiter: 'À traiter',
    aTraiterEnPremier: 'À traiter en premier',
    aujourdhui: 'Aujourd’hui',
    reperes: 'Repères',
    rienDUrgent: 'Rien d’urgent',
    journeeTerminee: 'Journée terminée',
    voirLEquipe: 'Voir l’équipe',
    devisEnAttente: 'Devis en attente',
    chiffreAffairesMois: 'Chiffre d’affaires du mois',
    resteSansUrgence: '{n} à traiter, sans urgence.',
    urgencesInfo: 'Une urgence frigorifique est en cours : l’équipe terrain et le bureau s’en occupent.',
    urgencesInfoPluriel: '{n} urgences frigorifiques sont en cours : l’équipe terrain et le bureau s’en occupent.',
  },
  // Envois en attente (WEB1-21, 20/10/2026) : la file de l'appareil, lisible hors ligne.
  synchronisation: {
    titre: 'Envois en attente',
    description: 'Ce que cet appareil n’a pas encore envoyé, avec son état. Rien ne part sans vous en informer.',
    envoyer: 'Envoyer maintenant',
    envoi: 'Envoi…',
    reessayer: 'Réessayer',
    ouvrir: 'Ouvrir',
    retirer: 'Retirer de l’appareil',
    retirerTitre: 'Retirer cet envoi refusé ?',
    retirerConsequence:
      'Le serveur l’a refusé : il n’a rien enregistré. L’envoi quitte cet appareil ; refaites le geste si besoin.',
    retire: 'Envoi refusé retiré de l’appareil.',
    reessaye: 'Nouvel envoi demandé.',
    envoye: 'Envoi demandé : la liste se met à jour au fil des réponses.',
    horsLigne: 'Hors ligne : tout partira au retour du réseau.',
    refusesTitre: 'Refusés',
    refusesAide: 'Le serveur les a refusés : corrigez puis réessayez, ou retirez-les.',
    bureauTitre: 'En attente du bureau',
    bureauAide: 'La même donnée a changé au bureau : le bureau choisit la version à garder.',
    attenteTitre: 'À envoyer',
    attenteAide: 'Ils partent seuls dès que le réseau le permet, dans l’ordre où vous les avez faits.',
    videTitre: 'Tout est envoyé',
    vide: 'Rien n’attend sur cet appareil.',
    faitLe: 'Fait le {date}',
    etats: {
      attente: 'En attente du réseau',
      envoi: 'Envoi en cours',
      erreur: 'Échec passager : nouvel essai automatique',
      erreurA: 'Échec passager : nouvel essai à {heure}',
      refusee: 'Refusé : {motif}',
      refuseeSansMotif: 'Refusé par le serveur',
      conflit: 'En attente du bureau',
      conflitChamps: 'En attente du bureau : {champs}',
    },
    // Champs en conflit, dits dans la ligne de l'envoi (FLD-9).
    champs: {
      body: 'compte rendu',
      fault_detail: 'panne',
      fault_reported: 'panne',
      recommendations: 'recommandations',
      checklist_results: 'checklist',
      notes: 'notes',
    },
    genres: {
      cloture: 'Clôture de l’intervention',
      etape: 'Étape de l’intervention',
      intervention: 'Modification de l’intervention',
      rapport: 'Rapport d’intervention',
      note: 'Note du carnet',
      aPrevoir: 'Élément à prévoir',
      temps: 'Temps passé',
      urgence: 'Prise en charge d’une urgence',
      planning: 'Planning',
      client: 'Fiche client',
      machine: 'Historique de la machine',
      photo: 'Photo',
      fichier: 'Fichier',
      photoRapport: 'Photo du rapport',
      piece: 'Pièce posée',
      mesure: 'Mesure du rapport',
      signature: 'Signature du client',
      signatureImpossible: 'Signature impossible',
      mouvementFluide: 'Mouvement de bouteille',
      controleEtancheite: 'Contrôle d’étanchéité',
      cerfa: 'Fiche CERFA',
      signatureCerfa: 'Validation de la fiche CERFA',
      devis: 'Devis préparé sans réseau',
      message: 'Message',
      annonce: 'Prise de connaissance d’une annonce',
      autre: 'Autre envoi',
    },
  },
  // Mise en route de l'entreprise (18/10/2026) : carte de l'accueil pour qui règle l'entreprise.
  miseEnRoute: {
    titre: 'Mise en route',
    aide: 'Les réglages indispensables de votre entreprise. Rien n’est bloqué en attendant.',
    progression: '{fait} sur {total}',
    progressionAria: '{fait} réglages faits sur {total}',
    masquer: 'Masquer',
    fait: 'Fait',
    continuer: 'Continuer',
    toutFait: 'Tout est réglé pour le moment.',
    masquee: 'La mise en route est masquée pour votre compte.',
    masquerEchec: 'Impossible de masquer la mise en route pour le moment. Réessayez.',
    regler: 'Régler maintenant',
    etapes: {
      identite: { titre: 'Identité légale, SIRET et TVA', aide: 'Obligatoires sur vos factures et vos CERFA.' },
      metiers: { titre: 'Vos métiers', aide: 'Ils choisissent les pages et modules proposés.' },
      logo: { titre: 'Votre logo', aide: 'Sur vos devis, factures et rapports.' },
      banque: { titre: 'Coordonnées bancaires', aide: 'Pour « Comment régler » sur vos factures.' },
      horaires: { titre: 'Horaires habituels', aide: 'Le planning prévient en dehors de ces heures.' },
      roles: { titre: 'Vérifier les rôles', aide: 'Qui voit et fait quoi dans votre équipe.' },
      equipe: { titre: 'Inviter votre équipe', aide: 'Chacun avec son propre compte.' },
    },
  },
  analyses: {
    titre: 'Analyses',
    usage:
      'Les chiffres de l’entreprise sur la période choisie, comparés à la période précédente de même durée.',
    indicatif:
      'Heures déclarées par chacun : repères indicatifs, ni preuve d’heures travaillées ni base de paie.',
    nonCalcule: 'non calculé',
    lignes: {
      piece: 'Pièces',
      main_oeuvre: 'Main-d’œuvre',
      deplacement: 'Déplacement',
      consommable: 'Consommables',
      fluide: 'Fluides',
      forfait: 'Forfaits',
      remise: 'Remises',
      frais: 'Frais',
      avoir: 'Avoirs',
    },
    anciennete: {
      a_echoir: 'Pas encore échu',
      j1_30: 'En retard de 1 à 30 jours',
      j31_60: 'En retard de 31 à 60 jours',
      j61_90: 'En retard de 61 à 90 jours',
      j90_plus: 'En retard de plus de 90 jours',
    },
    devisTemps: {
      titre: 'Heures chiffrées et réalisées',
      aide: 'Main-d’œuvre des devis acceptés dont toutes les interventions liées sont clôturées ; la dernière clôture appartient à la période.',
      indicatif: 'Un écart aide à revoir le chiffrage avec l’équipe. Il ne démontre ni temps perdu ni faute individuelle. Les pauses et déplacements sont exclus ; le relevé vient des étapes terrain.',
      vide: 'Aucun devis accepté avec des interventions entièrement clôturées sur cette période.',
      limite: 'Seuls les 100 derniers devis sont analysés. Réduisez la période pour consulter les autres.',
      chiffre: 'Main-d’œuvre chiffrée',
      declare: 'Travail déclaré',
      observe: 'Travail relevé',
      ecart: 'Écart déclaré − chiffré',
      visites: '{n} intervention(s) liée(s)',
      comparable: 'Écart à vérifier avec l’équipe',
      partiel: 'relevé partiel, à vérifier',
      raisons: {
        ambiguous: 'Une intervention relève de plusieurs devis : temps non attribuable.',
        incomplete: 'Trop d’interventions ou d’étapes liées pour une comparaison fiable.',
        no_budget: 'Aucune durée fiable : main-d’œuvre sans unité de temps ou au forfait.',
        no_declared: 'Il manque un relevé déclaré sur au moins une intervention.',
      },
    },
  },
  aide: {
    patronAccueil:
      'Commencez par « Maintenant », puis « À traiter » : chaque ligne ouvre le dossier. « Aujourd’hui » montre l’équipe.',
    technicienJournee:
      'Votre journée fonctionne aussi sans réseau : rapports, photos et clôtures sont mis en file et envoyés automatiquement au retour de la connexion.',
    planningTournee:
      'Astuce : la vue Tournée permet de réaffecter une intervention en la glissant sur la colonne d’un autre technicien.',
  },
  maintenanceEmail: {
    titre: 'Envoyer la proposition',
    aide: 'Envoyez la proposition enregistrée en PDF, avec les rythmes et les prix choisis. Cette simulation ne crée ni contrat ni devis.',
    retour: 'Proposition de maintenance',
    envoyer: 'Envoyer par e-mail',
    proposition: 'La proposition',
    client: 'Client',
    unPassage: '1 visite d’entretien par an',
    deuxPassages: '2 visites d’entretien par an',
    base: 'Base à confirmer',
    destinataire: 'Destinataire',
    aucunContact: 'Aucun contact avec une adresse e-mail. Complétez la fiche client.',
    incertain: 'Un ancien envoi a un accusé incertain. Vérifiez sa réception avant de renvoyer.',
    verification: 'Avant un nouvel envoi',
    verifie: 'J’ai vérifié la réception du précédent envoi.',
    enFile: 'Envoi mis en file. L’historique indique sa remise au serveur d’envoi ou son échec.',
    historique: 'Historique des envois',
    aucunEnvoi: 'Aucun envoi pour cette proposition.',
    confirmation: 'Envoyer cette proposition ?',
    consequence: 'Le PDF de la proposition enregistrée sera envoyé à {email}.',
    etats: {queued:'En file',sending:'Envoi en cours',accepted:'Remis au serveur d’envoi',failed:'Échec de l’envoi',unknown:'Accusé incertain : à vérifier'},
  },
} as const;

export type MessageCatalog = typeof fr;
